import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import messages from '../../statics/messages.json';
import orderContext from '../../context/OrderContext';
import OrderDetails from './OrderDetails';
import countriesData from '../../statics/countries.json';
import shipmentData from '../../statics/shipmentsData.json';
import statuses from '../../statics/status.json';
import '../../Css/style.css';
import './Orders.css';
// Shared page-title wrapper styles (.order-validation-outer / .order-validation-page-title-wrap)
import './OrderValidation.css';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { getStatus, getShipmentMethods, getCountries, getCustomer, saveComment, syncOrders, saveLineStatus, updateOrderAccessLink, deleteComment, manageOrderUrl } from '../../context/CommonContex';
import { Value } from 'sass';
import * as XLSX from 'xlsx';
import { Modal, Button, Form } from 'react-bootstrap';
import Hover from '../Hover';
import OrderPopup from './OrderPopup';
import HoverPO from '../HoverPO';
import OrderStatusDropdown, { collectCustomOrderStatusTags, orderStatusMenuPosition } from "./OrderStatusDropdown";
import OrderRefresh from './OrderRefresh';
import FloatingRefreshButton from './FloatingRefreshButton';
import useAutoRefreshTimer, { AUTO_REFRESH_INTERVAL_SECONDS } from './useAutoRefreshTimer';
import InlineOrderDropdown from './InlineOrderDropdown';
import ColumnGroupsModal from '../Common/ColumnGroupsModal';
import OrderHistoryModal from '../orderHistory/OrderHistoryModal';
import AllOrdersHistoryModal from '../orderHistory/AllOrdersHistoryModal';
import OrderHistoryIconButton from '../orderHistory/OrderHistoryIconButton';
import { useOrderHistoryUnread, notifyOrderHistoryChanged } from '../orderHistory/useOrderHistoryUnread';
import { recordOrderAccessHistoryHint } from '../orderHistory/orderAccessHistoryHints';
import ColumnVisibilityModal from '../Common/ColumnVisibilityModal';
import ViewModeToggle from '../Common/ViewModeToggle';
import HeaderLineTabs, { LAYOUT_HEADER, LAYOUT_LINE, readLayoutView, saveLayoutView } from './HeaderLineTabs';
import OrderLineView from './OrderLineView';
import BomAvailabilityPill from './BomAvailabilityPill';
import {
    flattenOrdersToLines,
    headerLinesMissingDetails,
    collectOrderComments,
    findCommentLineId,
    findOrderLineById,
    orderLinesForHeader,
} from './orderLineRows';
import PresenceBar from '../Common/PresenceBar';
import CellPresence from '../Common/CellPresence';
import usePresence from '../../hooks/usePresence';
import useRowPresence from '../../hooks/useRowPresence';
import useFocusedCell from '../../hooks/useFocusedCell';
import { cellKey, mergeRowPresence } from '../../utils/presenceKeys';
import { extractCommentText, toStoredComment } from '../../utils/commentText';
import OrderCommentsButton from '../comments/OrderCommentsButton';
import StickyNotesCell from '../StickyNotes/StickyNotesCell';
import useStickyNotes from '../StickyNotes/useStickyNotes';
import useShippingInstructions from '../StickyNotes/useShippingInstructions';
import { useNotifications } from '../../context/NotificationsContext';
import { getCommentThreadKey, getOrderThreadKey, useCommentDock } from '../../context/CommentDockContext';
import {
    loadInlineDropdownModeFromPreference,
    loadViewModeDefault,
    saveViewModeDefault,
    isInlineViewMode,
} from '../../utils/viewModePreference';
import {
    DEFAULT_ORDERS_COLUMN_ORDER,
    NORMAL_GROUP_ID,
    ORDER_SET_GROUP_ID,
    ORDER_SET_MERGED_ID,
    ORDER_SET_SOURCE_IDS,
    COLUMN_LABELS,
    buildEffectiveColumnOrder,
    expandMergedColumnOrder,
    getEffectiveColumnOrder,
    getMergedIdForGroup,
    getSourceIdsForGroup,
    isMergedColumnId,
    loadColumnGroupsState,
    saveColumnGroupsState,
    sanitizeColumnOrder,
    loadColumnVisibility,
    saveColumnVisibility,
} from './ordersColumnConfig';
import {
    ORDERS_FILTER_STATE_STORAGE_KEY,
    loadOrdersFilterState,
    saveOrdersFilterState,
    clearOrdersFilterState,
    hasActiveOrdersFilter,
} from '../../utils/ordersFilterPersistence';

import editIcon from '../../statics/images/pencil.png'
import viewIcon from '../../statics/images/view.png'
import filterIcon from '../../statics/images/filter.png'
import excelIcon from '../../statics/images/excel.png'
import ScrollingText from '../ScrollingText';

// ---- Bridge Orders: draggable column reorder (Orders page only) ----
const ORDERS_COLUMN_ORDER_STORAGE_KEY = 'bridgeOrders.columnOrder.v1';

// Loads a saved column order from localStorage, dropping unknown ids and
// appending any newly-added columns so the layout survives schema changes.
function loadOrdersColumnOrder() {
    try {
        const saved = JSON.parse(localStorage.getItem(ORDERS_COLUMN_ORDER_STORAGE_KEY));
        if (Array.isArray(saved)) return sanitizeColumnOrder(saved);
    } catch (e) { /* ignore corrupt storage */ }
    return [...DEFAULT_ORDERS_COLUMN_ORDER];
}

/** Order date from Cetec `oorderdate` (YYYY-MM-DD). */
function getOrderedOnDate(line) {
    const raw = line?.order?.oorderdate || line?.oorderdate || '';
    if (!raw) return '-';
    const datePart = String(raw).trim().split(/[ T]/)[0];
    return datePart || '-';
}

/** Stacked label/value lines inside a merged table column. */
function CombinedColumnCell({ lines, className = 'orders-column-group-cell text-start' }) {
    const visibleLines = (lines || []).filter(
        (line) => line.show !== false && line.content != null && line.content !== ''
    );
    if (!visibleLines.length) {
        return <span className="text-muted">—</span>;
    }
    return (
        <div className={className}>
            {visibleLines.map((line, index) => (
                <div key={`${line.label}-${index}`} className="orders-column-group-line">
                    {line.label ? (
                        <span className="orders-column-group-label">{line.label}: </span>
                    ) : null}
                    <span
                        className={`orders-column-group-value${line.valueClassName ? ` ${line.valueClassName}` : ''}`}
                        style={line.valueStyle}
                    >
                        {line.content}
                    </span>
                </div>
            ))}
        </div>
    );
}

function getLineItemMismatchStyle(negativeCountStr) {
    const mismatch = negativeCountStr && negativeCountStr.includes('/')
        && parseInt(negativeCountStr.split('/')[0], 10) !== parseInt(negativeCountStr.split('/')[1], 10);
    if (!mismatch) return undefined;
    return {
        backgroundColor: '#e74c3c',
        color: 'white',
        fontWeight: 'bold',
        padding: '1px 4px',
        borderRadius: '2px',
        display: 'inline-block',
    };
}

// Reorders row cells to match `order`. Base children map to DEFAULT_ORDERS_COLUMN_ORDER;
// virtual merged columns are supplied via `mergedCells`.
function ReorderableCells({ order, draggable = false, dragHandlers, draggedColumnId, mergedCells = {}, columnVisibility = {}, onToggleColumn, isHeader = false, children }) {
    const cells = React.Children.toArray(children).filter(
        (child) => React.isValidElement(child) && (typeof child.type === 'string' || typeof child.type === 'function')
    );
    if (cells.length !== DEFAULT_ORDERS_COLUMN_ORDER.length) {
        return <>{cells}</>;
    }
    const byId = {};
    DEFAULT_ORDERS_COLUMN_ORDER.forEach((id, i) => { byId[id] = cells[i]; });
    const activeOrder = Array.isArray(order) && order.length ? order : DEFAULT_ORDERS_COLUMN_ORDER;
    const visibleCount = activeOrder.filter((cid) => columnVisibility[cid] !== false).length;
    return (
        <>
            {activeOrder.map((id) => {
                const cell = isMergedColumnId(id) ? mergedCells?.[id] : byId[id];
                if (!React.isValidElement(cell) || (typeof cell.type !== 'string' && typeof cell.type !== 'function')) {
                    return null;
                }
                // Hidden column: collapse to a thin vertical marker. The header segment is the
                // click target to restore it; body segments continue the divider. Column count is
                // preserved so colSpan / sticky headers / horizontal scroll are unaffected.
                if (columnVisibility[id] === false) {
                    if (isHeader) {
                        return (
                            <th
                                key={id}
                                className="gf-col-hidden-marker"
                                title="Show hidden column"
                                onClick={(e) => { e.stopPropagation(); onToggleColumn && onToggleColumn(id); }}
                            >
                                <span className="gf-col-hidden-bar" aria-label="Show hidden column"></span>
                            </th>
                        );
                    }
                    return (
                        <td key={id} className="gf-col-hidden-marker">
                            <span className="gf-col-hidden-bar"></span>
                        </td>
                    );
                }
                // Visible header cell: add a right-edge handle to hide the column (Excel-like).
                // It is absolutely positioned (width-independent) and stops propagation so the
                // column's sort click and drag-to-reorder keep working.
                let renderCell = cell;
                if (isHeader && onToggleColumn && visibleCount > 1) {
                    const edgeHandle = (
                        <span
                            key="gf-hide-edge"
                            className="gf-col-hide-edge"
                            role="button"
                            title="Hide column"
                            aria-label="Hide column"
                            draggable={false}
                            onMouseDown={(e) => e.stopPropagation()}
                            onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
                            onClick={(e) => { e.stopPropagation(); onToggleColumn(id); }}
                        ></span>
                    );
                    const existingChildren = React.Children.toArray(cell.props.children);
                    renderCell = React.cloneElement(
                        cell,
                        { style: { ...(cell.props.style || {}), position: 'relative' } },
                        ...existingChildren,
                        edgeHandle
                    );
                }
                if (!draggable || !dragHandlers) {
                    return React.cloneElement(renderCell, { key: id });
                }
                const isDragging = draggedColumnId === id;
                return React.cloneElement(renderCell, {
                    key: id,
                    draggable: true,
                    onDragStart: (e) => dragHandlers.onDragStart(e, id),
                    onDragOver: (e) => dragHandlers.onDragOver(e, id),
                    onDrop: (e) => dragHandlers.onDrop(e, id),
                    onDragEnd: dragHandlers.onDragEnd,
                    title: 'Drag to reorder column',
                    style: {
                        ...(renderCell.props.style || {}),
                        cursor: 'grab',
                        opacity: isDragging ? 0.4 : 1,
                    },
                });
            })}
        </>
    );
}

/**
 * Strips archived BOM parts out of freshly-fetched order lines so the order popup / inline order
 * dropdown never show them. Only call this on data just returned from orderFetch — NOT on state
 * that's being optimistically patched by the archive/unarchive action, since that action needs the
 * just-toggled part to stay visible (with its archived styling) until the next real refetch.
 */
function stripArchivedBomParts(orderLines) {
    if (!Array.isArray(orderLines)) return orderLines;
    return orderLines.map((item) => {
        const bomParts = item?.bom?.bomParts;
        if (!Array.isArray(bomParts)) return item;
        const filtered = bomParts.filter((b) => !b?.archived);
        if (filtered.length === bomParts.length) return item;
        return { ...item, bom: { ...item.bom, bomParts: filtered } };
    });
}

/** Same aggregation as KPI “missing parts”; callable before orderLineStatusReportMap useMemo (filter runs early in render). */
function buildOrderLineStatusReportMapFromDetails(orderDetailsData, excludedAvailabilityPartsByOrder = {}) {
    const map = {};
    if (!orderDetailsData || typeof orderDetailsData !== 'object') return map;
    Object.entries(orderDetailsData).forEach(([orderNum, orderLines]) => {
        if (!Array.isArray(orderLines) || orderLines.length === 0) return;
        const excludedPartsForOrder =
            excludedAvailabilityPartsByOrder?.[orderNum] ||
            excludedAvailabilityPartsByOrder?.[String(orderNum)] ||
            {};

        const bomPartMap = new Map();
        orderLines.forEach((item) => {
            const lineShipQty = Number(item?.balancedue) || 0;
            const bomParts = item?.bom?.bomParts || [];

            bomParts.forEach((bom) => {
                const key = bom?.prcpart;
                if (!key || bom?.archived) {
                    return;
                }

                const qtyPerTop = Number(bom?.qty_per_top) || 0;
                const qtyOrder = qtyPerTop * lineShipQty;
                const part = bom?.part || {};
                const qohBom = Number(part?.qoh_cache) || 0;
                const qrBom = Number(part?.qr_cache) || 0;

                if (bomPartMap.has(key)) {
                    const existing = bomPartMap.get(key);
                    existing.qtyOrder += qtyOrder;
                } else {
                    bomPartMap.set(key, {
                        prcpart: key,
                        qtyPerTop,
                        qtyOrder,
                        qohBom,
                        qrBom,
                        qtyAvail: qohBom - qrBom,
                    });
                }
            });
        });

        const aggregatedBomParts = Array.from(bomPartMap.values());
        let missingPartsCount = 0;
        aggregatedBomParts.forEach((bomPart) => {
            if (bomPart.qtyAvail < 0 && !excludedPartsForOrder[bomPart.prcpart]) {
                missingPartsCount += 1;
            }
        });

        map[orderNum] = {
            missingPartsCount,
            totalPartsCount: aggregatedBomParts.length,
            orderLineCount: orderLines.length,
        };
    });
    return map;
}

/** Best-effort date when a line/order entered the system (for week-over-week “new orders” stats). */
function getOrderLineEntryDate(line) {
    const raw =
        line?.enterdate ||
        line?.imported_date ||
        line?.enterDate ||
        line?.importedDate ||
        line?.order?.imported_date ||
        line?.order?.enterdate ||
        line?.order?.enterDate ||
        '';
    if (!raw || !String(raw).trim()) return null;
    const d = new Date(raw);
    return isNaN(d.getTime()) ? null : d;
}

// Returns the previous WO # only when it exists and differs from the current WO #
function getPrevWoNum(line) {
    const prevWoNum = line?.order?.prevWoNum;
    if (prevWoNum === null || prevWoNum === undefined) return null;
    const prev = String(prevWoNum).trim();
    if (!prev || prev === '-' || prev === 'N/A') return null;
    const current = String(line?.order?.woNum ?? '').trim();
    return prev === current ? null : prev;
}

function renderPrevWoNum(line) {
    const prevWoNum = getPrevWoNum(line);
    if (!prevWoNum) return null;
    return (
        <div
            className="text-decoration-line-through"
            style={{ color: '#888', fontSize: '12px', lineHeight: 1.2 }}
            title={`Previous WO #: ${prevWoNum}`}
        >
            {prevWoNum}
        </div>
    );
}

// Order Status Tags with colors

const Orders = ({ path }) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Live presence. /orders and /ordersInternal share this component but are
    // different pages, so they get separate presence rooms.
    const presencePage = path === '652' ? 'orders-internal' : 'orders';
    const presence = usePresence(presencePage, {
        onLockDenied: (evt) =>
            console.info(`[presence] ${evt?.owner?.name || 'Someone'} is already editing ${evt?.cell}`),
        onRemoteSave: (evt) => applyRemoteSave(evt),
    });

    const lineStatusCell = useCallback(
        (lineId) => cellKey(presencePage, 'line', lineId, 'lineStatus'),
        [presencePage]
    );

    // Order Status and Notes live in the collapsed grid row, so their presence
    // has to work without anyone expanding the order.
    const orderStatusCell = useCallback(
        (lineId) => cellKey(presencePage, 'line', lineId, 'orderStatus'),
        [presencePage]
    );

    const notesCell = useCallback(
        (lineId) => cellKey(presencePage, 'line', lineId, 'comment'),
        [presencePage]
    );

    // Destructured so these identities only change when the roster does, not on
    // every render of this (very large) grid.
    const {
        usersInCell: presenceUsersInCell,
        lockOwner: presenceLockOwner,
        reportFocus: presenceFocus,
        reportBlur: presenceBlur,
    } = presence;

    const lineStatusLockOwner = useCallback(
        (lineId) => presenceLockOwner(lineStatusCell(lineId)),
        [presenceLockOwner, lineStatusCell]
    );

    const orderStatusLockOwner = useCallback(
        (lineId) => presenceLockOwner(orderStatusCell(lineId)),
        [presenceLockOwner, orderStatusCell]
    );

    const renderLinePresence = useCallback(
        (lineId) => {
            const key = lineStatusCell(lineId);
            return (
                <CellPresence
                    users={presenceUsersInCell(key)}
                    owner={presenceLockOwner(key)}
                    compact
                    activity="on this line status"
                />
            );
        },
        [presenceUsersInCell, presenceLockOwner, lineStatusCell]
    );

    const orderRowCell = useCallback(
        (ordernum) => cellKey(presencePage, 'order', ordernum, 'row'),
        [presencePage]
    );

    /** Avatars of everyone else who has this order open, for the row itself. */
    const renderRowPresence = useCallback(
        (ordernum) => {
            if (!ordernum) return null;
            const users = presenceUsersInCell(orderRowCell(ordernum));
            if (!users.length) return null;
            return <CellPresence users={users} size={16} compact activity="also on this order" />;
        },
        [presenceUsersInCell, orderRowCell]
    );
    
    const renderOrderStatusPresence = useCallback(
        (lineId) => {
            const key = orderStatusCell(lineId);
            return (
                <CellPresence
                    users={presenceUsersInCell(key)}
                    owner={presenceLockOwner(key)}
                    size={16}
                    compact
                    activity="changing this order status"
                />
            );
        },
        [presenceUsersInCell, presenceLockOwner, orderStatusCell]
    );

    const ORDER_STATUS_TAGS = [
        { label: 'CC Hold', color: '#E39827' },
        { label: 'Wire Hold', color: '#E39827' },
        { label: 'Credit Hold', color: '#E39827' },
        { label: 'PPA', color: '#E39827' },
        { label: 'Paid', color: '#28a745' },
        { label: 'Partial', color: '#EF9884' },
        { label: 'CoT Required', color: '#4AB2D5' },
        { label: 'PMA', color: '#4AB2D5' },
        { label: 'AS9102', color: '#4AB2D5' },
        { label: 'Burn Test', color: '#4AB2D5' },
        { label: 'No Overage', color: '#BD83B8' },
        { label: 'Specific Lengths Required', color: '#BD83B8' },
        { label: 'Do Not Insure', color: '#BD83B8' },
        { label: 'No Charge', color: '#BD83B8' },
        { label: 'Hot Order/AOG', color: '#FF6B35', icon: 'fa fa-fire' },
        { label: 'PO Review', color: '#ffc400' }
    ];

    /** Line Status Tags (same as OrderPopup / inline line status UI; display order). */
    const LINE_STATUS_TAGS = [
        { label: 'Released', color: '#02f77c' },
        { label: 'Shipped', color: '#2D895F' },
        { label: 'In Kitting', color: '#CB5722' },
        { label: 'In Process', color: '#9288FF' },
        { label: 'In Testing', color: '#84E6F8' },
        { label: 'In Outgoing Inspection', color: '#B8B2E1' },
        { label: 'Not Released', color: '#F3DC6B' },
        { label: 'On Hold Cart', color: '#C56A00' },
        { label: 'Staging Cart', color: '#1DA1DB' },
        { label: 'Waiting On Components', color: '#A40202' },
        { label: 'PMA', color: '#594E9F' },
        { label: 'RMA', color: '#EB4F4F' },
        { label: 'ENG Review', color: '#625C5C' },
        { label: 'Charge', color: '#1d545e' }
    ];

    const KPI_SLOT_STORAGE_KEY = 'ecommerce-orders-kpi-slot-config-v1';
    const EXCLUDED_BOM_PARTS_STORAGE_KEY = 'ecommerce-orders-excluded-bom-parts-v1';
    const DEFAULT_KPI_SLOTS = [
        { preset: 'total' },
        { preset: 'due' },
        { preset: 'missing' },
        { preset: 'ready' }
    ];

    const normalizeKpiSlotConfig = (raw) => {
        const allowed = new Set(['total', 'due', 'missing', 'ready', 'order', 'line']);
        if (!Array.isArray(raw) || raw.length !== 4) return DEFAULT_KPI_SLOTS.map((s) => ({ ...s }));
        return raw.map((s, i) => {
            const def = DEFAULT_KPI_SLOTS[i];
            if (!s || typeof s !== 'object') return { ...def };
            const preset = allowed.has(s.preset) ? s.preset : def.preset;
            if (preset === 'order' || preset === 'line') {
                const label = typeof s.label === 'string' && s.label.trim() ? s.label.trim() : 'Ready to Ship';
                return { preset, label };
            }
            return { preset };
        });
    };
 
    //  const [dropdownOpenId, setDropdownOpenId] = useState(null);
    //   const [dropdownPosition, setDropdownPosition] = useState(null);

    // This code related to DROPDOWN of Order Status
    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const [orderStatusSelections, setOrderStatusSelections] = useState({});
    const [submittedOrderStatuses, setSubmittedOrderStatuses] = useState({});
    const [tagsToDeselect, setTagsToDeselect] = useState({});
    // Every notes chat currently open, so presence can show this person on each one.
    const [openNotesLineIds, setOpenNotesLineIds] = useState(() => new Set());
    // Refresh functionality state
    const [lastRefreshData, setLastRefreshData] = useState(null);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [isManualRefreshing, setIsManualRefreshing] = useState(false);

    // New Orders section collapse (default hidden; user can expand from the section header)
    const [newOrdersSectionExpanded, setNewOrdersSectionExpanded] = useState(false);
    /** Total orders stat card: collapsed shows count + trend only; expanded shows new-order week breakdown */
    const [totalOrdersStatExpanded, setTotalOrdersStatExpanded] = useState(false);
    /** Hydrate once from localStorage so filter toggles survive remount / browser refresh. */
    const [ordersFilterHydration] = useState(() => loadOrdersFilterState(ORDERS_FILTER_STATE_STORAGE_KEY));
     /** KPI strip filter — applies to All Orders list only; New Orders section collapses when active. */
    const [kpiQuickFilter, setKpiQuickFilter] = useState(ordersFilterHydration.kpiQuickFilter); // null | 'due' | 'missing' | 'ready' | { kind, label }

    useEffect(() => {
        if (kpiQuickFilter) {
            setNewOrdersSectionExpanded(false);
        }
    }, [kpiQuickFilter]);

    const [kpiSlotConfig, setKpiSlotConfig] = useState(() => {
        try {
            const raw = localStorage.getItem(KPI_SLOT_STORAGE_KEY);
            if (!raw) return normalizeKpiSlotConfig(null);
            return normalizeKpiSlotConfig(JSON.parse(raw));
        } catch {
            return normalizeKpiSlotConfig(null);
        }
    });
    const [kpiTagPickerSlot, setKpiTagPickerSlot] = useState(null);

    useEffect(() => {
        try {
            localStorage.setItem(KPI_SLOT_STORAGE_KEY, JSON.stringify(kpiSlotConfig));
        } catch {
            /* ignore */
        }
    }, [kpiSlotConfig]);

    useEffect(() => {
        if (kpiTagPickerSlot == null) return;
        const onDown = (e) => {
            if (e.target.closest('.orders-kpi-tag-picker') || e.target.closest('.orders-kpi-filter-trigger')) return;
            setKpiTagPickerSlot(null);
        };
        document.addEventListener('mousedown', onDown);
        return () => document.removeEventListener('mousedown', onDown);
    }, [kpiTagPickerSlot]);

    /** Must be declared before isReadyToShipLine / getFilteredOrderData (Ready to ship filter uses these). */
    const [lineStatusSelections, setLineStatusSelections] = useState({});
    const [submittedLineStatuses, setSubmittedLineStatuses] = useState({});

    const toggleDropdown = (id, event) => {
        if (dropdownOpenId === id) {
            setDropdownOpenId(null);
            return;
        }
        const rect = event.currentTarget.getBoundingClientRect();
        setDropdownPosition(orderStatusMenuPosition(rect));
        setDropdownOpenId(id);
    };



    const handleSelectTagsClick = (event, line) => {
        // Close any other open dropdowns first
        if (dropdownOpenId && dropdownOpenId !== line.id) {
            setDropdownOpenId(null);
        }

        // Toggle the current dropdown
        if (dropdownOpenId === line.id) {
            setDropdownOpenId(null);
            return;
        }

        // Someone else is already in this order status - don't open a second picker.
        const statusLockedBy = orderStatusLockOwner(line.id);
        if (statusLockedBy) {
            alert(`${statusLockedBy.name} is changing this order status. Try again in a moment.`);
            return;
        }

        const rect = event.currentTarget.getBoundingClientRect();
        setDropdownPosition(orderStatusMenuPosition(rect));
        setDropdownOpenId(line.id);
    };

    const pageShellRef = useRef(null);
    const titleWrapRef = useRef(null);
    const stickyStackRef = useRef(null);
    const kpiStatsRef = useRef(null);
    const tableContainerRef = useRef(null);
    const copyTimeoutRef = useRef(null);
    const promisedDateByOrderNumRef = useRef(new Map());

    // Close Order Status portal dropdown on any page/table scroll so it cannot detach
    // from its trigger. Keep open when scrolling inside the portaled menu list.
    useEffect(() => {
        if (!dropdownOpenId) return undefined;

        const handleScroll = (event) => {
            const target = event?.target;
            if (target instanceof Element && target.closest(".order-status-dropdown")) {
                return;
            }
            setDropdownOpenId(null);
        };

        window.addEventListener("scroll", handleScroll, true);
        return () => {
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, [dropdownOpenId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!dropdownOpenId) return;
            const target = event.target;
            if (!(target instanceof Element)) {
                setDropdownOpenId(null);
                return;
            }
            // Keep the menu open when choosing tags or clicking the save checkmark.
            // Closing on mousedown of the checkmark re-renders the table and swallows the save click.
            if (target.closest(".order-status-dropdown") || target.closest(".order-status-submit-btn")) {
                return;
            }
            setDropdownOpenId(null);
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [dropdownOpenId]);


    // This above code related to DROPDOWN of Order Status--- upto here

    const { orderFetch, updateArchiveOrder, updateArchiveOrderLineItem, updateArchiveBomPart } = orderContext();
    const [orderData, setOrderData] = useState([]);
    const [singleOrderData, setSingleOrderData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [overallTotalRecords, setOverallTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(-1);
    const [searchTerm, setSearchTerm] = useState(ordersFilterHydration.searchTerm);
    const [tempSearchTerm, setTempSearchTerm] = useState(ordersFilterHydration.searchTerm);
    const [loading, setLoading] = useState(false);
    const [expandedRows, setExpandedRows] = useState([]);
    const [showInlineOrders, setShowInlineOrders] = useState(true); // Global toggle for inline orders
    const [excludedAvailabilityPartsByOrder, setExcludedAvailabilityPartsByOrder] = useState(() => {
        try {
            const raw = localStorage.getItem(EXCLUDED_BOM_PARTS_STORAGE_KEY);
            if (!raw) return {};
            const parsed = JSON.parse(raw);
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch {
            return {};
        }
    });
    const [orderStatus, setorderStatus] = useState({});
    useEffect(() => {
        try {
            localStorage.setItem(
                EXCLUDED_BOM_PARTS_STORAGE_KEY,
                JSON.stringify(excludedAvailabilityPartsByOrder || {})
            );
        } catch {
            /* ignore */
        }
    }, [excludedAvailabilityPartsByOrder, EXCLUDED_BOM_PARTS_STORAGE_KEY]);
    const [startDate, setStartDate] = useState(ordersFilterHydration.startDate);
    const [endDate, setEndDate] = useState(ordersFilterHydration.endDate);

    const [useEffectOrder, setUseEffectOrder] = useState('');
    const [orderSearch, setOrderSearch] = useState([]);
    const [orderValue, setOrderValue] = useState(ordersFilterHydration.orderValue);

    const [useEffectPO, setUseEffectPO] = useState('');
    const [POSearch, setPOSearch] = useState([]);
    const [POValue, setPOValue] = useState(ordersFilterHydration.POValue);

    const [useEffectPartName, setUseEffectPartName] = useState('');
    const [PartNameSearch, setPartNameSearch] = useState([]);
    const [PartNameValue, setPartNameValue] = useState(ordersFilterHydration.PartNameValue);

    const [useEffectShippingMethod, setUseEffectShippingMethod] = useState('');
    const [ShippingMethodSearch, setShippingMethodSearch] = useState([]);
    const [ShippingMethodValue, setShippingMethodValue] = useState(ordersFilterHydration.ShippingMethodValue);

    const [useEffectCountry, setUseEffectCountry] = useState('');
    const [CountrySearch, setCountrySearch] = useState([]);
    const [CountryValue, setCountryValue] = useState(ordersFilterHydration.CountryValue);

    const [useEffectCustomer, setUseEffectCustomer] = useState('');
    const [CustomerSearch, setCustomerSearch] = useState([]);
    const [CustomerValue, setCustomerValue] = useState(ordersFilterHydration.CustomerValue);
    const [CustomerId, setCustomerId] = useState(path || ordersFilterHydration.customerId || '');

    const [selectBoxAppend, setSelectBoxAppend] = useState([]);
    
    // WO# filter state
    const [useEffectWO, setUseEffectWO] = useState('');
    const [WOSearch, setWOSearch] = useState([]);
    const [WOValue, setWOValue] = useState(ordersFilterHydration.WOValue);
    
    // Order Status tag filter state (multi-select)
    const [selectedOrderStatusTags, setSelectedOrderStatusTags] = useState(ordersFilterHydration.selectedOrderStatusTags);
    const [orderStatusFilterDropdownOpen, setOrderStatusFilterDropdownOpen] = useState(false);
    
    // Line Status tag filter state (multi-select)
    const [selectedLineStatusTags, setSelectedLineStatusTags] = useState(ordersFilterHydration.selectedLineStatusTags);
    const [lineStatusFilterDropdownOpen, setLineStatusFilterDropdownOpen] = useState(false);
    
    const [exports, setExports] = useState(false);

    const [updatePopUp, setUpdatePopUp] = useState('');

    const [show, setShow] = useState(false);

    const [lineId, setLineId] = useState('');
    const [orderNum, setOrderNum] = useState('');

    const [hoverRowId, setHoverRowId] = useState(null);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleCopyToClipboard = (value, field) => {
        const text = value !== null && value !== undefined ? value.toString().trim() : '';
        if (!text) {
            return;
        }

        const finalizeCopy = () => {
            setCopiedField(field);
            if (copyTimeoutRef.current) {
                clearTimeout(copyTimeoutRef.current);
            }
            copyTimeoutRef.current = setTimeout(() => {
                setCopiedField(null);
            }, 2000);
        };

        const fallbackCopyText = (textToCopy) => {
            const textArea = document.createElement('textarea');
            textArea.value = textToCopy;
            textArea.style.position = 'fixed';
            textArea.style.top = '-9999px';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);
            if (!successful) {
                throw new Error('Fallback copy command was unsuccessful');
            }
        };

        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(text)
                .then(finalizeCopy)
                .catch(() => {
                    try {
                        fallbackCopyText(text);
                        finalizeCopy();
                    } catch (err) {
                        console.error('Failed to copy text:', err);
                    }
                });
        } else {
            try {
                fallbackCopyText(text);
                finalizeCopy();
            } catch (err) {
                console.error('Failed to copy text:', err);
            }
        }
    };

    const getCetecOrderNumber = (line) => {
        const orderNum = line?.order?.ordernum || line?.ordernum || '';
        const partialName = line?.name || line?.order?.name || '';
        if (orderNum && partialName) {
            return `${orderNum}(${partialName})`;
        }
        return orderNum || partialName || 'N/A';
    };

    const [note, setNote] = useState('');

    const [commentsMap, setCommentsMap] = useState({});

    // State for order access links
    const [orderAccessLinks, setOrderAccessLinks] = useState(() => {
        const savedLinks = localStorage.getItem('orderAccessLinks');
        return savedLinks ? JSON.parse(savedLinks) : {};
    });

    // Archived line item IDs (used to hide only specific lines in inline tables)
    const [archivedOrderIds, setArchivedOrderIds] = useState(() => {
        const savedLineArchived = localStorage.getItem('archivedLineItemIds');
        if (savedLineArchived) {
            return new Set(JSON.parse(savedLineArchived));
        }
        const legacyArchived = localStorage.getItem('archivedOrderIds');
        return legacyArchived ? new Set(JSON.parse(legacyArchived)) : new Set();
    });

    // Archived order numbers (used to hide whole order rows)
    const [archivedOrderNums, setArchivedOrderNums] = useState(() => {
        const savedOrderNums = localStorage.getItem('archivedOrderNums');
        return savedOrderNums ? new Set(JSON.parse(savedOrderNums)) : new Set();
    });

    // State for archived orders data (stored as array of full order line objects)
    const [archivedOrdersData, setArchivedOrdersData] = useState(() => {
        const savedArchivedData = localStorage.getItem('archivedOrdersData');
        return savedArchivedData ? JSON.parse(savedArchivedData) : [];
    });

    // State for order access modal
    const [showOrderAccessModal, setShowOrderAccessModal] = useState(false);
    const [selectedOrderForAccess, setSelectedOrderForAccess] = useState(null);
    const [newLinkUrl, setNewLinkUrl] = useState('');
    const [newLinkUrlName, setNewLinkUrlName] = useState('');
    const [copiedField, setCopiedField] = useState(null);
    const selectedOrderNumber = selectedOrderForAccess?.order?.ordernum ?? '';
    const selectedCustomerName = selectedOrderForAccess?.order?.customer?.name ?? '';

    // State for shipping date sorting (default: ascending - earliest dates first)
    const [shippingDateSort, setShippingDateSort] = useState('ascending');

    // State for other column sorting (order#, customer name, PO#, country)
    const [columnSort, setColumnSort] = useState({ key: null, direction: null });
    const [orderDetailsData, setOrderDetailsData] = useState({}); // Store fetched order details

    // ---- Draggable column reorder (Bridge Orders page) ----
    const [columnOrder, setColumnOrder] = useState(() => {
        const base = loadOrdersColumnOrder();
        const groups = loadColumnGroupsState(localStorage.getItem('userEmail'));
        return getEffectiveColumnOrder(base, groups.activeGroupId, groups.customGroups);
    });
    const [draggedColumnId, setDraggedColumnId] = useState(null);

    // ---- Column groups (merged columns) ----
    const [showColumnGroupsModal, setShowColumnGroupsModal] = useState(false);
    const [columnGroupsState, setColumnGroupsState] = useState(() => {
        const userEmail = localStorage.getItem('userEmail');
        return loadColumnGroupsState(userEmail);
    });
    const { activeGroupId, defaultGroupId, customGroups } = columnGroupsState;

    const effectiveColumnOrder = useMemo(
        () => getEffectiveColumnOrder(columnOrder, activeGroupId, customGroups),
        [columnOrder, activeGroupId, customGroups]
    );

    // ---- Column show/hide (inline +/- controls + modal share one state) ----
    const [columnVisibility, setColumnVisibility] = useState(() => loadColumnVisibility(localStorage.getItem('userEmail')));
    const [showColumnVisibilityModal, setShowColumnVisibilityModal] = useState(false);

    const handleColumnVisibilityChange = useCallback((newVisibility) => {
        const next = newVisibility || {};
        setColumnVisibility(next);
        saveColumnVisibility(localStorage.getItem('userEmail'), next);
    }, []);

    const toggleColumnVisibility = useCallback((columnId) => {
        setColumnVisibility((prev) => {
            const currentlyVisible = prev[columnId] !== false;
            // Never hide the last visible column.
            if (currentlyVisible) {
                const visibleIds = effectiveColumnOrder.filter((id) => prev[id] !== false);
                if (visibleIds.length <= 1) return prev;
            }
            const next = { ...prev, [columnId]: currentlyVisible ? false : true };
            saveColumnVisibility(localStorage.getItem('userEmail'), next);
            return next;
        });
    }, [effectiveColumnOrder]);

    const handleShowAllColumns = useCallback(() => {
        handleColumnVisibilityChange({});
    }, [handleColumnVisibilityChange]);

    // Label lookup for the modal (handles merged group columns too).
    const getColumnLabel = useCallback((id) => {
        if (COLUMN_LABELS[id]) return COLUMN_LABELS[id];
        if (isMergedColumnId(id)) {
            const group = customGroups.find((g) => getMergedIdForGroup(g.id) === id);
            return group?.name || 'Group';
        }
        return id;
    }, [customGroups]);

    const columnVisibilityList = useMemo(
        () => effectiveColumnOrder.map((id) => ({ key: id, label: getColumnLabel(id) })),
        [effectiveColumnOrder, getColumnLabel]
    );

    const hiddenColumnCount = useMemo(
        () => effectiveColumnOrder.filter((id) => columnVisibility[id] === false).length,
        [effectiveColumnOrder, columnVisibility]
    );

    const inlineDropdownTrailingCells = 3;

    useEffect(() => {
        const userEmail = localStorage.getItem('userEmail');
        saveColumnGroupsState(userEmail, columnGroupsState);
    }, [columnGroupsState]);

    const handleColumnGroupsApply = ({ activeGroupId: nextActiveId, defaultGroupId: nextDefaultId }) => {
        setColumnGroupsState((prev) => {
            setColumnOrder((prevOrder) => {
                const baseOrder = sanitizeColumnOrder(prevOrder.filter((id) => !isMergedColumnId(id)));
                if (!nextActiveId || nextActiveId === NORMAL_GROUP_ID) {
                    const prevMerged = getMergedIdForGroup(prev.activeGroupId);
                    const prevSources = getSourceIdsForGroup(prev.activeGroupId, prev.customGroups);
                    if (prevMerged && prevSources.length) {
                        return expandMergedColumnOrder(prevOrder, prevMerged, prevSources);
                    }
                    return baseOrder;
                }
                return buildEffectiveColumnOrder(baseOrder, nextActiveId, prev.customGroups);
            });
            return {
                ...prev,
                activeGroupId: nextActiveId,
                defaultGroupId: nextDefaultId,
            };
        });
    };

    const handleSaveCustomGroup = (group) => {
        setColumnGroupsState((prev) => {
            const existing = prev.customGroups.findIndex((g) => g.id === group.id);
            const nextGroups = [...prev.customGroups];
            if (existing >= 0) nextGroups[existing] = group;
            else nextGroups.push(group);
            return { ...prev, customGroups: nextGroups };
        });
    };

    const handleDeleteCustomGroup = (groupId) => {
        setColumnGroupsState((prev) => {
            const nextActive = prev.activeGroupId === groupId ? NORMAL_GROUP_ID : prev.activeGroupId;
            const nextDefault = prev.defaultGroupId === groupId ? NORMAL_GROUP_ID : prev.defaultGroupId;
            return {
                ...prev,
                customGroups: prev.customGroups.filter((g) => g.id !== groupId),
                activeGroupId: nextActive,
                defaultGroupId: nextDefault,
            };
        });
        if (activeGroupId === groupId) {
            setColumnOrder((prev) => {
                const mergedId = getMergedIdForGroup(groupId);
                const sources = getSourceIdsForGroup(groupId, customGroups);
                return expandMergedColumnOrder(prev, mergedId, sources);
            });
        }
    };

    const renderOrderFolderIcon = useCallback((line, isOrangeRow) => {
        const rowLinks = orderAccessLinks?.[line.id];
        const rowLinkUrl = Array.isArray(rowLinks) && rowLinks.length > 0
            ? rowLinks[rowLinks.length - 1]?.url?.trim()
            : null;
        const fallbackUrl = typeof line.folderUrl === 'string' ? line.folderUrl.trim() : null;
        const folderLink = rowLinkUrl || fallbackUrl || null;
        const folderTitle = folderLink ? `Open folder: ${folderLink}` : 'No folder link saved yet';
        return (
            <a
                href={folderLink || '#'}
                onClick={(event) => { if (!folderLink) event.preventDefault(); }}
                target={folderLink ? '_blank' : undefined}
                rel={folderLink ? 'noopener noreferrer' : undefined}
                style={{ cursor: folderLink ? 'pointer' : 'not-allowed', textDecoration: 'none' }}
                title={folderTitle}
            >
                <i
                    className="fa fa-folder"
                    aria-hidden="true"
                    style={{ fontSize: '16px', color: folderLink ? (isOrangeRow ? '#cc7a00' : '#ff8c00') : '#cccccc' }}
                />
            </a>
        );
    }, [orderAccessLinks]);

    const renderOrderSetBodyCell = useCallback((line, isOrangeRow) => (
        <td className="text-center orders-column-group-td" style={{ minWidth: '280px', maxWidth: '320px' }}>
            <CombinedColumnCell
                lines={[
                    {
                        label: 'Order #',
                        show: !!(line.order?.ordernum || line.ordernum),
                        content: (
                            <span className="d-inline-flex align-items-center gap-2">
                                <a
                                    href={`https://gigaflightinc.cetecerp.com/order/MN${line.order.ordernum}/view`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'none', whiteSpace: 'nowrap' }}
                                >
                                    {getCetecOrderNumber(line)}
                                </a>
                                {renderOrderFolderIcon(line, isOrangeRow)}
                            </span>
                        ),
                    },
                    {
                        label: 'WO #',
                        show: !!((line.order?.woNum && line.order.woNum !== '-') || getPrevWoNum(line)),
                        content: (
                            <span className="d-inline-flex flex-column">
                                <span className="d-inline-flex align-items-center gap-1">
                                    <a
                                        href={`https://gigaflightinc.cetecerp.com/order/MN${line.order?.woNum}/view`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        {line.order?.woNum}
                                    </a>
                                    {line.order?.woUrl && (
                                        <a
                                            href={line.order.woUrl}
                                            target="_blank"
                                            rel="noreferrer"
                                            title={`Open WO folder: ${line.order.woUrl}`}
                                        >
                                            <i className="fa fa-folder" aria-hidden="true" style={{ fontSize: '16px', color: isOrangeRow ? '#cc7a00' : '#ff8c00' }} />
                                        </a>
                                    )}
                                </span>
                                {renderPrevWoNum(line)}
                            </span>
                        ),
                    },
                    {
                        label: 'Customer',
                        show: !!(line.order?.customer?.name),
                        content: line.order?.customer?.id ? (
                            <a
                                href={`https://gigaflightinc.cetecerp.com/customer/${line.order.customer.id}/view`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none' }}
                            >
                                {line.order.customer.name}
                            </a>
                        ) : line.order.customer.name,
                    },
                    {
                        label: 'PO #',
                        show: !!(line.order?.custponum),
                        content: line.order.custponum,
                    },
                ]}
            />
        </td>
    ), [renderOrderFolderIcon]);

    const getSimpleColumnLine = useCallback((colId, line, displayShipDate, isOrangeRow, isPoReviewRow = false) => {
        switch (colId) {
            case 'ordernum':
                return {
                    label: 'Order #',
                    show: !!(line.order?.ordernum || line.ordernum),
                    content: (
                        <span className="d-inline-flex align-items-center gap-2">
                            <a
                                href={`https://gigaflightinc.cetecerp.com/order/MN${line.order.ordernum}/view`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', whiteSpace: 'nowrap' }}
                            >
                                {getCetecOrderNumber(line)}
                            </a>
                            {renderOrderFolderIcon(line, isOrangeRow)}
                        </span>
                    ),
                };
            case 'orderedondate':
                return {
                    label: 'Ordered On Date',
                    show: getOrderedOnDate(line) !== '-',
                    content: getOrderedOnDate(line),
                };
            case 'wo':
                return {
                    label: 'WO #',
                    show: !!((line.order?.woNum && line.order.woNum !== '-') || getPrevWoNum(line)),
                    content: (
                        <span className="d-inline-flex flex-column align-items-center">
                            <span className="d-inline-flex align-items-center justify-content-center gap-1">
                                <a
                                    href={`https://gigaflightinc.cetecerp.com/order/MN${line.order?.woNum}/view`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'none' }}
                                >
                                    {line.order?.woNum}
                                </a>
                                {line.order?.woNum && line.order.woNum !== '-' && line.order?.woUrl && (
                                    <a
                                        href={line.order.woUrl}
                                        target="_blank"
                                        rel="noreferrer"
                                        title={`Open WO folder: ${line.order.woUrl}`}
                                    >
                                        <i
                                            className="fa fa-folder"
                                            aria-hidden="true"
                                            style={{ fontSize: '16px', color: isOrangeRow ? '#cc7a00' : '#ff8c00' }}
                                        />
                                    </a>
                                )}
                            </span>
                            {renderPrevWoNum(line)}
                        </span>
                    ),
                };
            case 'name':
                return {
                    label: 'Customer',
                    show: !!(line.order?.customer?.name),
                    content: line.order?.customer?.id ? (
                        <a
                            href={`https://gigaflightinc.cetecerp.com/customer/${line.order.customer.id}/view`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                        >
                            {line.order.customer.name}
                        </a>
                    ) : (line.order?.customer?.name || ''),
                };
            case 'custponum':
                return { label: 'PO #', content: line.order?.custponum, show: !!(line.order?.custponum) };
            case 'shipdate':
                return { label: 'Ship Date', content: displayShipDate || 'N/A', show: true };
            case 'lineitem':
                return {
                    label: 'Line Item',
                    content: line.negativeCountStr,
                    show: !!(line.negativeCountStr),
                    valueStyle: isPoReviewRow ? undefined : getLineItemMismatchStyle(line.negativeCountStr),
                };
            case 'shippingmethod': {
                const methodText = line.order?.shipmentMethod?.methodOfShipment;
                const text = methodText || 'N/A';
                const lower = String(text).toLowerCase();
                let content = text;
                if (lower.includes('fedex')) {
                    content = (
                        <a href="https://www.fedex.com/secure-login/en-us/#/credentials" target="_blank" rel="noopener noreferrer">
                            {text}
                        </a>
                    );
                } else if (lower.includes('ups')) {
                    content = (
                        <a href="https://www.ups.com/ship/basic/shipment-info?tx=20678219171053728&loc=en_US&promoCodeAlias=sPArk&WT.srch=1" target="_blank" rel="noopener noreferrer">
                            {text}
                        </a>
                    );
                }
                return { label: 'Shipping Method', content, show: !!(methodText) };
            }
            case 'country': {
                const countryName = line.order?.country?.country_Name;
                const isIntl = countryName && countryName !== 'United States';
                return {
                    label: 'Country',
                    content: countryName,
                    show: !!countryName,
                    valueClassName: (!isPoReviewRow && isIntl) ? 'bg-dark text-light px-1 rounded country-cell-intl' : ((!isPoReviewRow && countryName === 'United States') ? 'px-1 rounded country-cell-us' : ''),
                };
            }
            default:
                return null;
        }
    }, [renderOrderFolderIcon]);

    const renderCustomGroupBodyCell = useCallback((line, mergedId, displayShipDate, isOrangeRow, isPoReviewRow = false) => {
        const groupId = mergedId.replace(/^group-/, '');
        const group = customGroups.find((g) => g.id === groupId);
        const columnIds = group?.columnIds || [];
        const lines = columnIds
            .map((colId) => getSimpleColumnLine(colId, line, displayShipDate, isOrangeRow, isPoReviewRow))
            .filter(Boolean);
        return (
            <td className="text-center orders-column-group-td" style={{ minWidth: '240px', maxWidth: '300px' }}>
                <CombinedColumnCell lines={lines} />
            </td>
        );
    }, [customGroups, getSimpleColumnLine]);

    const getMergedBodyCells = useCallback((line, displayShipDate, isOrangeRow, isPoReviewRow = false) => {
        const cells = {};
        if (activeGroupId === ORDER_SET_GROUP_ID) {
            cells[ORDER_SET_MERGED_ID] = renderOrderSetBodyCell(line, isOrangeRow);
        }
        customGroups.forEach((group) => {
            if (activeGroupId === group.id) {
                cells[getMergedIdForGroup(group.id)] = renderCustomGroupBodyCell(
                    line,
                    getMergedIdForGroup(group.id),
                    displayShipDate,
                    isOrangeRow,
                    isPoReviewRow
                );
            }
        });
        return cells;
    }, [activeGroupId, customGroups, renderOrderSetBodyCell, renderCustomGroupBodyCell]);

    // Persist the user's column order so it survives a refresh.
    useEffect(() => {
        try {
            localStorage.setItem(ORDERS_COLUMN_ORDER_STORAGE_KEY, JSON.stringify(columnOrder));
        } catch (e) { /* ignore storage write errors */ }
    }, [columnOrder]);

    const handleColumnDragStart = (e, id) => {
        setDraggedColumnId(id);
        if (e.dataTransfer) {
            e.dataTransfer.effectAllowed = 'move';
            // Firefox requires data to be set for a drag to start.
            try { e.dataTransfer.setData('text/plain', id); } catch (err) { /* noop */ }
        }
    };
    const handleColumnDragOver = (e) => {
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
    };
    const handleColumnDrop = (e, targetId) => {
        e.preventDefault();
        const sourceId = draggedColumnId || (e.dataTransfer && e.dataTransfer.getData('text/plain'));
        if (!sourceId || sourceId === targetId) { setDraggedColumnId(null); return; }
        setColumnOrder((prev) => {
            const next = [...prev];
            const from = next.indexOf(sourceId);
            const to = next.indexOf(targetId);
            if (from === -1 || to === -1) return prev;
            next.splice(from, 1);
            next.splice(to, 0, sourceId);
            return next;
        });
        setDraggedColumnId(null);
    };
    const handleColumnDragEnd = () => setDraggedColumnId(null);
    const resetColumnOrder = () => {
        const nextOrder = activeGroupId && activeGroupId !== NORMAL_GROUP_ID
            ? buildEffectiveColumnOrder([...DEFAULT_ORDERS_COLUMN_ORDER], activeGroupId, customGroups)
            : [...DEFAULT_ORDERS_COLUMN_ORDER];
        setColumnOrder(nextOrder);
        try { localStorage.removeItem(ORDERS_COLUMN_ORDER_STORAGE_KEY); } catch (e) { /* ignore */ }
    };
    const orderColumnDragHandlers = {
        onDragStart: handleColumnDragStart,
        onDragOver: handleColumnDragOver,
        onDrop: handleColumnDrop,
        onDragEnd: handleColumnDragEnd,
    };

    // Get the earliest promisedate across all visible (non-archived) lines for the same order.
    // Uses a per-render map (promisedDateByOrderNumRef) so sort/filter/row paint stay O(1) per line.
    const getEarliestPromisedDateForOrder = (line) => {
        const orderNum = line?.order?.ordernum;
        const fallbackDate = line?.promisedate || '';

        if (!orderNum) return fallbackDate;

        const cached = promisedDateByOrderNumRef.current.get(String(orderNum));
        if (cached) return cached;

        const isArchived = archivedOrderIds.has(line?.id) || archivedOrderIds.has(String(line?.id));
        if (fallbackDate && !isArchived) return String(fallbackDate).trim();
        return '';
    };

    // Parse date as calendar day in local time to avoid UTC shift issues (e.g., YYYY-MM-DD showing as previous day).
    const parseAsLocalCalendarDate = (dateValue) => {
        if (!dateValue) return null;
        const raw = String(dateValue).trim();
        if (!raw) return null;

        const dateOnlyMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (dateOnlyMatch) {
            const [, year, month, day] = dateOnlyMatch;
            return new Date(Number(year), Number(month) - 1, Number(day));
        }

        const parsed = new Date(raw);
        if (isNaN(parsed.getTime())) return null;
        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    };

    // Function to sort orders by shipping date
    const sortOrdersByShippingDate = (orders, sortDirection) => {
        if (!orders || !Array.isArray(orders)) return orders;
        
        return [...orders].sort((a, b) => {
            const dateA = getEarliestPromisedDateForOrder(a);
            const dateB = getEarliestPromisedDateForOrder(b);

            // Handle empty dates - put them at the end
            if (!dateA && !dateB) return 0;
            if (!dateA) return 1;
            if (!dateB) return -1;

            // Parse dates (format: yyyy-mm-dd)
            const dateObjA = new Date(dateA);
            const dateObjB = new Date(dateB);

            // Compare dates
            if (sortDirection === 'ascending') {
                return dateObjA - dateObjB; // Earliest dates first
            } else {
                return dateObjB - dateObjA; // Latest dates first
            }
        });
    };

    // Function to toggle shipping date sort direction
    const handleShippingDateSort = () => {
        setShippingDateSort(prev => prev === 'ascending' ? 'descending' : 'ascending');
        // Clear column sort when shipping date is clicked
        setColumnSort({ key: null, direction: null });
    };

    // Function to get sort icon for shipping date
    const getShippingDateSortIcon = () => {
        return shippingDateSort === 'ascending' ? '▲' : '▼';
    };

    // Function to sort orders by other columns (order#, customer name, PO#, country)
    const sortOrdersByColumn = (orders, sortKey, sortDirection) => {
        if (!orders || !Array.isArray(orders) || !sortKey || !sortDirection) return orders;
        
        return [...orders].sort((a, b) => {
            let valueA, valueB;

            // Get values based on column key
            switch (sortKey) {
                case 'ordernum':
                    // Order number - numeric sorting
                    valueA = parseInt(a.order?.ordernum || 0);
                    valueB = parseInt(b.order?.ordernum || 0);
                    if (sortDirection === 'ascending') {
                        return valueA - valueB;
                    } else {
                        return valueB - valueA;
                    }

                case 'orderedondate':
                    valueA = getOrderedOnDate(a) === '-' ? '' : getOrderedOnDate(a);
                    valueB = getOrderedOnDate(b) === '-' ? '' : getOrderedOnDate(b);
                    if (sortDirection === 'ascending') {
                        return valueA.localeCompare(valueB);
                    }
                    return valueB.localeCompare(valueA);

                case 'name':
                    // Customer name - text sorting
                    valueA = (a.order?.customer?.name || '').toLowerCase();
                    valueB = (b.order?.customer?.name || '').toLowerCase();
                    if (sortDirection === 'ascending') {
                        return valueA.localeCompare(valueB);
                    } else {
                        return valueB.localeCompare(valueA);
                    }

                case 'custponum':
                    // PO number - text sorting
                    valueA = (a.order?.custponum || '').toString().toLowerCase();
                    valueB = (b.order?.custponum || '').toString().toLowerCase();
                    if (sortDirection === 'ascending') {
                        return valueA.localeCompare(valueB);
                    } else {
                        return valueB.localeCompare(valueA);
                    }

                case 'country_name':
                    // Country name - text sorting
                    valueA = (a.order?.country?.country_Name || '').toLowerCase();
                    valueB = (b.order?.country?.country_Name || '').toLowerCase();
                    if (sortDirection === 'ascending') {
                        return valueA.localeCompare(valueB);
                    } else {
                        return valueB.localeCompare(valueA);
                    }

                default:
                    return 0;
            }
        });
    };

    // Function to handle column sort toggle
    const handleColumnSort = (key) => {
        setColumnSort(prev => {
            // If clicking the same column, toggle direction
            if (prev.key === key) {
                return {
                    key: key,
                    direction: prev.direction === 'ascending' ? 'descending' : 'ascending'
                };
            } else {
                // If clicking a different column, set to ascending
                return {
                    key: key,
                    direction: 'ascending'
                };
            }
        });
        // Note: Shipping date sort remains active but column sort takes priority
    };

    // Function to get sort icon for columns
    const getColumnSortIcon = (key) => {
        if (columnSort.key !== key) return null;
        return columnSort.direction === 'ascending' ? '▲' : '▼';
    };

    const mergedHeaderCells = useMemo(() => {
        const cells = {};
        if (activeGroupId === ORDER_SET_GROUP_ID) {
            cells[ORDER_SET_MERGED_ID] = (
                <th
                    className="text-center"
                    style={{ minWidth: '280px', maxWidth: '320px', cursor: 'pointer', whiteSpace: 'nowrap' }}
                    onClick={() => handleColumnSort('ordernum')}
                >
                    Order Set {getColumnSortIcon('ordernum')}
                </th>
            );
        }
        customGroups.forEach((group) => {
            const mergedId = getMergedIdForGroup(group.id);
            if (activeGroupId === group.id) {
                cells[mergedId] = (
                    <th className="text-center" style={{ minWidth: '240px', maxWidth: '300px' }}>
                        {group.name}
                    </th>
                );
            }
        });
        return cells;
    }, [activeGroupId, customGroups, columnSort]);

    // const orderStatusOptions = ["Can Ship Early", "Do Not Ship Early", "CC Hold", "Wire Hold", "Credit Hold"];

    useEffect(() => {
        localStorage.setItem('orderAccessLinks', JSON.stringify(orderAccessLinks));
    }, [orderAccessLinks]);

    useEffect(() => {
        localStorage.setItem('archivedLineItemIds', JSON.stringify(Array.from(archivedOrderIds)));
    }, [archivedOrderIds]);

    useEffect(() => {
        localStorage.setItem('archivedOrderNums', JSON.stringify(Array.from(archivedOrderNums)));
    }, [archivedOrderNums]);

    useEffect(() => {
        localStorage.setItem('archivedOrdersData', JSON.stringify(archivedOrdersData));
    }, [archivedOrdersData]);
    useEffect(() => {
        return () => {
            if (copyTimeoutRef.current) {
                clearTimeout(copyTimeoutRef.current);
            }
        };
    }, []);
    useEffect(() => {
        if (orderData && Array.isArray(orderData)) {
            orderData.forEach((line) => {
                if (line?.manualUpdateStatus) {
                    try {
                        const orderLineStatuss = JSON.parse(line.manualUpdateStatus);
                        setSubmittedOrderStatuses((prev) => ({
                            ...prev,
                            [line.id]: orderLineStatuss,
                        }));
                    } catch (e) {
                        console.error("Invalid JSON in manualUpdateStatus:", e);
                    }
                } else if (Array.isArray(line?.comment)) {
                    // Tags are saved as Comments records with a `status` JSON field
                    const statusComments = line.comment
                        .filter(c => c.status)
                        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                    if (statusComments.length > 0) {
                        try {
                            const tags = JSON.parse(statusComments[0].status);
                            if (Array.isArray(tags)) {
                                setSubmittedOrderStatuses((prev) => ({
                                    ...prev,
                                    [line.id]: tags,
                                }));
                            }
                        } catch (e) {
                            console.error("Invalid JSON in comment.status:", e);
                        }
                    }
                }
            });
        }
    }, [orderData])

    const [newOrders, setNewOrders] = useState(true);
    const [newOrdersData, setNewOrdersData] = useState([]);

    const earliestPromisedDateByOrderNum = useMemo(() => {
        const map = new Map();
        const datesByOrder = new Map();
        const addLine = (item) => {
            const orderNum = item?.order?.ordernum;
            if (orderNum == null || orderNum === '') return;
            if (archivedOrderIds.has(item.id) || archivedOrderIds.has(String(item.id))) return;
            const date = String(item?.promisedate || '').trim();
            if (!date) return;
            const key = String(orderNum);
            const list = datesByOrder.get(key);
            if (list) list.push(date);
            else datesByOrder.set(key, [date]);
        };

        if (Array.isArray(orderData)) orderData.forEach(addLine);
        if (Array.isArray(newOrdersData)) newOrdersData.forEach(addLine);
        Object.values(orderDetailsData || {}).forEach((value) => {
            if (Array.isArray(value)) value.forEach(addLine);
        });

        datesByOrder.forEach((dates, key) => {
            map.set(key, dates.reduce((earliest, current) => {
                const earliestDate = new Date(earliest);
                const currentDate = new Date(current);
                if (isNaN(earliestDate.getTime())) return current;
                if (isNaN(currentDate.getTime())) return earliest;
                return currentDate < earliestDate ? current : earliest;
            }));
        });
        return map;
    }, [orderData, newOrdersData, orderDetailsData, archivedOrderIds]);
    promisedDateByOrderNumRef.current = earliestPromisedDateByOrderNum;


    // New state for Order Status dropdown
    // const [orderStatusSelections, setOrderStatusSelections] = useState({});
    const [dropdownOpen, setDropdownOpen] = useState({});

    // Handle Order Status dropdown toggle
    // const toggleDropdown = (lineId) => {
    //     ////console.log('toggleDropdown called with lineId:', lineId);
    //     console.log('Current dropdownOpen state:', dropdownOpen);

    //     setDropdownOpen(prev => {
    //         console.log('Previous state:', prev);
    //         // If this dropdown is already open, close it
    //         if (prev[lineId]) {
    //             const newState = { ...prev };
    //             delete newState[lineId];
    //             console.log('Closing dropdown, new state:', newState);
    //             return newState;
    //         } else {
    //             // Close all other dropdowns and open only this one
    //             const newState = { [lineId]: true };
    //             console.log('Opening dropdown, new state:', newState);
    //             return newState;
    //         }
    //     });
    // };

    // Handle Order Status tag selection
    const handleOrderStatusToggle = (lineId, tag) => {
        setOrderStatusSelections(prev => {
            const currentSelections = prev[lineId] || [];
            const isSelected = currentSelections.some(selection => selection.label === tag.label);

            if (isSelected) {
                // Remove tag if already selected
                return {
                    ...prev,
                    [lineId]: currentSelections.filter(selection => selection.label !== tag.label)
                };
            } else {
                // Add tag if not selected
                return {
                    ...prev,
                    [lineId]: [...currentSelections, tag]
                };
            }
        });

        // Don't close dropdown to allow multi-select
        // setDropdownOpenId(null);
    };

    // Handle individual tag deselection by clicking on the tag
    const handleTagDeselect = (lineId, tag) => {
        setTagsToDeselect(prev => {
            const currentDeselections = prev[lineId] || [];
            const isMarkedForDeselection = currentDeselections.some(t => t.label === tag.label);

            if (isMarkedForDeselection) {
                // Remove from deselection list
                return {
                    ...prev,
                    [lineId]: currentDeselections.filter(t => t.label !== tag.label)
                };
            } else {
                // Add to deselection list
                return {
                    ...prev,
                    [lineId]: [...currentDeselections, tag]
                };
            }
        });
    };

    // Check if there are changes to submit
    const hasChangesToSubmit = (lineId) => {
        const currentSelections = orderStatusSelections[lineId] || [];
        const submittedSelections = submittedOrderStatuses[lineId] || [];
        const tagsToRemove = tagsToDeselect[lineId] || [];

        // Check if there are new selections to submit
        const hasNewSelections = currentSelections.length > 0;

        // Check if there are tags marked for deselection
        const hasTagsToDeselect = tagsToRemove.length > 0;

        return hasNewSelections || hasTagsToDeselect;
    };

    /** Push a committed order status into every piece of grid state that renders it.
     *  Shared by the local submit path and by remote saves arriving over presence. */
    const applyOrderStatusPatch = useCallback((lineId, newSubmitted) => {
        const lineIdStr = String(lineId);
        const statusJson = JSON.stringify(newSubmitted);
        const applyManualStatus = (prevOrders) => {
            if (!Array.isArray(prevOrders)) return prevOrders;
            return prevOrders.map((o) => (
                String(o.id) === lineIdStr ? { ...o, manualUpdateStatus: statusJson } : o
            ));
        };

        setOrderStatusSelections((prev) => ({ ...prev, [lineId]: [], [lineIdStr]: [] }));
        setSubmittedOrderStatuses((prev) => ({ ...prev, [lineId]: newSubmitted, [lineIdStr]: newSubmitted }));
        setTagsToDeselect((prev) => ({ ...prev, [lineId]: [], [lineIdStr]: [] }));
        setOrderData(applyManualStatus);
        setNewOrdersData(applyManualStatus);
    }, []);

    // Handle Order Status submission/deselection
    const handleOrderStatusSubmit = async (lineId) => {
        const statusLockedBy = orderStatusLockOwner(lineId);
        if (statusLockedBy) {
            alert(`${statusLockedBy.name} is changing this order status. Try again in a moment.`);
            return;
        }

        // Save selected statuses to backend but do NOT trigger a full refresh.
        const currentSelections = orderStatusSelections[lineId] || orderStatusSelections[String(lineId)] || [];
        const submittedSelections = submittedOrderStatuses[lineId] || submittedOrderStatuses[String(lineId)] || [];
        const tagsToRemove = tagsToDeselect[lineId] || tagsToDeselect[String(lineId)] || [];

        let newSubmitted = Array.isArray(submittedSelections) ? [...submittedSelections] : [];

        if (tagsToRemove.length > 0) {
            newSubmitted = newSubmitted.filter(
                tag => !tagsToRemove.some(removeTag => removeTag.label === tag.label)
            );
        }

        if (currentSelections.length > 0) {
            currentSelections.forEach(sel => {
                if (!newSubmitted.some(t => t.label === sel.label)) {
                    newSubmitted.push(sel);
                }
            });
        }

        const lineIdStr = String(lineId);

        // Apply the tag in the UI immediately so PO Review (and charcoal rows) do not wait on the API.
        setDropdownOpenId(null);
        applyOrderStatusPatch(lineId, newSubmitted);

        try {
            await saveComment({
                status: JSON.stringify(newSubmitted),
                orderLineId: lineId,
                // Names the user on the order history entry and on the PO Review
                // notification raised for Customer Service and the Warehouse.
                lastEditedBy: localStorage.getItem('userEmail')
                    || localStorage.getItem('email')
                    || localStorage.getItem('userName')
                    || ''
            });
            notifyOrderHistoryChanged(
                (Array.isArray(newOrdersData) ? newOrdersData : [])
                    .concat(Array.isArray(orderData) ? orderData : [])
                    .find((l) => String(l?.id) === lineIdStr)?.order?.ordernum
            );

            // Let everyone else on this page patch the same cell without a refresh.
            presence.broadcastSave({
                cell: orderStatusCell(lineId),
                kind: 'orderStatus',
                lineId: lineIdStr,
                value: newSubmitted,
            });
        } catch (err) {
            console.error('Failed to save order status:', err);
        }
    };

    // Handle clicking outside dropdown to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if click is outside any order status dropdown
            const isInsideDropdown = event.target.closest('.order-status-dropdown');
            if (!isInsideDropdown) {
                // Close all dropdowns when clicking outside
                setDropdownOpen({});
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);




    // const fetchOrders = async (index, maxRecords, search, singleOrder = false, orderNum = null, lineIds = null, ordernnum = null) => {
    //     setLoading(true);
    //     //const orders = await orderFetch(index, maxRecords, search, sortConfig.key, sortConfig.direction, null, '', '', '', '', '', '', '', '', '', true, true, "", orderNum);
    //     const orders = await orderFetch(index, maxRecords, search, sortConfig.key, sortConfig.direction, null, startDate, endDate, orderValue, POValue, PartNameValue, statusValue, ShippingMethodValue, CustomerId, CountryValue, viewBy, exports, lineIds, ordernnum);
    //     if (newOrders) {
    //         debugger
    //         const neword = await orderFetch(index, maxRecords, search, sortConfig.key, sortConfig.direction, null, startDate, endDate, orderValue, POValue, PartNameValue, statusValue, ShippingMethodValue, CustomerId, CountryValue, viewBy, exports, lineIds, ordernnum, newOrders);
    //         setNewOrders(false);

    //         // Apply client-side sorting to ensure proper date sorting for new orders
    //         const sortedNewOrdersData = neword.order.sort((a, b) => {
    //             const dateA = a.shipdate || a.orig_shipdate || '';
    //             const dateB = b.shipdate || b.orig_shipdate || '';

    //             // Handle empty dates
    //             if (!dateA && !dateB) return 0;
    //             if (!dateA) return 1;
    //             if (!dateB) return -1;

    //             // For date sorting, we need to ensure proper comparison
    //             if (sortConfig.key === 'orig_shipdate' || sortConfig.key === 'shipdate') {
    //                 if (sortConfig.direction === 'ascending') {
    //                     return dateA.localeCompare(dateB);
    //                 } else {
    //                     return dateB.localeCompare(dateA);
    //                 }
    //             }

    //             // For other fields, use default sorting
    //             if (sortConfig.direction === 'ascending') {
    //                 return dateA.localeCompare(dateB);
    //             } else {
    //                 return dateB.localeCompare(dateA);
    //             }
    //         });

    //         setNewOrdersData(sortedNewOrdersData);
    //     }
    //     if (orders === null) {
    //         return;
    //     }

    //     if (singleOrder === true) {
    //         setSingleOrderData(orders.order);
    //     } else {
    //         debugger
    //         // Apply client-side sorting to ensure proper date sorting
    //         const sortedOrderData = orders.order.sort((a, b) => {
    //             const dateA = a.shipdate || a.orig_shipdate || '';
    //             const dateB = b.shipdate || b.orig_shipdate || '';

    //             if (sortConfig.direction === 'ascending') {
    //                 return dateA.localeCompare(dateB);
    //             } else {
    //                 return dateB.localeCompare(dateA);
    //             }
    //         });

    //         setOrderData(sortedOrderData);
    //         if (orders.order && orders.order.length > 0 && orders.order[0].newOrders) {
    //             setNote(orders.order[0].newOrders);
    //         }
    //         setTotalRecords(orders.totalRecords);
    //     }
    //     setLoading(false);
    // };


    const fetchOrders = async (index, maxRecords, search, singleOrder = false, orderNum = null, lineIds = null, ordernnum = null) => {
        setLoading(true);
        //const orders = await orderFetch(index, maxRecords, search, sortConfig.key, sortConfig.direction, null, '', '', '', '', '', '', '', '', '', true, true, "", orderNum);
        const orders = await orderFetch(index, maxRecords, search, null, null, null, startDate, endDate, orderValue, POValue, PartNameValue, '', ShippingMethodValue, CustomerId, CountryValue, false, exports, lineIds, ordernnum);
        if (newOrders) {
            debugger
            const neword = await orderFetch(index, maxRecords, search, null, null, null, startDate, endDate, orderValue, POValue, PartNameValue, '', ShippingMethodValue, CustomerId, CountryValue, false, exports, lineIds, ordernnum, newOrders);
            setNewOrders(false);
            // Sort new orders by shipping date
            const sortedNewOrders = sortOrdersByShippingDate(neword.order, shippingDateSort);
            setNewOrdersData(sortedNewOrders);
            
            // Pre-fetch order details for new orders
            if (neword && neword.order && neword.order.length > 0) {
                prefetchOrderDetails(neword.order);
            }
        }
        if (orders === null) {
            return;
        }

        if (singleOrder === true) {
            setSingleOrderData(orders.order);
            // Update orderAccessLinks for single order data
            if (orders.order) {
                const newLinks = {};
                orders.order.forEach(line => {
                    if (line.folderUrl) {
                        newLinks[line.id] = [{
                            id: Date.now() + Math.random(),
                            url: line.folderUrl,
                            dateAdded: new Date().toLocaleDateString()
                        }];
                    }
                });
                setOrderAccessLinks(prev => ({ ...prev, ...newLinks }));
            }
        } else {
            debugger
            // Sort orders by shipping date
            const sortedOrders = sortOrdersByShippingDate(orders.order, shippingDateSort);
            setOrderData(sortedOrders);
            if (orders.order && orders.order.length > 0 && orders.order[0].newOrders) {
                setNote(orders.order[0].newOrders);
            }
            const currentTotal = typeof orders.totalRecords === 'number'
                ? orders.totalRecords
                : (Array.isArray(orders.order) ? orders.order.length : 0);
            setTotalRecords(currentTotal);
            if (currentTotal > 0) {
                setOverallTotalRecords((prevTotal) => {
                    if (prevTotal === 0) {
                        return currentTotal;
                    }
                    return Math.max(prevTotal, currentTotal);
                });
            }
            // Update orderAccessLinks for order data
            if (orders.order) {
                const newLinks = {};
                orders.order.forEach(line => {
                    if (line.folderUrl) {
                        newLinks[line.id] = [{
                            id: Date.now() + Math.random(),
                            url: line.folderUrl,
                            dateAdded: new Date().toLocaleDateString()
                        }];
                    }
                });
                setOrderAccessLinks(prev => ({ ...prev, ...newLinks }));
            }
        }
        setLoading(false);
        
        // Pre-fetch order details for missing parts calculation
        if (!singleOrder && orders && orders.order && orders.order.length > 0) {
            prefetchOrderDetails(orders.order);
        }
    };
    
    // Pre-fetch order details for all visible orders to populate missing parts data
    const prefetchOrderDetails = async (orders) => {
        if (!orders || orders.length === 0) return;
        
        // Get unique order numbers from the orders
        const uniqueOrderNums = [...new Set(orders.map(line => line.order?.ordernum).filter(Boolean))];
        
        // Fetch details for orders we don't have yet
        const detailsToFetch = uniqueOrderNums.filter(orderNum => !orderDetailsData[orderNum]);
        
        if (detailsToFetch.length === 0) return;
        
        // Fetch in batches to avoid overwhelming the API
        const batchSize = 5;
        for (let i = 0; i < detailsToFetch.length; i += batchSize) {
            const batch = detailsToFetch.slice(i, i + batchSize);
            
            // Fetch all orders in this batch in parallel
            const promises = batch.map(orderNum => 
                orderFetch(0, 10, "", "lineitem", "ascending", null, "", "", "", "", "", "", "", "", "", true, true, "", orderNum)
                    .catch(err => {
                        console.error(`Failed to fetch details for order ${orderNum}:`, err);
                        return null;
                    })
            );
            
            const results = await Promise.all(promises);
            
            // Update orderDetailsData with the fetched results
            const newDetailsData = {};
            results.forEach((result, index) => {
                if (result && result.order) {
                    newDetailsData[batch[index]] = stripArchivedBomParts(result.order);
                }
            });
            
            if (Object.keys(newDetailsData).length > 0) {
                setOrderDetailsData(prev => ({
                    ...prev,
                    ...newDetailsData
                }));
            }
        }
    };


    // const SyncAndfetchOrders = async (null, 0, '', false, null, null, null) => {


    //     const comment = await syncOrders(user);
    //     //const orders = await orderFetch(index, maxRecords, search, sortConfig.key, sortConfig.direction, null, '', '', '', '', '', '', '', CustomerId, '', viewBy, false, null, orderNum);
    //     const orders = await orderFetch(index, maxRecords, search, sortConfig.key, sortConfig.direction, null, startDate, endDate, orderValue, POValue, PartNameValue, statusValue, ShippingMethodValue, CustomerId, CountryValue, viewBy, exports, lineIds, ordernnum);
    //     if (newOrders) {
    //         debugger
    //         const neword = await orderFetch(index, maxRecords, search, sortConfig.key, sortConfig.direction, null, startDate, endDate, orderValue, POValue, PartNameValue, statusValue, ShippingMethodValue, CustomerId, CountryValue, viewBy, exports, lineIds, ordernnum, newOrders);
    //         setNewOrders(false);
    //         // Apply client-side sorting to ensure proper date sorting for new orders
    //         const sortedNewOrdersData = sortOrdersByDate([...neword.order], sortConfig);
    //         setNewOrdersData(sortedNewOrdersData);
    //     }
    //     if (orders === null) {
    //         return;
    //     }

    //     if (singleOrder === true) {
    //         setSingleOrderData(orders.order);
    //     } else {
    //         debugger
    //         // Apply client-side sorting to ensure proper date sorting
    //         const sortedOrderData = sortOrdersByDate([...orders.order], sortConfig);
    //         setOrderData(sortedOrderData);
    //         if (orders.order && orders.order.length > 0 && orders.order[0].newOrders) {
    //             setNote(orders.order[0].newOrders);
    //         }
    //         setTotalRecords(orders.totalRecords);
    //     }
    //     setLoading(false);
    // };

    const fetchOrdersSearch = async (index, maxRecords, search, lineIds = null, ordernnum = null) => {
        debugger;
        setLoading(true);
        const orders = await orderFetch(index, maxRecords, search, null, null, null, startDate, endDate, orderValue, POValue, PartNameValue, '', ShippingMethodValue, CustomerId, CountryValue, false, exports, lineIds, ordernnum);

        if (orders === null) {
            return;
        }
        setOrderData(orders.order);
        setTotalRecords(orders.totalRecords);

        // Pre-fetch order details for missing parts calculation
        if (orders && orders.order && orders.order.length > 0) {
            prefetchOrderDetails(orders.order);
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchStatusData();
    }, []);

    // Auto-refresh function - reloads orders data silently without authorization checks
    const handleAutoRefresh = async () => {
        // Reload orders with current filters and page settings
        await fetchOrders(0, itemsPerPage === -1 ? 1000 : itemsPerPage * currentPage, searchTerm, false, null, null, null);
    };

    // Shared auto-refresh countdown (10 minutes) - refreshes orders when it reaches zero
    const { timerFormatted, restartTimer } = useAutoRefreshTimer(handleAutoRefresh, AUTO_REFRESH_INTERVAL_SECONDS);

    const handleManualPageRefresh = async () => {
        setIsManualRefreshing(true);
        try {
            await handleAutoRefresh();
            // Restart the countdown after manual refresh.
            restartTimer();
        } catch (error) {
            console.error('Manual refresh error:', error);
            throw error;
        } finally {
            setIsManualRefreshing(false);
        }
    };

    // Re-sort data when sort direction changes
    useEffect(() => {
        if (newOrdersData && newOrdersData.length > 0) {
            let sorted;
            if (columnSort.key && columnSort.direction) {
                sorted = sortOrdersByColumn([...newOrdersData], columnSort.key, columnSort.direction);
            } else {
                sorted = sortOrdersByShippingDate([...newOrdersData], shippingDateSort);
            }
            setNewOrdersData(sorted);
        }
        if (orderData && orderData.length > 0) {
            let sorted;
            if (columnSort.key && columnSort.direction) {
                sorted = sortOrdersByColumn([...orderData], columnSort.key, columnSort.direction);
            } else {
                sorted = sortOrdersByShippingDate([...orderData], shippingDateSort);
            }
            setOrderData(sorted);
        }
    }, [shippingDateSort, columnSort]);


    // Re-sort new orders data when sort configuration changes
    // useEffect(() => {
    //     if (newOrdersData.length > 0 && sortConfig.key && sortConfig.direction) {
    //         const sortedNewOrders = [...newOrdersData].sort((a, b) => {
    //             const dateA = a.shipdate || a.orig_shipdate || '';
    //             const dateB = b.shipdate || b.orig_shipdate || '';

    //             // Handle empty dates
    //             if (!dateA && !dateB) return 0;
    //             if (!dateA) return 1;
    //             if (!dateB) return -1;

    //             // For date sorting, we need to ensure proper comparison
    //             if (sortConfig.key === 'orig_shipdate' || sortConfig.key === 'shipdate') {
    //                 if (sortConfig.direction === 'ascending') {
    //                     return dateA.localeCompare(dateB);
    //                 } else {
    //                     return dateB.localeCompare(dateA);
    //                 }
    //             }

    //             // For other fields, use default sorting
    //             if (sortConfig.direction === 'ascending') {
    //                 return dateA.localeCompare(dateB);
    //             } else {
    //                 return dateB.localeCompare(dateA);
    //             }
    //         });
    //         setNewOrdersData(sortedNewOrders);
    //     }
    // }, [sortConfig.key, sortConfig.direction]);

    const fetchStatusData = async () => {
        const status = await getStatus();

        if (status && status.length > 0) {
            setSelectBoxAppend(status);
        }
    };

    useEffect(() => {
        setCustomerId(path);
        if (refresh === true) {
            return;
        }

        const pageSize = itemsPerPage === -1 ? -1 : itemsPerPage;
        const startIndex = itemsPerPage === -1 ? 0 : (currentPage - 1) * itemsPerPage;

        fetchOrders(startIndex, pageSize, searchTerm, false, null, null, null);
    }, [currentPage, itemsPerPage, searchTerm]);

    const handleOrderStatusChange = (lineId, newStatus) => {
        setorderStatus((prevStatus) => ({
            ...prevStatus,
            [lineId]: newStatus,
        }));
    };

    const [refresh, setRefresh] = useState(false);

    // Handler for toggling Order Status tags in filter
    const handleOrderStatusTagToggle = (tag) => {
        setSelectedOrderStatusTags(prev => {
            const isSelected = prev.some(t => t.label === tag.label);
            if (isSelected) {
                return prev.filter(t => t.label !== tag.label);
            } else {
                return [...prev, tag];
            }
        });
    };

    // Handler for toggling Line Status tags in filter
    const handleLineStatusTagToggle = (tag) => {
        setSelectedLineStatusTags(prev => {
            const isSelected = prev.some(t => t.label === tag.label);
            if (isSelected) {
                return prev.filter(t => t.label !== tag.label);
            } else {
                return [...prev, tag];
            }
        });
    };

    // Close filter dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (orderStatusFilterDropdownOpen && !event.target.closest('.order-status-filter-dropdown')) {
                setOrderStatusFilterDropdownOpen(false);
            }
            if (lineStatusFilterDropdownOpen && !event.target.closest('.line-status-filter-dropdown')) {
                setLineStatusFilterDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [orderStatusFilterDropdownOpen, lineStatusFilterDropdownOpen]);

    // WO# search effect
    useEffect(() => {
        if (useEffectWO.trim() === '') {
            setWOSearch([]);
            return;
        }

        const searchWO = async () => {
            try {
                const searchResults = await orderFetch('0', '-1', '', null, null, null, '', '', '', '', '', '', '', '', '', false, false, null, null);
                if (searchResults && searchResults.order) {
                    const filtered = searchResults.order.filter(item => 
                        item.order?.woNum && 
                        item.order.woNum.toString().toLowerCase().includes(useEffectWO.toLowerCase())
                    );
                    setWOSearch(filtered);
                }
            } catch (error) {
                console.error('Error searching WO#:', error);
            }
        };

        const timeoutId = setTimeout(searchWO, 300);
        return () => clearTimeout(timeoutId);
    }, [useEffectWO, orderFetch]);

    const handleRefresh = async () => {
        setRefresh(true);
        setSearchTerm('');
        setTempSearchTerm('');
        setCurrentPage(1);
        setOrderValue('');
        setPOValue('');
        setPartNameValue('');
        setCustomerValue('');
        setShippingMethodValue('');
        setCountryValue('');
        setWOValue('');
        setSelectedOrderStatusTags([]);
        setSelectedLineStatusTags([]);
        setExports(false);
        setStartDate('');
        setEndDate('');
        setAssembliesFilter(false);
        setWeekFilter(false);
        setMonthFilter(false);
        setKpiQuickFilter(null);
        clearOrdersFilterState(ORDERS_FILTER_STATE_STORAGE_KEY);
        setRefresh(false);
        setItemsPerPage(-1);

    };

    const searchOrder = (value) => {
        setSearchTerm(value);
        setCurrentPage(1); // Reset to first page on new search
    };

    const toggleRowExpansion = (orderId) => {
        setExpandedRows(prev =>
            prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]
        );
    };

    const getCountryNameById = (id) => {
        const country = countriesData.find(country => country.Id == id);
        return country ? country.Country_Name : 'N/A';
    };

    const getShipmentMethodById = (id) => {
        const shipment = shipmentData.find(ship => ship.Id == id);
        return shipment ? shipment.MethodOfShipment : 'N/A';
    };
    const getStatusById = (id) => {
        const status = statuses.find(ship => ship.Id == id);
        return status ? status.status : 'N/A';
    };

    const UPS_SHIPPING_LINK = 'https://www.ups.com/ship/basic/shipment-info?tx=20678219171053728&loc=en_US&promoCodeAlias=sPArk&WT.srch=1';
    const FEDEX_SHIPPING_LINK = 'https://www.fedex.com/secure-login/en-us/#/credentials';

    const renderShippingMethodCell = (methodText) => {
        const text = methodText || 'N/A';
        const lower = String(text).toLowerCase();
        if (lower.includes('fedex')) {
            return <a href={FEDEX_SHIPPING_LINK} target="_blank" rel="noopener noreferrer">{text}</a>;
        }
        if (lower.includes('ups')) {
            return <a href={UPS_SHIPPING_LINK} target="_blank" rel="noopener noreferrer">{text}</a>;
        }
        return text;
    };

    const getLineReportPercentage = (report) => {
        const parsedPercentage = Number(report?.percentage);
        const count = parseInt(report?.count, 10) || 0;
        const totalCount = parseInt(report?.totalCount, 10) || 0;

        if (!Number.isNaN(parsedPercentage) && Number.isFinite(parsedPercentage)) {
            return parsedPercentage;
        }

        if (totalCount > 0) {
            return Math.round((count / totalCount) * 100);
        }

        return 0;
    };

    const normalizeLineStatusKey = (status) => {
        const key = String(status || '').trim().toLowerCase();
        return key === 'stagging cart' ? 'staging cart' : key;
    };

    const formatLineStatusDisplayLabel = (status) => {
        if (normalizeLineStatusKey(status) === 'staging cart') return 'Staging Cart';
        return String(status || '').trim();
    };

    const collectLineStatusLabelsForReport = (line) => {
        const ordered = [];
        const seen = new Set();

        const add = (raw) => {
            const label =
                typeof raw === 'string'
                    ? raw.trim()
                    : String(raw?.label || '').trim();
            if (!label) return;
            const key = normalizeLineStatusKey(label);
            if (seen.has(key)) return;
            seen.add(key);
            ordered.push(formatLineStatusDisplayLabel(label));
        };

        (line?.lineStatuses || []).forEach((s) =>
            add(typeof s === 'string' ? s : s?.label ?? s)
        );

        if (line?.lineItemStatus) {
            try {
                const parsed = JSON.parse(line.lineItemStatus);
                if (Array.isArray(parsed)) {
                    parsed.forEach((s) =>
                        add(typeof s === 'string' ? s : s?.label ?? s)
                    );
                }
            } catch {
                /* ignore invalid JSON */
            }
        }

        (submittedLineStatuses[line.id] || []).forEach((t) =>
            add(typeof t === 'string' ? t : t?.label ?? t)
        );

        (lineStatusSelections[line.id] || []).forEach((t) =>
            add(typeof t === 'string' ? t : t?.label ?? t)
        );

        return ordered;
    };

    const getMergedLineStatusReportRows = (line) => {
        const base = Array.isArray(line?.orderReport) ? [...line.orderReport] : [];
        const existing = new Set(base.map((r) => normalizeLineStatusKey(r?.status)));

        collectLineStatusLabelsForReport(line).forEach((label) => {
            const key = normalizeLineStatusKey(label);
            if (!existing.has(key)) {
                existing.add(key);
                base.push({
                    status: label,
                    count: 1,
                    totalCount: 1
                });
            }
        });

        return base;
    };

    const getOrderLinesForReport = (orderNum) => {
        if (!orderNum) return [];
        const fromDetails = orderDetailsData[orderNum];
        if (Array.isArray(fromDetails) && fromDetails.length > 0) {
            return fromDetails;
        }
        return (orderData || []).filter((l) => String(l?.order?.ordernum) === String(orderNum));
    };

    const lineHasStatusTag = (ln, statusLabel) => {
        const key = normalizeLineStatusKey(statusLabel);
        return collectLineStatusLabelsForReport(ln).some(
            (lab) => normalizeLineStatusKey(lab) === key
        );
    };

    const getOrderAggregatedLineStatusReportRows = (orderNum) => {
        const lines = getOrderLinesForReport(orderNum);
        if (lines.length === 0) return null;

        const orderKeys = [];
        const keyToDisplayLabel = new Map();

        const register = (displayLabel) => {
            const canonical = formatLineStatusDisplayLabel(displayLabel);
            const k = normalizeLineStatusKey(canonical);
            if (!k) return;
            if (!keyToDisplayLabel.has(k)) {
                keyToDisplayLabel.set(k, canonical);
                orderKeys.push(k);
            }
        };

        lines.forEach((ln) => {
            (ln.orderReport || []).forEach((r) => {
                if (r?.status) register(r.status);
            });
        });

        lines.forEach((ln) => {
            collectLineStatusLabelsForReport(ln).forEach(register);
        });

        const total = lines.length;
        const rows = orderKeys.map((k) => {
            const display = keyToDisplayLabel.get(k);
            const count = lines.filter((ln) => lineHasStatusTag(ln, display)).length;
            const pct = total > 0 ? Math.round((count / total) * 10000) / 100 : 0;
            return {
                status: display,
                count,
                totalCount: total,
                percentage: pct
            };
        });

        return rows.filter((r) => (parseInt(r.count, 10) || 0) > 0);
    };

    /** Multi-line orders: count = lines that have the tag. Single-line: merged row logic with independent per-tag percentages. */
    const getDisplayLineStatusReportRows = (line) => {
        const orderNum = line?.order?.ordernum;
        const lines = getOrderLinesForReport(orderNum);
        if (lines.length > 1) {
            const agg = getOrderAggregatedLineStatusReportRows(orderNum);
            if (agg && agg.length > 0) {
                return agg;
            }
        }
        return getMergedLineStatusReportRows(line);
    };

    const handleKeyPress = (event) => {
        if (event.key !== 'Enter') {
            return;
        }

        const pageSize = itemsPerPage === -1 ? -1 : itemsPerPage;
        const startIndex = itemsPerPage === -1 ? 0 : (currentPage - 1) * itemsPerPage;

        fetchOrders(startIndex, pageSize, searchTerm, false, null, null, null);
    };

    const handleCommentChange = (lineId, newComment) => {
        setCommentsMap(prev => ({
            ...prev,
            [lineId]: newComment
        }));
    };


    // Enhanced comment management functions
    const handleDeleteComment = async (lineId, commentId) => {
        // First, try to delete from backend if this is a saved comment
        try {
            await deleteComment(commentId, lineId);
        } catch (error) {
            console.error('Error deleting comment from backend:', error);
            // Continue to update local state even if backend call fails
        }
        
        // Update local commentsMap state to remove the comment
        setCommentsMap(prev => {
            const currentComments = prev[lineId] || [];
            const updatedComments = currentComments.filter((comment) => {
                if (!comment || typeof comment !== 'object') return false;
                const existingId = comment.id;
                return String(existingId) !== String(commentId);
            });
            return {
                ...prev,
                [lineId]: updatedComments
            };
        });
        
        // Update orderData to remove the comment from line.comment array
        setOrderData(prevOrders => {
            if (!Array.isArray(prevOrders)) return prevOrders;
            return prevOrders.map(line => {
                if (line.id === lineId && Array.isArray(line.comment)) {
                    return {
                        ...line,
                        comment: line.comment.filter(c => String(c.id) !== String(commentId))
                    };
                }
                return line;
            });
        });
        
        // Update newOrdersData to remove the comment from line.comment array
        setNewOrdersData(prevOrders => {
            if (!Array.isArray(prevOrders)) return prevOrders;
            return prevOrders.map(line => {
                if (line.id === lineId && Array.isArray(line.comment)) {
                    return {
                        ...line,
                        comment: line.comment.filter(c => String(c.id) !== String(commentId))
                    };
                }
                return line;
            });
        });
    };

    const handleResolveThread = (lineId, commentId = null) => {
        setCommentsMap(prev => {
            const currentComments = prev[lineId] || [];
            let updatedComments;

            if (commentId !== null) {
                // Resolve specific comment
                updatedComments = currentComments.map((comment, index) =>
                    index === commentId ? { ...comment, resolved: true } : comment
                );
            } else {
                // Resolve all comments in the thread
                updatedComments = currentComments.map(comment => ({ ...comment, resolved: true }));
            }

            return {
                ...prev,
                [lineId]: updatedComments
            };
        });
    };

    // Helper function to sort comments by date/time in descending order (most recent first)
    const sortCommentsByDate = (comments) => {
        if (!Array.isArray(comments) || comments.length === 0) return comments;
        return [...comments].sort((a, b) => {
            // Try to parse date and time from comment objects
            const dateA = a.dateStr && a.timeStr ? new Date(`${a.dateStr} ${a.timeStr}`) : 
                         a.createdAt ? new Date(a.createdAt) : 
                         a.date ? new Date(a.date) : new Date(0);
            const dateB = b.dateStr && b.timeStr ? new Date(`${b.dateStr} ${b.timeStr}`) : 
                         b.createdAt ? new Date(b.createdAt) : 
                         b.date ? new Date(b.date) : new Date(0);
            // Return descending order (most recent first)
            return dateB - dateA;
        });
    };

    /** Merge one saved comment into commentsMap. Shared by the local add path and
     *  by remote adds arriving over presence. */
    const applyCommentPatch = useCallback((lineId, commentToStore) => {
        if (!commentToStore) return;
        setCommentsMap(prev => {
            const currentComments = prev[lineId] || [];
            const filtered = currentComments.filter(c => c && c.id !== commentToStore.id);
            return {
                ...prev,
                [lineId]: [...filtered, commentToStore]
            };
        });
    }, []);

    const handleAddComment = (lineId, newComment, status = "pending") => {
        const currentUser = localStorage.getItem('userEmail') || localStorage.getItem('userName') || 'Current User';
        const commentToStore = toStoredComment(newComment, status, { lastEditedBy: currentUser });

        applyCommentPatch(lineId, commentToStore);

        const line = findOrderLineById(lineId, [newOrdersData, orderData], orderDetailsData);
        // Everyone else, on any page, gets a minimized blue chat for this note.
        presence.broadcastSave({
            cell: notesCell(lineId),
            kind: 'comment',
            lineId: String(lineId),
            orderNumber: line?.order?.ordernum || line?.ordernum || '',
            customerName: line?.order?.customer?.name || '',
            value: commentToStore,
        });
    };

    const resolveAddedOrderUrlItem = (response, url, urlName) => {
        const payload = (response && typeof response === 'object' && response.data && typeof response.data === 'object' && !Array.isArray(response.data))
            ? response.data
            : response;
        return {
            id: payload?.id ?? payload?.urlId ?? Date.now(),
            url: payload?.url || url,
            urlName: payload?.urlName || urlName,
        };
    };

    const patchOrderUrlsForOrder = (ordernum, updater) => {
        const patchList = (list) => {
            if (!Array.isArray(list)) return list;
            return list.map((line) => {
                if (String(line?.order?.ordernum) !== String(ordernum)) return line;
                const current = Array.isArray(line.order?.orderUrls) ? line.order.orderUrls : [];
                return {
                    ...line,
                    order: {
                        ...line.order,
                        orderUrls: updater(current),
                    },
                };
            });
        };
        setOrderData((prev) => patchList(prev));
        setNewOrdersData((prev) => patchList(prev));
        setSelectedOrder((prev) => patchList(prev));
        setSelectedSourceLine((prev) => {
            if (!prev || String(prev?.order?.ordernum) !== String(ordernum)) return prev;
            const current = Array.isArray(prev.order?.orderUrls) ? prev.order.orderUrls : [];
            return {
                ...prev,
                order: {
                    ...prev.order,
                    orderUrls: updater(current),
                },
            };
        });
        setSelectedOrderForAccess((prev) => {
            if (!prev || String(prev?.order?.ordernum) !== String(ordernum)) return prev;
            const current = Array.isArray(prev.order?.orderUrls) ? prev.order.orderUrls : [];
            return {
                ...prev,
                order: {
                    ...prev.order,
                    orderUrls: updater(current),
                },
            };
        });
    };

    // Order Access functions
    const handleOrderAccessClick = (line) => {
        setSelectedOrderForAccess(line);
        setShowOrderAccessModal(true);
        setNewLinkUrl('');
        setNewLinkUrlName('');
    };

    // const handleAddOrderAccessLink = () => {
    //     if (!newLinkUrl.trim()) {
    //         alert('Please enter a URL');
    //         return;
    //     }

    //     // Validate URL format
    //     try {
    //         new URL(newLinkUrl);
    //     } catch {
    //         alert('Please enter a valid URL (include http:// or https://)');
    //         return;
    //     }

    //     const newLink = {
    //         id: Date.now(),
    //         url: newLinkUrl.trim(),
    //         dateAdded: new Date().toLocaleDateString()
    //     };

    //     setOrderAccessLinks(prev => {
    //         const currentLinks = prev[selectedOrderForAccess.id] || [];
    //         return {
    //             ...prev,
    //             [selectedOrderForAccess.id]: [...currentLinks, newLink]
    //         };
    //     });

    //     setNewLinkUrl('');
    // };

    const handleAddOrderAccessLink = async () => {
        if (!newLinkUrlName.trim()) {
            alert('Please enter a URL name');
            return;
        }

        if (!newLinkUrl.trim()) {
            alert('Please enter a URL');
            return;
        }

        // Validate URL format
        try {
            new URL(newLinkUrl);
        } catch {
            alert('Please enter a valid URL (include http:// or https://)');
            return;
        }

        try {
            const ordernum = selectedOrderForAccess?.order?.ordernum
                || selectedOrderForAccess?.ordernum
                || '';
            const urlName = newLinkUrlName.trim();
            const changedBy = localStorage.getItem('userEmail')
                || localStorage.getItem('email')
                || localStorage.getItem('userName')
                || '';
            // Prepare the data to send in the request
            const requestData = {
                action: 'add',
                ordernum,
                url: newLinkUrl.trim(),
                urlName,
                orderLineId: selectedOrderForAccess.id,
                lastEditedBy: changedBy,
            };

            // Make API call to the new endpoint
            const response = await manageOrderUrl(requestData);

            // If the API call is successful, refetch the orders to get updated URLs
            if (response) {
                const existingUrls = selectedOrderForAccess?.order?.orderUrls;
                const previousUrlName = Array.isArray(existingUrls) && existingUrls.length > 0
                    ? String(existingUrls[existingUrls.length - 1]?.urlName || '').trim()
                    : '';
                recordOrderAccessHistoryHint({
                    ordernum,
                    action: 'add',
                    urlName,
                    previousUrlName,
                    changedBy,
                    orderLineId: selectedOrderForAccess.id,
                });
                setNewLinkUrl('');
                setNewLinkUrlName('');
                notifyOrderHistoryChanged(ordernum);
                const addedItem = resolveAddedOrderUrlItem(response, newLinkUrl.trim(), urlName);
                patchOrderUrlsForOrder(ordernum, (urls) => {
                    if (urls.some((item) => String(item.id) === String(addedItem.id))) return urls;
                    return [...urls, addedItem];
                });
                alert('URL added successfully');
            } else {
                alert('Failed to save URL. Please try again.');
            }
        } catch (error) {
            console.error('Error saving URL:', error);
            alert('Error saving URL. Please try again.');
        }
    };

    const handleDeleteOrderAccessLink = async (lineId, linkId, ordernum = null, urlName = '') => {
        try {
            // Get order number from parameter or from selectedOrderForAccess if in modal context
            const order = ordernum || selectedOrderForAccess?.order?.ordernum || selectedOrderForAccess?.ordernum;
            
            if (!order) {
                alert('Order number not found. Please try again.');
                return;
            }

            const changedBy = localStorage.getItem('userEmail')
                || localStorage.getItem('email')
                || localStorage.getItem('userName')
                || '';

            // Prepare the data to send in the request
            const requestData = {
                action: 'delete',
                ordernum: order,
                id: linkId,
                orderLineId: lineId,
                lastEditedBy: changedBy,
            };

            // Make API call to delete the URL
            const response = await manageOrderUrl(requestData);

            // If the API call is successful, show success message and refetch
            if (response) {
                recordOrderAccessHistoryHint({
                    ordernum: order,
                    action: 'delete',
                    urlName: String(urlName || '').trim(),
                    previousUrlName: String(urlName || '').trim(),
                    changedBy,
                    orderLineId: lineId,
                });
                notifyOrderHistoryChanged(order);
                patchOrderUrlsForOrder(order, (urls) => urls.filter((item) => String(item.id) !== String(linkId)));
                alert('URL deleted successfully');
                // Refetch orders to get updated orderURLS
                const pageSize = itemsPerPage === -1 ? -1 : itemsPerPage;
                const startIndex = itemsPerPage === -1 ? 0 : (currentPage - 1) * itemsPerPage;
                await fetchOrders(startIndex, pageSize, searchTerm, false, null, null, null);
            } else {
                alert('Failed to delete URL. Please try again.');
            }
        } catch (error) {
            console.error('Error deleting URL:', error);
            alert('Error deleting URL. Please try again.');
        }
    };

    const handleCloseOrderAccessModal = () => {
        setShowOrderAccessModal(false);
        setSelectedOrderForAccess(null);
        setNewLinkUrl('');
        setNewLinkUrlName('');
        setCopiedField(null);
        if (copyTimeoutRef.current) {
            clearTimeout(copyTimeoutRef.current);
            copyTimeoutRef.current = null;
        }
    };

    // Archive functions
    const handleArchiveOrder = async (line) => {
        const orderNumber = line?.order?.ordernum;
        if (!orderNumber) {
            console.error('Missing order number for archive');
            return;
        }

        const confirmed = window.confirm(`Are you sure you want to archive order ${orderNumber}?`);
        if (!confirmed) {
            return;
        }

        try {
            const result = await updateArchiveOrder(orderNumber, true);
            if (result?.success) {
                // Keep local archive state in sync for filtering/UI until data reloads
                setArchivedOrderNums(prev => {
                    const newSet = new Set(prev);
                    newSet.add(String(orderNumber));
                    return newSet;
                });

                setArchivedOrdersData(prev => {
                    const existingIndex = prev.findIndex(archived => archived.id === line.id);
                    if (existingIndex === -1) {
                        return [...prev, line];
                    }
                    const updated = [...prev];
                    updated[existingIndex] = line;
                    return updated;
                });

                const pageSize = itemsPerPage === -1 ? -1 : itemsPerPage;
                const startIndex = itemsPerPage === -1 ? 0 : (currentPage - 1) * itemsPerPage;
                await fetchOrders(startIndex, pageSize, searchTerm, false, null, null, null);
            } else {
                alert(result?.message || 'Failed to archive order.');
            }
        } catch (err) {
            console.error('Error archiving order:', err);
            alert('Error archiving order. Please try again.');
        }
    };

    const handleArchiveOrderLineItem = async (line) => {
        const orderLineItemId = line?.id;
        const orderNumber = line?.order?.ordernum || line?.ordernum;

        if (!orderLineItemId) {
            console.error('Missing order line item ID for archive');
            return;
        }

        const confirmed = window.confirm(`Are you sure you want to archive order ${orderNumber} line ${line?.lineitem || ''}?`);
        if (!confirmed) {
            return;
        }

        try {
            const result = await updateArchiveOrderLineItem(orderLineItemId, true);
            if (result?.success) {
                setArchivedOrderIds(prev => {
                    const newSet = new Set(prev);
                    newSet.add(orderLineItemId);
                    return newSet;
                });

                setArchivedOrdersData(prev => {
                    const existingIndex = prev.findIndex(archived => archived.id === orderLineItemId);
                    if (existingIndex === -1) {
                        return [...prev, line];
                    }
                    const updated = [...prev];
                    updated[existingIndex] = line;
                    return updated;
                });

                const pageSize = itemsPerPage === -1 ? -1 : itemsPerPage;
                const startIndex = itemsPerPage === -1 ? 0 : (currentPage - 1) * itemsPerPage;
                await fetchOrders(startIndex, pageSize, searchTerm, false, null, null, null);
            } else {
                alert(result?.message || 'Failed to archive order line item.');
            }
        } catch (err) {
            console.error('Error archiving order line item:', err);
            alert('Error archiving order line item. Please try again.');
        }
    };

    // Archive a single BOM part line (used for duplicate BOM component parts).
    const handleArchiveBomPart = async (bomPartId, archived, orderNum) => {
        if (!bomPartId) {
            console.error('Missing BOM part ID for archive');
            return;
        }

        const action = archived ? 'archive' : 'unarchive';
        const confirmed = window.confirm(`Are you sure you want to ${action} this BOM part line?`);
        if (!confirmed) {
            return;
        }

        try {
            const result = await updateArchiveBomPart(bomPartId, archived);
            if (result?.success) {
                const applyArchiveToLines = (lines) => {
                    if (!Array.isArray(lines)) return lines;
                    return lines.map((item) => {
                        const bomParts = item?.bom?.bomParts;
                        if (!Array.isArray(bomParts)) return item;
                        let changed = false;
                        const nextBomParts = bomParts.map((bom) => {
                            if (bom?.id === bomPartId) {
                                changed = true;
                                return { ...bom, archived };
                            }
                            return bom;
                        });
                        if (!changed) return item;
                        return { ...item, bom: { ...item.bom, bomParts: nextBomParts } };
                    });
                };

                if (orderNum) {
                    setOrderDetailsData(prev => {
                        const existing = prev?.[orderNum];
                        if (!existing) return prev;
                        return { ...prev, [orderNum]: applyArchiveToLines(existing) };
                    });
                }

                setSelectedOrder(prev => (Array.isArray(prev) ? applyArchiveToLines(prev) : prev));
            } else {
                alert(result?.message || 'Failed to update BOM part archive status.');
            }
        } catch (err) {
            console.error('Error updating BOM part archive status:', err);
            alert('Error updating BOM part archive status. Please try again.');
        }
    };


    const getRowStyle = (date) => {
        if (!date) return {};
        
        // Parse the shipping date (format: yyyy-MM-dd)
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
        
        // Parse date string (yyyy-MM-dd format) to avoid timezone issues
        const dateParts = String(date).split('-');
        const targetDate = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
        targetDate.setHours(0, 0, 0, 0); // Reset time to start of day
        
        const timeDiff = targetDate - today;
        const diffDays = Math.round(timeDiff / (1000 * 60 * 60 * 24));

        // Only apply colors for today and future dates (diffDays >= 0), not past dates
        if (diffDays < 0) {
            return {}; // Past dates - no color
        }

        // Red: Today (diffDays === 0) and tomorrow (diffDays === 1) - the 2 days before shipping date
        // If today is Jan 13, then Jan 13 (today) and Jan 14 (tomorrow) should show red
        if (diffDays === 0 || diffDays === 1) {
            return { style: { backgroundColor: '#f8d7da' } }; // Light red - today and tomorrow
        } else if (diffDays <= 7) {
            return { style: { backgroundColor: '#fff3cd' } }; // Light yellow - 1 week before shipping date (2-7 days)
        } else if (diffDays <= 30) {
            return { style: { backgroundColor: '#d1ecf1' } }; // Light cyan - 1 month before shipping date (8-30 days)
        }
        return {}; // More than 30 days - no color
    };


    // Filter orders based on shipment date filters and assemblies filter
    const getFilteredOrderData = () => {
        let filteredData = Array.isArray(orderData) ? orderData : [];

        // Filter out archived whole orders
        filteredData = filteredData.filter(line => !archivedOrderNums.has(String(line?.order?.ordernum || '')));

        // Apply date range filter
        if (weekFilter || monthFilter) {
            filteredData = filteredData.filter(line => {
                const shipDate = getEarliestPromisedDateForOrder(line);
                return isWithinDateRange(shipDate);
            });
        }

        // Apply assemblies filter
        if (assembliesFilter) {
            filteredData = filteredData.filter(line => hasAssemblyParts(line));
        }

        // Stat strip quick filter (due / missing parts / ready)
        if (kpiQuickFilter === 'due') {
            filteredData = filteredData.filter((line) => {
                const ds = getEarliestPromisedDateForOrder(line);
                if (!ds) return false;
                const orderDay = parseAsLocalCalendarDate(ds);
                if (!orderDay) return false;
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return orderDay.getTime() <= today.getTime();
            });
        } else if (kpiQuickFilter === 'missing') {
            const missingMap = buildOrderLineStatusReportMapFromDetails(orderDetailsData, excludedAvailabilityPartsByOrder);
            filteredData = filteredData.filter((line) => {
                const r = missingMap[String(line?.order?.ordernum)];
                return r && (r.missingPartsCount || 0) > 0;
            });
        } else if (kpiQuickFilter === 'ready') {
            filteredData = filteredData.filter((line) => isReadyToShipLine(line));
        } else if (kpiQuickFilter && typeof kpiQuickFilter === 'object' && kpiQuickFilter.kind === 'order') {
            filteredData = filteredData.filter((line) => lineHasOrderStatusLabel(line, kpiQuickFilter.label));
        } else if (kpiQuickFilter && typeof kpiQuickFilter === 'object' && kpiQuickFilter.kind === 'line') {
            filteredData = filteredData.filter((line) => lineHasLineStatusLabel(line, kpiQuickFilter.label));
        }

        // Sort by column if a column is selected, otherwise sort by shipping date
        if (columnSort.key && columnSort.direction) {
            filteredData = sortOrdersByColumn(filteredData, columnSort.key, columnSort.direction);
        } else {
            // Default: sort by shipping date
            const effectiveShippingSort = kpiQuickFilter === 'due' ? 'descending' : shippingDateSort;
            filteredData = sortOrdersByShippingDate(filteredData, effectiveShippingSort);
        }

        return filteredData;
    };

    // Filter single order data based on shipment date filters and assemblies filter
    const getFilteredSingleOrderData = () => {
        let filteredData = singleOrderData;

        // Filter out archived whole orders
        filteredData = filteredData.filter(line => !archivedOrderNums.has(String(line?.order?.ordernum || '')));

        // Apply date range filter
        if (weekFilter || monthFilter) {
            filteredData = filteredData.filter(line => {
                const shipDate = getEarliestPromisedDateForOrder(line);
                return isWithinDateRange(shipDate);
            });
        }

        // Apply assemblies filter
        if (assembliesFilter) {
            filteredData = filteredData.filter(line => hasAssemblyParts(line));
        }

        return filteredData;
    };

    // Helper function to check if an order has assembly parts (ASY or SOC)
    const hasAssemblyParts = (line) => {
        // Check if the main part is an assembly
        const mainPart = String(line.prcpart || '');
        if (mainPart.startsWith('ASY') || mainPart.startsWith('SOC')) {
            return true;
        }

        // Check BOM parts if they exist
        const bomParts = line?.bom?.bomParts || [];
        return bomParts.some(bomPart => {
            const partNumber = String(bomPart.prcpart || '');
            return partNumber.startsWith('ASY') || partNumber.startsWith('SOC');
        });
    };

    // Helper function to check if a date falls within the selected date range filter
    const isWithinDateRange = (dateString) => {
        if (!weekFilter && !monthFilter) {
            return true; // No date filter applied
        }

        if (!dateString) return false;

        const orderDate = new Date(dateString);
        if (isNaN(orderDate.getTime())) return false;

        // Use the same calculation method as getRowStyle
        const today = new Date();
        const targetDate = new Date(dateString);
        const timeDiff = targetDate - today;
        const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        if (weekFilter) {
            // Include today through next 7 days (diffDays 0-7)
            return diffDays >= 0 && diffDays <= 7;
        }

        if (monthFilter) {
            // Include today through next 30 days (diffDays 0-30)
            return diffDays >= 0 && diffDays <= 30;
        }

        return true;
    };

    // Filter new orders data based on shipment date filters and assemblies filter
    const getFilteredNewOrdersData = () => {
        let filteredData = newOrdersData;

        // Filter out archived whole orders
        filteredData = filteredData.filter(line => !archivedOrderNums.has(String(line?.order?.ordernum || '')));

        // Apply WO# filter
        if (WOValue && WOValue.trim() !== '') {
            filteredData = filteredData.filter(line => {
                const woNum = line.order?.woNum?.toString() || '';
                return woNum.toLowerCase().includes(WOValue.toLowerCase());
            });
        }

        // Apply Order Status tag filter
        if (selectedOrderStatusTags.length > 0) {
            filteredData = filteredData.filter(line => {
                const submittedStatuses = submittedOrderStatuses[line.id] || [];
                const selectedLabels = selectedOrderStatusTags.map(t => t.label);
                return submittedStatuses.some(status => selectedLabels.includes(status.label));
            });
        }

        // Apply Line Status tag filter
        if (selectedLineStatusTags.length > 0) {
            filteredData = filteredData.filter(line => {
                const lineStatuses = line.lineStatuses || [];
                const selectedLabels = selectedLineStatusTags.map(t => t.label);
                return lineStatuses.some(status => selectedLabels.includes(status));
            });
        }

        // Apply date range filter
        if (weekFilter || monthFilter) {
            filteredData = filteredData.filter(line => {
                const shipDate = getEarliestPromisedDateForOrder(line);
                return isWithinDateRange(shipDate);
            });
        }

        // Apply assemblies filter
        if (assembliesFilter) {
            filteredData = filteredData.filter(line => hasAssemblyParts(line));
        }

        // Stat strip quick filter (due / missing parts / ready)
        // if (kpiQuickFilter === 'due') {
        //     filteredData = filteredData.filter((line) => {
        //         const ds = getEarliestPromisedDateForOrder(line);
        //         if (!ds) return false;
        //         const orderDay = parseAsLocalCalendarDate(ds);
        //         if (!orderDay) return false;
        //         const today = new Date();
        //         today.setHours(0, 0, 0, 0);
        //         return orderDay.getTime() <= today.getTime();
        //     });
        // } else if (kpiQuickFilter === 'missing') {
        //     const missingMap = buildOrderLineStatusReportMapFromDetails(orderDetailsData, excludedAvailabilityPartsByOrder);
        //     filteredData = filteredData.filter((line) => {
        //         const r = missingMap[String(line?.order?.ordernum)];
        //         return r && (r.missingPartsCount || 0) > 0;
        //     });
        // } else if (kpiQuickFilter === 'ready') {
        //     filteredData = filteredData.filter((line) => isReadyToShipLine(line));
        // } else if (kpiQuickFilter && typeof kpiQuickFilter === 'object' && kpiQuickFilter.kind === 'order') {
        //     filteredData = filteredData.filter((line) => lineHasOrderStatusLabel(line, kpiQuickFilter.label));
        // } else if (kpiQuickFilter && typeof kpiQuickFilter === 'object' && kpiQuickFilter.kind === 'line') {
        //     filteredData = filteredData.filter((line) => lineHasLineStatusLabel(line, kpiQuickFilter.label));
        // }

        // Sort by column if a column is selected, otherwise sort by shipping date
        if (columnSort.key && columnSort.direction) {
            filteredData = sortOrdersByColumn(filteredData, columnSort.key, columnSort.direction);
        } else {
            filteredData = sortOrdersByShippingDate(filteredData, shippingDateSort);
            // Default: sort by shipping date
            // const effectiveShippingSort = kpiQuickFilter === 'due' ? 'descending' : shippingDateSort;
            // filteredData = sortOrdersByShippingDate(filteredData, effectiveShippingSort);
        }

        return filteredData;
    };


    useEffect(() => {
        const delayTimer = setTimeout(() => {
            fetchData();
        }, 500); // 500ms debounce delay

        return () => clearTimeout(delayTimer);
    }, [useEffectOrder]);

    useEffect(() => {
        const delayTimer = setTimeout(() => {
            fetchPOData();
        }, 500); // 500ms debounce delay

        return () => clearTimeout(delayTimer);
    }, [useEffectPO]);

    useEffect(() => {
        const delayTimer = setTimeout(() => {
            fetchPartNameData();
        }, 500); // 500ms debounce delay

        return () => clearTimeout(delayTimer);
    }, [useEffectPartName]);

    useEffect(() => {
        const delayTimer = setTimeout(() => {
            fetchShipmentMethodData();
        }, 500); // 500ms debounce delay

        return () => clearTimeout(delayTimer);
    }, [useEffectShippingMethod]);

    useEffect(() => {
        const delayTimer = setTimeout(() => {
            fetchCustomer();
        }, 500); // 500ms debounce delay

        return () => clearTimeout(delayTimer);
    }, [useEffectCustomer]);

    useEffect(() => {
        const delayTimer = setTimeout(() => {
            fetchCountryData();
        }, 500); // 500ms debounce delay

        return () => clearTimeout(delayTimer);
    }, [useEffectCountry]);

    const fetchData = async () => {
        debugger
        if (!useEffectOrder || useEffectOrder === '' || useEffectOrder.length === 0) {
            setOrderSearch([]);
            setOrderValue(useEffectOrder);
            return;
        }
        const orders = await orderFetch('0', '10', useEffectOrder, null, null, null);
        if (orders === null) {
            return;
        }
        debugger
        setOrderSearch(orders.order);
        setOrderValue(useEffectOrder);
    };
    const fetchPOData = async () => {
        debugger
        if (!useEffectPO || useEffectPO === '' || useEffectPO.length === 0) {
            setPOSearch([]);
            setPOValue(useEffectPO);
            return;
        }
        const orders = await orderFetch('0', '10', useEffectPO, null, null, null);
        if (orders === null) {
            return;
        }
        debugger
        setPOSearch(orders.order);
        setPOValue(useEffectPO);
    };

    const fetchPartNameData = async () => {
        debugger
        if (!useEffectPartName || useEffectPartName === '' || useEffectPartName.length === 0) {
            setPartNameSearch([]);
            setPartNameValue(useEffectPartName);
            return;
        }
        const orders = await orderFetch('0', '10', useEffectPartName, null, null, null);
        if (orders === null) {
            return;
        }
        debugger
        setPartNameSearch(orders.order);
        setPartNameValue(useEffectPartName);
    };


    const fetchShipmentMethodData = async () => {
        debugger
        if (!useEffectShippingMethod || useEffectShippingMethod === '' || useEffectShippingMethod.length === 0) {
            setShippingMethodSearch([]);
            setShippingMethodValue(useEffectShippingMethod);
            return;
        }
        const orders = await getShipmentMethods(useEffectShippingMethod);
        setShippingMethodSearch(orders);
        setShippingMethodValue(useEffectShippingMethod);
    };



    const fetchCountryData = async () => {
        debugger
        if (!useEffectCountry || useEffectCountry === '' || useEffectCountry.length === 0) {
            setCountrySearch([]);
            setCountryValue(useEffectCountry);
            return;
        }
        const orders = await getCountries(useEffectCountry);
        setCountrySearch(orders);
        setCountryValue(useEffectCountry);
    };

    const fetchCustomer = async () => {
        debugger
        if (!useEffectCustomer || useEffectCustomer === '' || useEffectCustomer.length === 0) {
            setCustomerSearch([]);
            setCustomerValue(useEffectCustomer);
            return;
        }
        const orders = await getCustomer(useEffectCustomer);
        setCustomerSearch(orders);
        setCustomerValue(useEffectCustomer);
    };

    const [formData, setFormData] = useState({
        comment: "",
        flowName: "Order",
        status: "",
        orderLineId: ""
    });

    // Handle form input changes
    const handleChange = (e) => {
        debugger
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        debugger
        try {
            formData.flowName = "Order";
            formData.orderLineId = updatePopUp.id;
            const comment = await saveComment(formData);
            setCurrentPage(1);
            fetchOrdersSearch((currentPage - 1) * itemsPerPage, itemsPerPage, searchTerm)
            handleClose();
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };
    const handleLineItemChange = async (lineIds, ordernnum) => {
        await setLineId(lineIds);
        await setOrderNum(ordernnum);
        await fetchOrdersSearch((currentPage - 1) * itemsPerPage, itemsPerPage, searchTerm, lineIds, ordernnum)
    };
    const getStatusColor = (status) => {
        switch (status) {
            case 'Credit hold':
                return 'red';
            case 'CC hold':
                return 'orange';
            case 'Wire hold':
                return '#8B47FF'; // Purple
            case 'Do not ship early':
                return '#F8D700'; // Yellow
            default:
                return 'green'; // Default color
        }
    };

    // Helper to determine if row should be light green
    // const shouldRowBeGreen = (line) => {
    //     // Check if orderReport has 'In Shipping' or 'Shipped'
    //     const hasShippingStatus = line.orderReport && Array.isArray(line.orderReport) && 
    //         line.orderReport.some(report => 
    //             report.status === 'In Shipping' || report.status === 'Shipped'
    //         );

    //     if (!hasShippingStatus) return false;

    //     // Check for hold exceptions in Order Status (not Line Status)
    //     const holdStatuses = ['CC Hold', 'Wire Hold', 'Credit Hold'];
    //     const hasHold = (submittedOrderStatuses[line.id] || []).some(tag => 
    //         holdStatuses.includes(tag.label)
    //     ) || (orderStatusSelections[line.id] || []).some(tag => 
    //         holdStatuses.includes(tag.label)
    //     );

    //     return !hasHold;
    // };


    const isInShippingOrShippedLabel = (raw) => {
        const s = String(typeof raw === 'string' ? raw : raw?.label || '').trim().toLowerCase();
        return s === 'in shipping' || s === 'ready to ship' || s === 'shipped';
    };

    /** API sometimes sends status as string; sometimes nested on the report row. */
    const statusLabelFromOrderReportRow = (r) => {
        if (!r) return '';
        const s = r.status;
        if (typeof s === 'string') return s.trim();
        if (s && typeof s === 'object') {
            return String(s.label ?? s.name ?? s.status ?? '').trim();
        }
        return '';
    };

    const getOrderDetailLineById = (l) => {
        const on = l?.order?.ordernum;
        if (!on || !l?.id) return null;
        const arr =
            orderDetailsData?.[on] ??
            orderDetailsData?.[String(on)] ??
            orderDetailsData?.[Number(on)];
        if (!Array.isArray(arr)) return null;
        return arr.find((d) => String(d.id) === String(l.id)) || null;
    };

    /** Single row: orderReport, lineStatuses, lineItemStatus (list row often lacks report until detail fetch). */
    const lineHasInShippingOrShippedOnRow = (row) => {
        if (!row?.id) return false;

        const reports = Array.isArray(row.orderReport) ? row.orderReport : [];
        if (reports.some((r) => isInShippingOrShippedLabel(statusLabelFromOrderReportRow(r)))) return true;

        if ((row.lineStatuses || []).some((x) => isInShippingOrShippedLabel(typeof x === 'string' ? x : x?.label))) {
            return true;
        }

        if (row.lineItemStatus) {
            try {
                const parsed = JSON.parse(row.lineItemStatus);
                if (Array.isArray(parsed) && parsed.some((t) => isInShippingOrShippedLabel(typeof t === 'string' ? t : t?.label))) {
                    return true;
                }
            } catch {
                /* ignore */
            }
        }

        return false;
    };

    /** List row + detail + pending tags + merged report + siblings (same sources as Line Status Report column). */
    const lineHasInShippingOrShippedStatus = (line) => {
        if (!line?.id) return false;

        const reportRowsShowInShipping = (rows) =>
            Array.isArray(rows) &&
            rows.some((r) => isInShippingOrShippedLabel(statusLabelFromOrderReportRow(r)));

        const checkLineObj = (ln) => {
            if (!ln?.id) return false;
            if (lineHasInShippingOrShippedOnRow(ln)) return true;
            if (reportRowsShowInShipping(getMergedLineStatusReportRows(ln))) return true;
            if ((submittedLineStatuses[ln.id] || []).some((t) => isInShippingOrShippedLabel(t))) return true;
            if ((lineStatusSelections[ln.id] || []).some((t) => isInShippingOrShippedLabel(t))) return true;
            return false;
        };

        if (checkLineObj(line)) return true;

        const detail = getOrderDetailLineById(line);
        if (detail && checkLineObj(detail)) return true;

        const orderNum = String(line?.order?.ordernum || '');
        if (orderNum) {
            const detailLinesForOrder =
                orderDetailsData?.[orderNum] ??
                orderDetailsData?.[String(orderNum)] ??
                orderDetailsData?.[Number(orderNum)];
            if (Array.isArray(detailLinesForOrder) && detailLinesForOrder.some(checkLineObj)) {
                return true;
            }

            const siblingListRows = [...(orderData || []), ...(newOrdersData || [])].filter(
                (ln) => String(ln?.order?.ordernum || '') === orderNum
            );
            if (siblingListRows.some(checkLineObj)) return true;
        }

        if (reportRowsShowInShipping(getDisplayLineStatusReportRows(line))) return true;

        return false;
    };

    const normLineStatusLabel = (x) => {
        if (x == null) return '';
        if (typeof x === 'string') return x.trim();
        return String(x.label ?? x.name ?? x).trim();
    };

    /** KPI / list filter: line matches a Line Status tag label (list row + detail + submitted/pending). */
    const lineHasLineStatusLabel = (line, wantLabel) => {
        const w = String(wantLabel || '').trim().toLowerCase();
        if (!w || !line?.id) return false;

        const checkArr = (arr) =>
            Array.isArray(arr) && arr.some((x) => normalizeLineStatusKey(normLineStatusLabel(x)) === normalizeLineStatusKey(w));

        const checkLineObj = (ln) => {
            if (!ln) return false;
            if (checkArr(ln.lineStatuses)) return true;
            if (checkArr(submittedLineStatuses[ln.id] || submittedLineStatuses[String(ln.id)])) return true;
            if (checkArr(lineStatusSelections[ln.id] || lineStatusSelections[String(ln.id)])) return true;
            if (ln.lineItemStatus) {
                try {
                    const parsed = JSON.parse(ln.lineItemStatus);
                    if (checkArr(parsed)) return true;
                } catch {
                    /* ignore */
                }
            }
            return false;
        };

        if (checkLineObj(line)) return true;
        const detail = getOrderDetailLineById(line);
        if (detail && checkLineObj(detail)) return true;

        // Also check sibling lines in the same order (not just the clicked/list row line).
        // This keeps KPI card counts accurate when a tag is on another line of that order.
        const orderNum = String(line?.order?.ordernum || '');
        if (!orderNum) return false;

        const detailLinesForOrder =
            orderDetailsData?.[orderNum] ??
            orderDetailsData?.[String(orderNum)] ??
            orderDetailsData?.[Number(orderNum)];
        if (Array.isArray(detailLinesForOrder) && detailLinesForOrder.some((ln) => checkLineObj(ln))) {
            return true;
        }

        const siblingListRows = [...(orderData || []), ...(newOrdersData || [])].filter(
            (ln) => String(ln?.order?.ordernum || '') === orderNum
        );
        if (siblingListRows.some((ln) => checkLineObj(ln))) {
            return true;
        }

        return false;
    };

    /** KPI / list filter: line matches an Order Status tag (submitted + pending selections). */
    const lineHasOrderStatusLabel = (line, wantLabel) => {
        const w = String(wantLabel || '').trim().toLowerCase();
        if (!w || !line?.id) return false;
        const checkArr = (arr) =>
            Array.isArray(arr) && arr.some((t) => String(t?.label ?? '').trim().toLowerCase() === w);
        return checkArr(submittedOrderStatuses[line.id]) || checkArr(orderStatusSelections[line.id]);
    };

    const lineHasOrderStatusHold = (l) => {
        if (!l?.id) return false;
        const holdStatuses = ['cc hold', 'wire hold', 'credit hold', 'ppa'];
        return (
            (submittedOrderStatuses[l.id] || []).some((tag) => holdStatuses.includes(String(tag?.label || '').toLowerCase())) ||
            (orderStatusSelections[l.id] || []).some((tag) => holdStatuses.includes(String(tag?.label || '').toLowerCase()))
        );
    };

    const lineHasOrderStatusPaid = (l) => {
        if (!l?.id) return false;
        const hasPaid = (arr) =>
            Array.isArray(arr) && arr.some((tag) => {
                const s = String(typeof tag === 'string' ? tag : tag?.label || '').trim().toLowerCase();
                return s === 'paid';
            });
        return hasPaid(submittedOrderStatuses[l.id])
            || hasPaid(submittedOrderStatuses[String(l.id)])
            || hasPaid(orderStatusSelections[l.id])
            || hasPaid(orderStatusSelections[String(l.id)]);
    };

    /** Paid on any line of this order (overrides hold tags for green row). */
    const orderHasOrderStatusPaid = (line) => {
        const orderNum = String(line?.order?.ordernum || '');
        if (!orderNum) return lineHasOrderStatusPaid(line);

        const seen = new Set();
        const check = (ln) => {
            if (!ln?.id || seen.has(ln.id)) return false;
            seen.add(ln.id);
            return lineHasOrderStatusPaid(ln);
        };

        if (check(line)) return true;

        const detailLines =
            orderDetailsData?.[orderNum] ??
            orderDetailsData?.[String(orderNum)] ??
            orderDetailsData?.[Number(orderNum)];
        if (Array.isArray(detailLines) && detailLines.some(check)) return true;

        const siblingListRows = [...(orderData || []), ...(newOrdersData || [])].filter(
            (ln) => String(ln?.order?.ordernum || '') === orderNum
        );
        return siblingListRows.some(check);
    };

    /** Saved CC / Wire / Credit / PPA hold on any line of this order. */
    const orderHasOrderStatusHold = (line) => {
        const orderNum = String(line?.order?.ordernum || '');
        if (!orderNum) return lineHasOrderStatusHold(line);

        const seen = new Set();
        const check = (ln) => {
            if (!ln?.id || seen.has(ln.id)) return false;
            seen.add(ln.id);
            return lineHasOrderStatusHold(ln);
        };

        if (check(line)) return true;

        const detailLines =
            orderDetailsData?.[orderNum] ??
            orderDetailsData?.[String(orderNum)] ??
            orderDetailsData?.[Number(orderNum)];
        if (Array.isArray(detailLines) && detailLines.some(check)) return true;

        const siblingListRows = [...(orderData || []), ...(newOrdersData || [])].filter(
            (ln) => String(ln?.order?.ordernum || '') === orderNum
        );
        return siblingListRows.some(check);
    };

    /** Cart tags that mean ready-to-ship (In Shipping KPI + green-eligible like Shipped). */
    const hasReadyToShipCartTag = (line) => {
        if (lineHasLineStatusLabel(line, 'Staging Cart')) return true;
        if (lineHasLineStatusLabel(line, 'On Hold Cart')) return true;
        const stagingKey = normalizeLineStatusKey('Staging Cart');
        const onHoldCartKey = normalizeLineStatusKey('On Hold Cart');
        return getDisplayLineStatusReportRows(line).some((r) => {
            const key = normalizeLineStatusKey(r?.status);
            return key === stagingKey || key === onHoldCartKey;
        });
    };

    /** In shipping KPI / filter: in shipping path or Staging/On Hold Cart (holds do not block KPI). */
    const isReadyToShipLine = (line) => {
        if (hasReadyToShipCartTag(line)) return true;

        const ordernum = line?.order?.ordernum;
        if (!ordernum) return false;

        if (lineHasInShippingOrShippedStatus(line)) return true;

        const inlineLines = orderDetailsData?.[ordernum];
        const linesForOrder = Array.isArray(inlineLines) && inlineLines.length > 0
            ? inlineLines
            : orderData.filter((l) => l?.order?.ordernum === ordernum);

        if (!linesForOrder.length) return false;

        return linesForOrder.every((l) => {
            const reports = getMergedLineStatusReportRows(l);

            return reports.some((r) => {
                const status = statusLabelFromOrderReportRow(r).toLowerCase();
                const count = parseInt(r?.count, 10) || 0;
                const totalCount = parseInt(r?.totalCount, 10) || 0;

                return (status === 'shipped' || status === 'in shipping' || status === 'ready to ship') && count === totalCount && totalCount > 0;
            });
        });
    };

    const isHotOrderOrAogLabel = (raw) => {
        const s = String(typeof raw === 'string' ? raw : raw?.label || '').toLowerCase().trim();
        return s === 'hot order' || s === 'hot order/aog' || s === 'aog';
    };

    const lineHasHotOrderStatus = (l) => {
        if (!l?.id) return false;
        const hasTag = (arr) => Array.isArray(arr) && arr.some((tag) => isHotOrderOrAogLabel(tag));
        return hasTag(submittedOrderStatuses[l.id])
            || hasTag(submittedOrderStatuses[String(l.id)])
            || hasTag(orderStatusSelections[l.id])
            || hasTag(orderStatusSelections[String(l.id)]);
    };

    // Entire order turns orange when Hot Order or AOG is selected (pending or submitted).
    const shouldRowBeOrange = (line) => {
        if (lineHasHotOrderStatus(line)) return true;
        const orderNum = String(line?.order?.ordernum || '');
        if (!orderNum) return false;

        const seen = new Set();
        const check = (ln) => {
            if (!ln?.id || seen.has(ln.id)) return false;
            seen.add(ln.id);
            return lineHasHotOrderStatus(ln);
        };

        const detailLines =
            orderDetailsData?.[orderNum] ??
            orderDetailsData?.[String(orderNum)] ??
            orderDetailsData?.[Number(orderNum)];
        if (Array.isArray(detailLines) && detailLines.some(check)) return true;

        const siblingListRows = [...(orderData || []), ...(newOrdersData || [])].filter(
            (ln) => String(ln?.order?.ordernum || '') === orderNum
        );
        return siblingListRows.some(check);
    };

    const lineHasCcHoldAndPpa = (l) => {
        if (!l?.id) return false;
        const labels = new Set();
        const add = (arr) => {
            if (!Array.isArray(arr)) return;
            arr.forEach((tag) => {
                const s = String(typeof tag === 'string' ? tag : tag?.label || '').toLowerCase().trim();
                if (s) labels.add(s);
            });
        };
        add(submittedOrderStatuses[l.id]);
        add(submittedOrderStatuses[String(l.id)]);
        add(orderStatusSelections[l.id]);
        add(orderStatusSelections[String(l.id)]);
        const hasPpa = labels.has('ppa');
        const hasCcOrWireHold = labels.has('cc hold') || labels.has('wire hold');
        return hasPpa && hasCcOrWireHold;
    };

    // Entire order turns purple when PPA is selected together with CC Hold or Wire Hold.
    // Paid on the order removes that purple highlight.
    const shouldRowBePurple = (line) => {
        if (orderHasOrderStatusPaid(line)) return false;
        if (lineHasCcHoldAndPpa(line)) return true;
        const orderNum = String(line?.order?.ordernum || '');
        if (!orderNum) return false;

        const seen = new Set();
        const check = (ln) => {
            if (!ln?.id || seen.has(ln.id)) return false;
            seen.add(ln.id);
            return lineHasCcHoldAndPpa(ln);
        };

        const detailLines =
            orderDetailsData?.[orderNum] ??
            orderDetailsData?.[String(orderNum)] ??
            orderDetailsData?.[Number(orderNum)];
        if (Array.isArray(detailLines) && detailLines.some(check)) return true;

        const siblingListRows = [...(orderData || []), ...(newOrdersData || [])].filter(
            (ln) => String(ln?.order?.ordernum || '') === orderNum
        );
        return siblingListRows.some(check);
    };

    const isPoReviewStatusLabel = (label) =>
        String(label || '').toLowerCase().trim() === 'po review';

    const lineHasPoReviewStatus = (l) => {
        if (!l?.id) return false;
        const hasTag = (arr) =>
            Array.isArray(arr) && arr.some((tag) => isPoReviewStatusLabel(typeof tag === 'string' ? tag : tag?.label));
        return hasTag(submittedOrderStatuses[l.id])
            || hasTag(submittedOrderStatuses[String(l.id)])
            || hasTag(orderStatusSelections[l.id])
            || hasTag(orderStatusSelections[String(l.id)]);
    };

    const poReviewOrderNums = useMemo(() => {
        const nums = new Set();
        const consider = (ln) => {
            if (!lineHasPoReviewStatus(ln)) return;
            const n = ln?.order?.ordernum;
            if (n != null && n !== '') nums.add(String(n));
        };
        (orderData || []).forEach(consider);
        (newOrdersData || []).forEach(consider);
        Object.values(orderDetailsData || {}).forEach((rows) => {
            if (Array.isArray(rows)) rows.forEach(consider);
        });
        return nums;
    }, [orderData, newOrdersData, orderDetailsData, submittedOrderStatuses, orderStatusSelections]);

    // Entire order: charcoal row when PO Review is selected (pending or submitted).
    const shouldRowBePoReview = (line) => {
        if (lineHasPoReviewStatus(line)) return true;
        const orderNum = String(line?.order?.ordernum || '');
        return !!orderNum && poReviewOrderNums.has(orderNum);
    };

    const orderHasAnyLineStatusTag = (line, triggerTags = []) => {
        const ordernum = line?.order?.ordernum;
        if (!ordernum) return false;

        // Get all lines for this order
        // Prefer the fully fetched inline details (when eye icon was opened)
        const inlineLines = orderDetailsData?.[ordernum];
        const linesForOrder = Array.isArray(inlineLines) && inlineLines.length > 0
            ? inlineLines
            : (newOrdersData.length > 0 
                ? newOrdersData.filter(l => l?.order?.ordernum === ordernum)
                : orderData.filter(l => l?.order?.ordernum === ordernum));

        if (!linesForOrder.length) return false;

        // Check if any line in the order has one of the trigger tags
        const matchesLabel = (raw) => {
            const label = typeof raw === 'string' ? raw : raw?.label || raw;
            return triggerTags.some((tag) => normalizeLineStatusKey(label) === normalizeLineStatusKey(tag));
        };

        const hasTriggerTag = linesForOrder.some(l => {
            const submittedStatuses = submittedLineStatuses[l.id] || submittedLineStatuses[String(l.id)] || [];
            if (submittedStatuses.some(matchesLabel)) {
                return true;
            }

            const pendingSelections = lineStatusSelections[l.id] || lineStatusSelections[String(l.id)] || [];
            if (pendingSelections.some((tag) => matchesLabel(tag.label))) {
                return true;
            }

            const lineStatuses = l.lineStatuses || [];
            if (lineStatuses.some(matchesLabel)) {
                return true;
            }

            if (l.lineItemStatus) {
                try {
                    const parsedStatuses = JSON.parse(l.lineItemStatus);
                    if (Array.isArray(parsedStatuses) && parsedStatuses.some(matchesLabel)) {
                        return true;
                    }
                } catch (e) {
                    // Ignore parse errors
                }
            }

            if (l.orderReport && Array.isArray(l.orderReport)) {
                if (l.orderReport.some((report) => matchesLabel(report?.status))) {
                    return true;
                }
            }

            return false;
        });

        return hasTriggerTag;
    };

    // Helper to determine if row should be highlighted brown (RMA or Waiting On Components)
    const shouldRowBeBrown = (line) =>
        orderHasAnyLineStatusTag(line, ['RMA', 'Waiting On Components', 'Waiting for Components']);

    const shouldRowBeOnHoldCart = (line) =>
        orderHasAnyLineStatusTag(line, ['On Hold Cart']);

    const shouldRowBeStaggingCart = (line) =>
        orderHasAnyLineStatusTag(line, ['Staging Cart']);

    const isStaggingCartLine = (line) => {
        if (lineHasLineStatusLabel(line, 'Staging Cart')) return true;
        if (shouldRowBeStaggingCart(line)) return true;

        const stagingKey = normalizeLineStatusKey('Staging Cart');
        return getDisplayLineStatusReportRows(line).some(
            (r) => normalizeLineStatusKey(r?.status) === stagingKey
        );
    };

    /** Light green row: Shipped / cart tags green unless unpaid hold; Paid allows green with holds. */
    const shouldRowBeGreen = (line) => {
        if (orderHasOrderStatusHold(line) && !orderHasOrderStatusPaid(line)) return false;
        return isReadyToShipLine(line);
    };

    const getLineStatusReportHighlight = (line) => {
        if (orderHasAnyLineStatusTag(line, ['ENG Review'])) {
            return { backgroundColor: '#625C5C', textColor: 'white', secondaryTextColor: 'rgba(255, 255, 255, 0.9)' };
        }
        if (shouldRowBeStaggingCart(line)) {
            return { backgroundColor: '#1DA1DB', textColor: 'white', secondaryTextColor: 'rgba(255, 255, 255, 0.9)' };
        }
        if (shouldRowBeOnHoldCart(line)) {
            return { backgroundColor: '#C56A00', textColor: 'white', secondaryTextColor: 'rgba(255, 255, 255, 0.9)' };
        }
        if (shouldRowBeBrown(line)) {
            return { backgroundColor: '#A85A58', textColor: 'white', secondaryTextColor: 'rgba(255, 255, 255, 0.9)' };
        }
        return { backgroundColor: 'transparent', textColor: 'inherit', secondaryTextColor: '#6c757d' };
    };

    // These line-status colors stay on the report cell even when the row has another highlight
    // (purple CC/Wire+PPA, Hot Order, PO Review, shipped green, or ship-date colors).
    const getPriorityLineStatusHighlight = (line) => {
        if (orderHasAnyLineStatusTag(line, ['ENG Review'])) {
            return { backgroundColor: '#625C5C', textColor: 'white', secondaryTextColor: 'rgba(255, 255, 255, 0.9)' };
        }
        if (shouldRowBeStaggingCart(line)) {
            return { backgroundColor: '#1DA1DB', textColor: 'white', secondaryTextColor: 'rgba(255, 255, 255, 0.9)' };
        }
        if (shouldRowBeOnHoldCart(line)) {
            return { backgroundColor: '#C56A00', textColor: 'white', secondaryTextColor: 'rgba(255, 255, 255, 0.9)' };
        }
        if (orderHasAnyLineStatusTag(line, ['Waiting On Components', 'Waiting for Components'])) {
            return { backgroundColor: '#A85A58', textColor: 'white', secondaryTextColor: 'rgba(255, 255, 255, 0.9)' };
        }
        return null;
    };

    const handleSingleOrder = async (ordernumber) => {
        await fetchOrders((currentPage - 1) * itemsPerPage, itemsPerPage, searchTerm, true, ordernumber, null, null);

        // Ensure state is updated AFTER the fetch is complete
        setTimeout(() => {
            setHoverRowId(ordernumber);
        }, 200); // Delay to allow state update
    };

    const [filterTabOpen, setFilterTab] = useState(false);

    const [assembliesFilter, setAssembliesFilter] = useState(ordersFilterHydration.assembliesFilter); // Assemblies filter toggle
    const [weekFilter, setWeekFilter] = useState(ordersFilterHydration.weekFilter); // Week filter toggle
    const [monthFilter, setMonthFilter] = useState(ordersFilterHydration.monthFilter); // Month filter toggle

    // Keep Orders filter selections in localStorage so they survive refresh / remount.
    useEffect(() => {
        const nextState = {
            weekFilter,
            monthFilter,
            assembliesFilter,
            kpiQuickFilter,
            searchTerm,
            startDate,
            endDate,
            orderValue,
            POValue,
            PartNameValue,
            ShippingMethodValue,
            CountryValue,
            CustomerValue,
            customerId: path ? '' : (CustomerId || ''),
            WOValue,
            selectedOrderStatusTags,
            selectedLineStatusTags,
        };

        if (hasActiveOrdersFilter(nextState)) {
            saveOrdersFilterState(nextState, ORDERS_FILTER_STATE_STORAGE_KEY);
        } else {
            clearOrdersFilterState(ORDERS_FILTER_STATE_STORAGE_KEY);
        }
    }, [
        weekFilter,
        monthFilter,
        assembliesFilter,
        kpiQuickFilter,
        searchTerm,
        startDate,
        endDate,
        orderValue,
        POValue,
        PartNameValue,
        ShippingMethodValue,
        CountryValue,
        CustomerValue,
        CustomerId,
        path,
        WOValue,
        selectedOrderStatusTags,
        selectedLineStatusTags,
    ]);

    const filteredOrderData = getFilteredOrderData();
    const filteredNewOrdersData = getFilteredNewOrdersData();
    const filteredRecordsCount = filteredOrderData.length;
    const totalPages = itemsPerPage === -1 ? 1 : Math.max(1, Math.ceil(filteredRecordsCount / itemsPerPage));

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [currentPage, totalPages]);

    // Sticky layout is CSS-driven (Order Validation model): fixed-height shell,
    // toolbar stack at top, both tables in ONE scroll region with All Orders thead
    // sticky at top: 0. JS only collapses the page title while scrolled down.
    const syncOrdersPageTitle = useCallback(() => {
        const scrollEl = tableContainerRef.current;
        const titleEl = titleWrapRef.current;
        if (!scrollEl || !titleEl) return;

        // Hysteresis (24px hide / 4px show) matches Order Validation — avoids flicker.
        const scrolled = scrollEl.scrollTop;
        if (scrolled > 24) {
            titleEl.classList.add('ov-title-collapsed');
        } else if (scrolled < 4) {
            titleEl.classList.remove('ov-title-collapsed');
        }
    }, []);

    useEffect(() => {
        const scrollEl = tableContainerRef.current;
        if (!scrollEl) return undefined;

        syncOrdersPageTitle();
        scrollEl.addEventListener('scroll', syncOrdersPageTitle, { passive: true });
        return () => {
            scrollEl.removeEventListener('scroll', syncOrdersPageTitle);
        };
    }, [
        syncOrdersPageTitle,
        filterTabOpen,
        assembliesFilter,
        weekFilter,
        monthFilter,
        filteredNewOrdersData.length,
        filteredRecordsCount,
    ]);

    const paginatedOrders = itemsPerPage === -1
        ? filteredOrderData
        : filteredOrderData.slice((currentPage - 1) * itemsPerPage, (currentPage - 1) * itemsPerPage + itemsPerPage);

    const lineSourceRows = useMemo(
        () => [...(filteredNewOrdersData || []), ...(paginatedOrders || [])],
        [filteredNewOrdersData, paginatedOrders]
    );
    const lineRows = useMemo(
        () => flattenOrdersToLines(lineSourceRows, orderDetailsData, archivedOrderIds),
        [lineSourceRows, orderDetailsData, archivedOrderIds]
    );
    const lineDetailsPending = useMemo(
        () => headerLinesMissingDetails(lineSourceRows, orderDetailsData),
        [lineSourceRows, orderDetailsData]
    );

    const historyUnreadOrderNums = useMemo(() => {
        const nums = new Set();
        const addFrom = (rows) => {
            (rows || []).forEach((line) => {
                const n = line?.order?.ordernum || line?.ordernum;
                if (n) nums.add(String(n));
            });
        };
        addFrom(filteredNewOrdersData);
        addFrom(paginatedOrders);
        return Array.from(nums);
    }, [filteredNewOrdersData, paginatedOrders]);

    const { getUnreadCount, markViewed } = useOrderHistoryUnread(historyUnreadOrderNums);

    // Sticky Notes column: permanent order / shipping instructions, per order number.
    // A save is relayed to everyone else on this page over presence.
    // Cetec shipping instructions, read-only, pinned on top of each row's sticky notes.
    const shippingOrdersOnScreen = useMemo(
        () => [...(filteredNewOrdersData || []), ...(paginatedOrders || [])].map((line) => line?.order || line),
        [filteredNewOrdersData, paginatedOrders]
    );
    const shippingInstructions = useShippingInstructions(shippingOrdersOnScreen);

    const stickyNotes = useStickyNotes(historyUnreadOrderNums, {
        onChange: (orderNumber, notes) => presence.broadcastSave({
            cell: cellKey(presencePage, 'order', orderNumber, 'stickyNotes'),
            kind: 'stickyNotes',
            lineId: String(orderNumber),
            value: notes,
        }),
    });
    const applyRemoteStickyNotes = stickyNotes.applyRemote;

    // INFO column comments icon: unread count comes from the same source as the bell
    // and the minimized chats; "active" means this line's chat is open on screen.
    const notificationsCtx = useNotifications();
    const commentDock = useCommentDock();
    const getUnreadCommentCount = (line) => (
        notificationsCtx
            ? notificationsCtx.unreadCountForOrder(line?.order?.ordernum || line?.ordernum, line?.id)
            : 0
    );
    const isCommentChatOpen = (lineId) => {
        const key = getCommentThreadKey({ orderLineId: lineId });
        return Boolean(commentDock?.threads?.some((t) => t.key === key && !t.minimized));
    };

    const hasPaginatedRecords = paginatedOrders.length > 0;
    const startRecord = hasPaginatedRecords ? (itemsPerPage === -1 ? 1 : (currentPage - 1) * itemsPerPage + 1) : 0;
    const endRecord = hasPaginatedRecords ? startRecord + paginatedOrders.length - 1 : 0;
const displayTotalRecords = overallTotalRecords > 0 ? overallTotalRecords : totalRecords;

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    // Export to Excel using the same filtered data as the table (respects Week/Month, Assemblies, Search, archived)
    const handleExportToExcel = () => {
        const dataToExport = getFilteredOrderData();
        if (!dataToExport || dataToExport.length === 0) {
            return;
        }
        const headers = [
            ["Line Item", "Order Number", "Ordered On Date", "WO#", "Customer", "Customer PO", "Order Qty", "Status", "Ship Date", "Shipment Method", "Country"]
        ];
        const rows = dataToExport.map((line) => [
            line.lineitem,
            line.order?.ordernum ?? "N/A",
            getOrderedOnDate(line),
            line.order?.woNum || "N/A",
            line.order?.customer?.name || "N/A",
            line.order?.custponum || "N/A",
            line.balancedue ?? "N/A",
            line.statusObj?.status || "N/A",
            getEarliestPromisedDateForOrder(line) || "N/A",
            line.order?.shipmentMethod?.methodOfShipment || "N/A",
            line.order?.country?.country_Name || "N/A"
        ]);
        const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
        XLSX.writeFile(workbook, "orders.xlsx");
    };

    const [selectedOrder, setSelectedOrder] = useState(null);
    const [selectedSourceLine, setSelectedSourceLine] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [defaultViewMode, setDefaultViewMode] = useState(() => loadViewModeDefault(localStorage.getItem('userEmail')));
    const [inlineDropdownMode, setInlineDropdownMode] = useState(() => loadInlineDropdownModeFromPreference(localStorage.getItem('userEmail')));
    const ordersLayoutKey = 'bridgeOrders.layoutView.v1';
    const [layoutView, setLayoutViewState] = useState(() => readLayoutView(ordersLayoutKey));
    const setLayoutView = (next) => {
        const value = next === LAYOUT_LINE ? LAYOUT_LINE : LAYOUT_HEADER;
        setLayoutViewState(value);
        saveLayoutView(ordersLayoutKey, value);
    };

    const handleSelectView = useCallback((mode) => {
        setInlineDropdownMode(isInlineViewMode(mode));
    }, []);

    const handleSetViewModeDefault = useCallback((mode) => {
        const userEmail = localStorage.getItem('userEmail');
        saveViewModeDefault(userEmail, mode);
        setDefaultViewMode(mode);
        setInlineDropdownMode(isInlineViewMode(mode));
    }, []);
    const cacheOrderDetailsData = useCallback((orderNumber, orderLines) => {
        if (!orderNumber || !Array.isArray(orderLines) || orderLines.length === 0) return;
        const orderKey = String(orderNumber);
        setOrderDetailsData((prev) => ({
            ...prev,
            [orderKey]: orderLines,
            [orderNumber]: orderLines,
        }));
    }, []);

    const handleToggleExcludedAvailabilityPart = useCallback((orderNum, partNumber, shouldExclude) => {
        if (!orderNum || !partNumber) return;
        setExcludedAvailabilityPartsByOrder((prev) => {
            const orderKey = String(orderNum);
            const prevOrderMap = prev[orderKey] || {};
            const nextOrderMap = { ...prevOrderMap };

            if (shouldExclude) {
                nextOrderMap[partNumber] = true;
            } else {
                delete nextOrderMap[partNumber];
            }

            if (Object.keys(nextOrderMap).length === 0) {
                const { [orderKey]: removedOrder, ...rest } = prev;
                return rest;
            }

            return {
                ...prev,
                [orderKey]: nextOrderMap,
            };
        });
    }, []);

    const [historyModalOrder, setHistoryModalOrder] = useState(null); // ordernum for the order-history modal, null when closed
    const [showAllOrdersHistory, setShowAllOrdersHistory] = useState(false); // top-level "All Orders History" modal
    const [expandedInlineOrders, setExpandedInlineOrders] = useState({}); // Track which orders are expanded in inline mode
    const [inlineActiveView, setInlineActiveView] = useState({}); // Track active view for each expanded order
    const [expandedInlineBomRows, setExpandedInlineBomRows] = useState({}); // Track which BOM rows are expanded in inline mode

    // Rows this user currently has open: expanded inline, or showing in the popup.
    // Announced to everyone else so the grid can show "X is also on this order".
    const openRowIds = useMemo(() => {
        const ids = Object.keys(expandedInlineOrders).filter((num) => expandedInlineOrders[num]);
        const popupOrder = showPopup
            ? selectedSourceLine?.order?.ordernum || selectedSourceLine?.ordernum
            : null;
        if (popupOrder && !ids.includes(String(popupOrder))) ids.push(String(popupOrder));
        return ids;
    }, [expandedInlineOrders, showPopup, selectedSourceLine]);

    useRowPresence(presencePage, openRowIds, presence);

    // const orderRowCell = useCallback(
    //     (ordernum) => cellKey(presencePage, 'order', ordernum, 'row'),
    //     [presencePage]
    // );

    /** Everyone active anywhere on this row, shown next to the order number.
     *  Editors of the Order Status / Notes cells are included so their activity
     *  is visible without the order being expanded - the cell badges alone are
     *  easy to miss in a wide grid. */
    const renderRowActivity = useCallback(
        (line) => {
            const ordernum = line?.order?.ordernum || line?.ordernum;
            const users = mergeRowPresence([
                {
                    users: presenceUsersInCell(orderStatusCell(line?.id)),
                    activity: 'changing this order status',
                },
                {
                    users: presenceUsersInCell(notesCell(line?.id)),
                    activity: 'in the notes',
                },
                {
                    users: ordernum ? presenceUsersInCell(orderRowCell(ordernum)) : [],
                    activity: 'also on this order',
                },
            ]);
            if (!users.length) return null;
            return <CellPresence users={users} size={16} compact />;
        },
        [presenceUsersInCell, orderRowCell, orderStatusCell, notesCell]
    );

    const showOrderPOP = async (line) => {
        const orderNumber = line?.order?.ordernum || line?.ordernum;
        if (!orderNumber) {
            return;
        }

        setSelectedSourceLine(line);

        const triggerUrl = line?.folderUrl?.trim();
        if (triggerUrl && line?.id) {
            setOrderAccessLinks((prev) => {
                if (prev[line.id]?.length > 0) {
                    return prev;
                }
                return {
                    ...prev,
                    [line.id]: [{
                        id: `trigger-${line.id}`,
                        url: triggerUrl,
                        dateAdded: new Date().toLocaleDateString(),
                    }],
                };
            });
        }

        const orders = await orderFetch(0, 10, "", "lineitem", "ascending", null, "", "", "", "", "", "", "", "", "", true, true, "", orderNumber);
        if (orders === null) {
            return;
        }

        const orderLines = stripArchivedBomParts(Array.isArray(orders.order) ? orders.order : []);
        setSelectedOrder(orderLines);
        cacheOrderDetailsData(orderNumber, orderLines);

        if (orderLines.length > 0) {
            const newLinks = {};
            const timestamp = Date.now();
            const dateLabel = new Date().toLocaleDateString();

            orderLines.forEach((orderLine) => {
                const url = orderLine.folderUrl?.trim();
                if (url) {
                    newLinks[orderLine.id] = [{
                        id: `${timestamp}-${orderLine.id}`,
                        url,
                        dateAdded: dateLabel
                    }];
                }
            });

            if (Object.keys(newLinks).length > 0) {
                setOrderAccessLinks(prev => ({ ...prev, ...newLinks }));
            }
        }

        setShowPopup(true);
    };

    // Helper function to open modal by order number
    const openModalByOrderNumber = async (orderNumber) => {
        if (!orderNumber) {
            return Promise.reject('No order number provided');
        }

        try {
            const orders = await orderFetch(0, 10, "", "lineitem", "ascending", null, "", "", "", "", "", "", "", "", true, true, "", orderNumber);
            if (orders === null || !orders.order || orders.order.length === 0) {
                console.warn(`Order ${orderNumber} not found`);
                return Promise.reject(`Order ${orderNumber} not found`);
            }

            const orderLines = stripArchivedBomParts(Array.isArray(orders.order) ? orders.order : []);
            setSelectedOrder(orderLines);
            cacheOrderDetailsData(orderNumber, orderLines);

            if (orderLines.length > 0) {
                const newLinks = {};
                const timestamp = Date.now();
                const dateLabel = new Date().toLocaleDateString();

                orderLines.forEach((orderLine) => {
                    const url = orderLine.folderUrl?.trim();
                    if (url) {
                        newLinks[orderLine.id] = [{
                            id: `${timestamp}-${orderLine.id}`,
                            url,
                            dateAdded: dateLabel
                        }];
                    }
                });

                if (Object.keys(newLinks).length > 0) {
                    setOrderAccessLinks(prev => ({ ...prev, ...newLinks }));
                }
            }

            // Force the modal to open
            setShowPopup(true);
            //console.log('setShowPopup(true) called for order:', orderNumber);
            return Promise.resolve();
        } catch (error) {
            console.error('Error opening modal:', error);
            return Promise.reject(error);
        }
    };

    // Handle URL parameter to open modal (e.g., /orders?openModal=12345)
    // This always opens in modal mode, regardless of inlineDropdownMode setting
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const orderNumberToOpen = searchParams.get('openModal');
        
        if (orderNumberToOpen) {
            //console.log('URL parameter detected - openModal:', orderNumberToOpen);
            // Force modal mode when opening from URL parameter
            // This ensures Teams "Order Card" button always opens modal, not inline
            // Use a delay to ensure component is fully mounted and ready
            const timer = setTimeout(async () => {
                //console.log('Attempting to open modal for order:', orderNumberToOpen);
                try {
                    await openModalByOrderNumber(orderNumberToOpen);
                    //console.log('Modal opened successfully for order:', orderNumberToOpen);
                    // Clean up URL by removing the parameter after modal opens
                    setTimeout(() => {
                        const newSearchParams = new URLSearchParams(window.location.search);
                        newSearchParams.delete('openModal');
                        const newSearch = newSearchParams.toString();
                        const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '');
                        window.history.replaceState({}, '', newUrl);
                        //console.log('URL cleaned up');
                    }, 500);
                } catch (err) {
                    console.error('Error opening modal for order', orderNumberToOpen, ':', err);
                }
            }, 1000); // Increased delay to ensure component and data are ready
            
            return () => {
                clearTimeout(timer);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    const getOrderFolderLink = useCallback((orderNum) => {
        const lines = orderDetailsData[orderNum];
        if (Array.isArray(lines)) {
            for (const orderLine of lines) {
                const linksForLine = orderAccessLinks?.[orderLine.id];
                if (Array.isArray(linksForLine) && linksForLine.length > 0) {
                    const latestLink = linksForLine[linksForLine.length - 1]?.url?.trim();
                    if (latestLink) {
                        return latestLink;
                    }
                }

                const fallbackUrl = orderLine.folderUrl?.trim();
                if (fallbackUrl) {
                    return fallbackUrl;
                }
            }
        }

        return null;
    }, [orderDetailsData, orderAccessLinks]);

    const resolveOrderFolderLinkForLine = useCallback((line) => {
        if (!line) return null;

        const orderNum = line?.order?.ordernum;
        const cachedLink = orderNum ? getOrderFolderLink(orderNum) : null;
        const rowLinks = orderAccessLinks?.[line.id];
        const rowLinkUrl = Array.isArray(rowLinks) && rowLinks.length > 0
            ? rowLinks[rowLinks.length - 1]?.url?.trim()
            : null;
        const namedUrls = line?.order?.orderUrls;
        const firstOrderUrl = Array.isArray(namedUrls) && namedUrls.length > 0
            ? namedUrls[0]?.url?.trim()
            : null;
        const fallbackUrl = typeof line.folderUrl === 'string' ? line.folderUrl.trim() : null;

        return cachedLink || rowLinkUrl || firstOrderUrl || fallbackUrl || null;
    }, [getOrderFolderLink, orderAccessLinks]);

    const renderInlineOrderHeader = useCallback((line, cachedOrderFolderLink) => {
        const inlineFolderLink = cachedOrderFolderLink || null;
        const rowLinks = orderAccessLinks?.[line.id];
        const rowLinkUrl = Array.isArray(rowLinks) && rowLinks.length > 0
            ? rowLinks[rowLinks.length - 1]?.url?.trim()
            : null;
        const fallbackUrl = typeof line.folderUrl === 'string' ? line.folderUrl.trim() : null;
        const folderLink = inlineFolderLink || rowLinkUrl || fallbackUrl || null;
        const folderTitle = folderLink ? `Open folder: ${folderLink}` : 'No folder link saved yet';
        const isOrange = shouldRowBeOrange(line);

        return (
            <div className="col-12 d-flex align-items-center justify-content-between">
                <div>
                    <b>Order Num</b>: <a 
                        href={`https://gigaflightinc.cetecerp.com/order/MN${line.order.ordernum}/view`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                    >
                        {line.order.ordernum}
                    </a>
                    <a
                        href={folderLink || '#'}
                        onClick={(event) => {
                            if (!folderLink) {
                                event.preventDefault();
                            }
                        }}
                        target={folderLink ? '_blank' : undefined}
                        rel={folderLink ? 'noreferrer' : undefined}
                        style={{ 
                            cursor: folderLink ? 'pointer' : 'not-allowed',
                            textDecoration: 'none',
                            marginLeft: '4px'
                        }}
                        title={folderTitle}
                    >
                        <i className="fa fa-folder" aria-hidden="true" style={{ fontSize: '16px', color: folderLink ? (isOrange ? '#cc7a00' : '#ff8c00') : '#cccccc' }}></i>
                    </a>
                </div>
                <div>
                    <b>WO#</b>: <a 
                        href={`https://gigaflightinc.cetecerp.com/order/MN${line.order?.woNum}/view`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                    >
                        {line.order?.woNum || 'N/A'}
                    </a>
                    {line.order?.woNum && line.order.woNum !== '-' && line.order.woNum !== 'N/A' && (
                        <a
                            href={line.order?.woUrl || '#'}
                            onClick={(event) => {
                                if (!line.order?.woUrl) {
                                    event.preventDefault();
                                }
                            }}
                            target={line.order?.woUrl ? '_blank' : undefined}
                            rel={line.order?.woUrl ? 'noreferrer' : undefined}
                            style={{ 
                                cursor: line.order?.woUrl ? 'pointer' : 'not-allowed',
                                textDecoration: 'none',
                                marginLeft: '4px'
                            }}
                            title={line.order?.woUrl ? `Open WO folder: ${line.order.woUrl}` : 'No WO folder link available'}
                        >
                            <i className="fa fa-folder" aria-hidden="true" style={{ fontSize: '16px', color: line.order?.woUrl ? (isOrange ? '#cc7a00' : '#ff8c00') : '#cccccc' }}></i>
                        </a>
                    )}
                    {renderPrevWoNum(line)}
                </div>
                <div><b>PO Num</b>: {line.order.custponum}</div>
                <div>
                    <b>Customer Name</b>: {line.order.customer?.id ? (
                        <a 
                            href={`https://gigaflightinc.cetecerp.com/customer/${line.order.customer.id}/view`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                        >
                            {line.order.customer.name || 'N/A'}
                        </a>
                    ) : (
                        line.order.customer?.name || 'N/A'
                    )}
                </div>
            </div>
        );
    }, [orderAccessLinks]);

    // Handle inline dropdown expansion
    const toggleInlineOrderDetails = async (line) => {
        //console.log('toggleInlineOrderDetails called with:', line);
        const orderNum = line.order?.ordernum || line.ordernum;
        //console.log('orderNum:', orderNum);
        const isExpanded = expandedInlineOrders[orderNum];
        //console.log('isExpanded:', isExpanded);

        if (isExpanded) {
            setExpandedInlineOrders(prev => {
                const newState = { ...prev };
                delete newState[orderNum];
                return newState;
            });
        } else {
            if (!orderDetailsData[orderNum]) {
                const orders = await orderFetch(0, 10, "", "lineitem", "ascending", null, "", "", "", "", "", "", "", "", "", true, true, "", orderNum);
                if (orders !== null) {
                    setOrderDetailsData(prev => ({
                        ...prev,
                        [orderNum]: stripArchivedBomParts(orders.order)
                    }));
                }
            }
            setExpandedInlineOrders(prev => ({
                ...prev,
                [orderNum]: true
            }));

            // Set default active view to 'orderLines'
            setInlineActiveView(prev => ({
                ...prev,
                [orderNum]: 'orderLines'
            }));
        }
    };

    // Handle eye icon click - choose between modal or inline
    const handleEyeIconClick = async (line) => {
        if (inlineDropdownMode) {
            await toggleInlineOrderDetails(line);
        } else {
            await showOrderPOP(line);
        }
    };

    // Handle history icon click - open the order's full audit history
    const handleHistoryIconClick = (line) => {
        const orderNumber = line?.order?.ordernum || line?.ordernum;
        if (orderNumber) {
            setHistoryModalOrder(orderNumber);
        }
    };

    // Handle inline view changes
    const handleInlineViewChange = (orderNum, view) => {
        setInlineActiveView(prev => ({
            ...prev,
            [orderNum]: view
        }));
    };

    // Handle BOM row expansion toggle
    const toggleInlineBomRow = (orderNum, lineIndex) => {
        const key = `${orderNum}-${lineIndex}`;
        setExpandedInlineBomRows(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    // Handle inline switch view
    const handleInlineSwitchView = (orderNum) => {
        const currentView = inlineActiveView[orderNum] || 'orderLines';
        const newView = currentView === 'orderLines' ? 'bomParts' : 'orderLines';
        setInlineActiveView(prev => ({
            ...prev,
            [orderNum]: newView
        }));
    };

    // Handle inline dual view
    const handleInlineDualView = (orderNum) => {
        setInlineActiveView(prev => ({
            ...prev,
            [orderNum]: 'both'
        }));
    };

    const closePopup = () => {
        setShowPopup(false);
        setSelectedSourceLine(null);
    };

    // Function to navigate to dedicated order details page
    const handleNavigateToOrderDetails = (line) => {
        const orderNum = line.order?.ordernum || line.ordernum;
        if (!orderNum) {
            console.error('No order number found');
            return;
        }
        // Navigate to the dedicated order details page
        navigate(`/order-details/${orderNum}`);
    };

    // Function to copy shareable order link to clipboard
    const handleCopyOrderLink = (line) => {
        const orderNum = line.order?.ordernum || line.ordernum;
        if (!orderNum) {
            console.error('No order number found');
            return;
        }

        // Generate the shareable URL to the dedicated order details page
        const shareableUrl = `${window.location.origin}/order-details/${orderNum}`;

        // Copy to clipboard
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(shareableUrl)
                .then(() => {
                    // Show success feedback
                    setCopiedField(`orderLink-${orderNum}`);
                    setTimeout(() => {
                        setCopiedField(null);
                    }, 2000);
                    //console.log('Shareable link copied:', shareableUrl);
                })
                .catch(err => {
                    console.error('Failed to copy link:', err);
                    alert('Failed to copy link. Please try again.');
                });
        } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = shareableUrl;
            textArea.style.position = 'fixed';
            textArea.style.top = '-9999px';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                setCopiedField(`orderLink-${orderNum}`);
                setTimeout(() => {
                    setCopiedField(null);
                }, 2000);
                //console.log('Shareable link copied:', shareableUrl);
            } catch (err) {
                console.error('Failed to copy link:', err);
                alert('Failed to copy link. Please try again.');
            }
            document.body.removeChild(textArea);
        }
    };



    // Refresh function for OrderRefresh component
    const handleRefreshOrders = async () => {

        // Get current user email
    const userEmail = localStorage.getItem('userEmail');
    
    // List of authorized users who can refresh orders
    const authorizedUsers = [
        'megan.hackettgaddam@gigaflightinc.com',
        'anabella.sengsouvanh@gigaflightinc.com',
        'hannah.mohror@gigaflightinc.com',
        'felicia.watkinsjohnson@gigaflightinc.com',
        'test@gmail.com'
    ];

    // Check if current user is authorized
    if (!authorizedUsers.includes(userEmail)) {
        alert('You don\'t have access to refresh the orders');
        return;
    }

        setIsRefreshing(true);
        try {

            const userObj = {
                //email: localStorage.getItem('userEmail'),
                userName: userEmail,
                name: "Production" // extra field if you added it to backend User
            };
            // Call the existing fetch function to get fresh data

            const comment = await syncOrders(userObj);
            //  await fetchOrders(index, maxRecords, search, singleOrder = false, orderNum = null, lineIds = null, ordernnum = null);

            // Update last refresh data
            setLastRefreshData({
                timestamp: new Date(),
                //user: 'Current User', // You can get this from your auth system
                user: userEmail,
                success: true
            });
        } catch (error) {
            console.error('Refresh failed:', error);
            setLastRefreshData({
                timestamp: new Date(),
                //user: 'Current User',
                user: userEmail,
                success: false,
                error: error.message
            });
        } finally {
            setIsRefreshing(false);
        }
    };

    // Add these state declarations to your Orders.js component
    const [lineTagsToDeselect, setLineTagsToDeselect] = useState({});
    const [lineStatusDropdownOpen, setLineStatusDropdownOpen] = useState({});
    const [pendingLineRemoval, setPendingLineRemoval] = useState({});
    
    // Bulk mode state for inline order view - per order
    const [orderBulkModeEnabled, setOrderBulkModeEnabled] = useState({});
    const [orderHasBulkChanges, setOrderHasBulkChanges] = useState({});
    const [isSubmittingBulk, setIsSubmittingBulk] = useState(false);

    // Line Status functions
    const toggleLineStatusDropdown = (lineId) => {
        setLineStatusDropdownOpen(prev => {
            // Close any other open dropdowns first
            const hasOtherOpen = Object.keys(prev).some(id => id !== lineId && prev[id]);
            
            // If this dropdown is already open, close it
            if (prev[lineId]) {
                return {};
            }
            
            // If other dropdowns are open, close them and open this one
            if (hasOtherOpen) {
                return { [lineId]: true };
            }
            
            // Otherwise, just open this dropdown
            return { [lineId]: true };
        });
    };

    const handleLineStatusToggle = useCallback((lineId, tag, orderNum) => {
        const isBulkMode = !!(orderNum && orderBulkModeEnabled && orderBulkModeEnabled[orderNum]);
        const lineIdKey = String(lineId);
        const orderDetailsArray = orderNum && orderDetailsData ? orderDetailsData[orderNum] : null;
        const targetIds = isBulkMode && Array.isArray(orderDetailsArray) && orderDetailsArray.length > 0
            ? orderDetailsArray.map((line) => String(line.id))
            : [lineIdKey];

        const isEffectivelySelected =
            (lineStatusSelections[lineIdKey] || []).some((s) => s.label === tag.label) ||
            (
                (submittedLineStatuses[lineIdKey] || []).some((s) => s.label === tag.label) &&
                !(lineTagsToDeselect[lineIdKey] || []).some((t) => t.label === tag.label)
            );
        const isAdding = !isEffectivelySelected;

        setLineStatusSelections((prev) => {
            const next = { ...prev };
            targetIds.forEach((itemId) => {
                const current = next[itemId] || [];
                const inSel = current.some((s) => s.label === tag.label);
                const inSub = (submittedLineStatuses[itemId] || []).some((s) => s.label === tag.label);

                if (isAdding) {
                    // Only stage new tags that are not already saved (pending-removal restore is handled below)
                    if (!inSel && !inSub) {
                        next[itemId] = [...current, tag];
                    }
                } else if (inSel) {
                    next[itemId] = current.filter((s) => s.label !== tag.label);
                }
            });
            return next;
        });

        setLineTagsToDeselect((prev) => {
            const next = { ...prev };
            targetIds.forEach((itemId) => {
                const current = next[itemId] || [];
                const marked = current.some((t) => t.label === tag.label);
                const inSub = (submittedLineStatuses[itemId] || []).some((s) => s.label === tag.label);

                if (isAdding) {
                    if (marked) {
                        next[itemId] = current.filter((t) => t.label !== tag.label);
                    }
                } else if (inSub && !marked) {
                    // Keep saved tag visible in grey pending-removal state until bulk/row Save
                    next[itemId] = [...current, tag];
                }
            });
            return next;
        });

        setPendingLineRemoval((prev) => {
            const next = { ...prev };
            targetIds.forEach((itemId) => {
                if (isAdding) {
                    next[itemId] = false;
                    return;
                }
                const remainingSelections = (lineStatusSelections[itemId] || []).filter(
                    (s) => s.label !== tag.label
                ).length;
                const remainingSubmitted = (submittedLineStatuses[itemId] || []).filter((s) => {
                    if (s.label === tag.label) return false;
                    return !(lineTagsToDeselect[itemId] || []).some((t) => t.label === s.label);
                }).length;
                next[itemId] = remainingSelections === 0 && remainingSubmitted === 0;
            });
            return next;
        });

        if (isBulkMode && orderNum) {
            setOrderHasBulkChanges((prev) => ({ ...prev, [orderNum]: true }));
        }
    }, [orderBulkModeEnabled, orderDetailsData, submittedLineStatuses, lineStatusSelections, lineTagsToDeselect]);

    const handleLineTagDeselect = (lineId, tag) => {
        const lineIdKey = String(lineId);
        setLineTagsToDeselect(prev => {
            const currentDeselections = prev[lineIdKey] || [];
            const isAlreadyMarked = currentDeselections.some(t => t.label === tag.label);
            const submittedTags = submittedLineStatuses[lineIdKey] || [];

            if (isAlreadyMarked) {
                const newDeselections = currentDeselections.filter(t => t.label !== tag.label);

                if (newDeselections.length === 0) {
                    setPendingLineRemoval(prevPending => ({
                        ...prevPending,
                        [lineIdKey]: false
                    }));
                }

                return {
                    ...prev,
                    [lineIdKey]: newDeselections
                };
            }

            const newDeselections = [...currentDeselections, tag];

            if (newDeselections.length === submittedTags.length && (lineStatusSelections[lineIdKey] || []).length === 0) {
                setPendingLineRemoval(prevPending => ({
                    ...prevPending,
                    [lineIdKey]: true
                }));
            }

            return {
                ...prev,
                [lineIdKey]: newDeselections
            };
        });
    };

    // Bulk tag deselection (toggle pending removal on saved statuses)
    const handleBulkLineTagDeselect = useCallback((lineId, tag, orderNum) => {
        const isBulkMode = orderNum && orderBulkModeEnabled && orderBulkModeEnabled[orderNum];

        if (!isBulkMode) {
            handleLineTagDeselect(lineId, tag);
            return;
        }

        const orderDetailsArray = orderDetailsData && orderDetailsData[orderNum];
        if (!Array.isArray(orderDetailsArray) || orderDetailsArray.length === 0) {
            console.warn('No order details found for bulk deselect - order:', orderNum);
            return;
        }

        const clickedId = String(lineId);
        const shouldMark = !(lineTagsToDeselect[clickedId] || []).some((t) => t.label === tag.label);

        setLineTagsToDeselect((prev) => {
            const newDeselections = { ...prev };
            let hasChanges = false;

            orderDetailsArray.forEach((line) => {
                const itemId = String(line.id);
                const submittedTags = submittedLineStatuses[itemId] || [];
                if (!submittedTags.some((t) => t.label === tag.label)) return;

                const currentDeselections = newDeselections[itemId] || [];
                const isAlreadyMarked = currentDeselections.some((t) => t.label === tag.label);

                if (shouldMark && !isAlreadyMarked) {
                    newDeselections[itemId] = [...currentDeselections, tag];
                    hasChanges = true;
                } else if (!shouldMark && isAlreadyMarked) {
                    newDeselections[itemId] = currentDeselections.filter((t) => t.label !== tag.label);
                    hasChanges = true;
                }
            });

            if (hasChanges && orderNum) {
                setOrderHasBulkChanges((prevBulk) => ({ ...prevBulk, [orderNum]: true }));
            }

            return newDeselections;
        });

        setPendingLineRemoval((prev) => {
            const next = { ...prev };
            orderDetailsArray.forEach((line) => {
                const itemId = String(line.id);
                const submittedTags = submittedLineStatuses[itemId] || [];
                if (!submittedTags.some((t) => t.label === tag.label)) return;

                if (shouldMark) {
                    const remainingSelections = (lineStatusSelections[itemId] || []).length;
                    const remainingSubmitted = submittedTags.filter((t) => t.label !== tag.label).length;
                    next[itemId] = remainingSelections === 0 && remainingSubmitted === 0;
                } else {
                    next[itemId] = false;
                }
            });
            return next;
        });
    }, [orderBulkModeEnabled, orderDetailsData, submittedLineStatuses, lineStatusSelections, lineTagsToDeselect]);

    const hasLineChangesToSubmit = useCallback((lineId) => {
        const currentSelections = lineStatusSelections[lineId] || [];
        const tagsToRemove = lineTagsToDeselect[lineId] || [];

        return currentSelections.length > 0 || tagsToRemove.length > 0 || pendingLineRemoval[lineId];
    }, [lineStatusSelections, lineTagsToDeselect, pendingLineRemoval]);

    // Announce the open line-status dropdown as our focused cell and hold a soft
    // lock on it. One effect covers every open/close path (toggle, outside click,
    // scroll-away, submit) because they all funnel through lineStatusDropdownOpen.
    const openLineStatusId = useMemo(
        () => Object.keys(lineStatusDropdownOpen).find((id) => lineStatusDropdownOpen[id]) || null,
        [lineStatusDropdownOpen]
    );

    useEffect(() => {
        if (!openLineStatusId) return undefined;
        const key = lineStatusCell(openLineStatusId);
        presenceFocus(key);
        return () => presenceBlur(key);
    }, [openLineStatusId, lineStatusCell, presenceFocus, presenceBlur]);

    // Order Status: dropdownOpenId is the single source of truth for "which row
    // has the tag picker open", so one focused cell covers every open/close path.
    useFocusedCell(
        dropdownOpenId ? orderStatusCell(dropdownOpenId) : null,
        Boolean(dropdownOpenId),
        presence,
        { lock: true }
    );

    // Notes are a conversation: show who has each chat window open. Minimizing or
    // closing the window drops the face, even if the row that opened it has scrolled away.
    const openCommentLineKey = useMemo(() => {
        const ids = [];
        (commentDock?.threads || []).forEach((thread) => {
            if (thread.minimized || thread.quoteId || thread.poLineId) return;
            if (thread.orderLineId == null || thread.orderLineId === '') return;
            ids.push(String(thread.orderLineId));
        });
        ids.sort();
        return ids.join('|');
    }, [commentDock?.threads]);

    useEffect(() => {
        const keys = (openCommentLineKey ? openCommentLineKey.split('|') : []).map((id) => notesCell(id));
        keys.forEach((key) => presenceFocus(key, { lock: false }));
        return () => {
            keys.forEach((key) => presenceBlur(key));
        };
    }, [openCommentLineKey, notesCell, presenceFocus, presenceBlur]);

    /** Wire one row's notes popup to presence: claim that cell while it is open. */
    const handleNotesVisibility = useCallback((lineId, isVisible) => {
        const id = String(lineId);
        setOpenNotesLineIds((prev) => {
            if (isVisible) {
                if (prev.has(id)) return prev;
                const next = new Set(prev);
                next.add(id);
                return next;
            }
            if (!prev.has(id)) return prev;
            const next = new Set(prev);
            next.delete(id);
            return next;
        });
    }, []);

    /** A line's comments as the old Notes column showed them: saved + just added, newest first. */
    const getLineComments = (line) => sortCommentsByDate([
        ...(line.comment || []),
        ...(commentsMap[line.id] || []),
    ]);

    const isOrderCommentChatOpen = (orderNumber) => {
        const key = getOrderThreadKey(orderNumber);
        return Boolean(key && commentDock?.threads?.some((thread) => thread.key === key && !thread.minimized));
    };

    /** Header view: one chat that shows every line's comments for the order.
     *  A new note from this chat is stored on the header row's line. */
    const renderInfoComments = (line) => {
        const orderNumber = line.order?.ordernum || line.ordernum;
        const lineComments = collectOrderComments(line, orderDetailsData, commentsMap);
        const commentWatchers = presenceUsersInCell(notesCell(line.id));
        const resolveLineId = (commentId) => findCommentLineId(commentId, line, orderDetailsData, commentsMap);
        return (
            <HoverPO
                hideBadge
                threadKey={getOrderThreadKey(orderNumber)}
                orderLineId={line.id}
                comments={lineComments}
                orderNumber={orderNumber}
                customerName={line.order?.customer?.name}
                customerId={line.order?.customer?.id}
                sourcePage="orders"
                threadTitle={orderNumber ? `${orderNumber} comments` : 'Comments'}
                onVisibleChange={(isVisible) => handleNotesVisibility(line.id, isVisible)}
                onDeleteComment={(commentId) => handleDeleteComment(resolveLineId(commentId), commentId)}
                onResolveThread={(commentId) => {
                    if (commentId == null) {
                        orderLinesForHeader(line, orderDetailsData).forEach((row) => handleResolveThread(row.id, null));
                        return;
                    }
                    handleResolveThread(resolveLineId(commentId), commentId);
                }}
                onAddComment={(newComment, status) => handleAddComment(line.id, newComment, status)}
            >
                <OrderCommentsButton
                    total={lineComments.length}
                    unread={notificationsCtx ? notificationsCtx.unreadCountForOrder(orderNumber) : 0}
                    presenceUsers={commentWatchers}
                    active={isOrderCommentChatOpen(orderNumber) || isCommentChatOpen(line.id) || commentWatchers.length > 0}
                    onClick={() => {
                        setUpdatePopUp(line);
                        setFormData(line.comment || null);
                    }}
                />
            </HoverPO>
        );
    };

    /** Line view: comments belong to this order line only. */
    const renderLineComments = (line) => {
        const lineNo = line?.lineitem != null && String(line.lineitem) !== '' ? `Line ${line.lineitem}` : '';
        const lineComments = getLineComments(line).map((comment) => ({
            ...comment,
            lineLabel: comment?.lineLabel || lineNo,
        }));
        const commentWatchers = presenceUsersInCell(notesCell(line.id));
        const orderNumber = line.order?.ordernum || line.ordernum;
        return (
            <HoverPO
                hideBadge
                orderLineId={line.id}
                comments={lineComments}
                orderNumber={orderNumber}
                customerName={line.order?.customer?.name}
                customerId={line.order?.customer?.id}
                sourcePage="orders"
                lineInfo={lineNo}
                threadTitle={orderNumber && lineNo ? `${orderNumber} · ${lineNo}` : (orderNumber || 'Comments')}
                onVisibleChange={(isVisible) => handleNotesVisibility(line.id, isVisible)}
                onDeleteComment={(commentId) => handleDeleteComment(line.id, commentId)}
                onResolveThread={(commentId) => handleResolveThread(line.id, commentId)}
                onAddComment={(newComment, status) => handleAddComment(line.id, newComment, status)}
            >
                <OrderCommentsButton
                    total={lineComments.length}
                    unread={getUnreadCommentCount(line)}
                    presenceUsers={commentWatchers}
                    active={isCommentChatOpen(line.id) || commentWatchers.length > 0}
                />
            </HoverPO>
        );
    };

    /** Sticky Notes column cell (replaces the Notes column's latest-comment preview). */
    const renderStickyNotes = (line) => {
        const orderNumber = line.order?.ordernum || line.ordernum;
        return (
            <StickyNotesCell
                orderNumber={orderNumber ? String(orderNumber) : ''}
                orderLineId={line.id}
                customerName={line.order?.customer?.name}
                notes={stickyNotes.notesByOrder[String(orderNumber)] || []}
                pinned={shippingInstructions.forOrder(line.order || line)}
                shippingComments={line.order?.shipping_instructions || ''}
                customerId={shippingInstructions.customerIdFor(line.order || line)}
                onAddShipping={shippingInstructions.add}
                onUpdateShipping={shippingInstructions.update}
                onRemoveShipping={shippingInstructions.remove}
                onAdd={stickyNotes.add}
                onUpdate={stickyNotes.update}
                onRemove={stickyNotes.remove}
            />
        );
    };

    /** Push a committed line status into every piece of grid state that renders it.
     *  Shared by the local submit path and by remote saves arriving over presence. */
    const applyLineStatusPatch = useCallback((lineId, finalSelections) => {
        const lineJson = JSON.stringify(finalSelections);

        setSubmittedLineStatuses(prev => ({ ...prev, [lineId]: finalSelections }));
        setLineStatusSelections(prev => ({ ...prev, [lineId]: [] }));
        setLineTagsToDeselect(prev => ({ ...prev, [lineId]: [] }));
        setPendingLineRemoval(prev => ({ ...prev, [lineId]: false }));

        setOrderDetailsData(prev => {
            const updated = { ...prev };
            const lineIdNum = typeof lineId === 'string' ? parseInt(lineId, 10) : lineId;
            Object.keys(updated).forEach(orderNum => {
                if (Array.isArray(updated[orderNum])) {
                    updated[orderNum] = updated[orderNum].map(line => {
                        if (line.id === lineIdNum || String(line.id) === String(lineId)) {
                            return { ...line, lineItemStatus: lineJson };
                        }
                        return line;
                    });
                }
            });
            return updated;
        });

        const patchRow = (prev) =>
            Array.isArray(prev)
                ? prev.map((row) =>
                      String(row.id) === String(lineId) ? { ...row, lineItemStatus: lineJson } : row
                  )
                : prev;
        setOrderData(patchRow);
        setNewOrdersData(patchRow);
    }, []);

    /** Someone else saved on this page - patch that one cell, no reload. */
    const applyRemoteSave = useCallback((evt) => {
        if (!evt || !evt.lineId) return;
        switch (evt.kind) {
            case 'lineStatus':
                applyLineStatusPatch(evt.lineId, evt.value || []);
                break;
            case 'orderStatus':
                applyOrderStatusPatch(evt.lineId, evt.value || []);
                break;
            case 'comment':
                if (evt.quoteId || evt.poLineId) break;
                applyCommentPatch(evt.lineId, evt.value);
                break;
            case 'stickyNotes':
                // lineId carries the order number for sticky notes.
                applyRemoteStickyNotes(evt.lineId, evt.value || []);
                break;
            default:
                break;
        }
    }, [applyLineStatusPatch, applyOrderStatusPatch, applyCommentPatch, applyRemoteStickyNotes]);

    const handleLineStatusSubmit = async (lineId) => {
        const lockedBy = lineStatusLockOwner(lineId);
        if (lockedBy) {
            alert(`${lockedBy.name} is editing this line status. Try again in a moment.`);
            return;
        }

        console.group('%c🎯 [handleLineStatusSubmit] Handler called', 'color: #BD83B8; font-weight: bold; font-size: 12px');
        //console.log('lineId:', lineId);
        //console.log('lineStatusSelections state:', lineStatusSelections);
        //console.log('submittedLineStatuses state:', submittedLineStatuses);
        //console.log('lineTagsToDeselect state:', lineTagsToDeselect);
        
        const currentSelections = lineStatusSelections[lineId] || [];
        const submittedSelections = submittedLineStatuses[lineId] || [];
        const tagsToRemove = lineTagsToDeselect[lineId] || [];
        
        //console.log('currentSelections:', currentSelections);
        //console.log('submittedSelections:', submittedSelections);
        //console.log('tagsToRemove:', tagsToRemove);

        const finalSelections = [
            ...currentSelections,
            ...submittedSelections.filter(
                tag => !tagsToRemove.some(removeTag => removeTag.label === tag.label)
            )
        ].filter((tag, index, array) =>
            array.findIndex(t => t.label === tag.label) === index
        );
        
        //console.log('finalSelections to save:', finalSelections);

        const submitData = {
            orderLineId: lineId,
            status: JSON.stringify(finalSelections),
        };
        
        //console.log('submitData:', submitData);
        console.groupEnd();

        try {
            const result = await saveLineStatus(submitData);

            if (!result) {
                console.warn('⚠️ [Orders.js] saveLineStatus returned null/falsy value');
                alert("Failed to save line status. Check console for details.");
                return;
            }

            notifyOrderHistoryChanged(
                (Array.isArray(newOrdersData) ? newOrdersData : [])
                    .concat(Array.isArray(orderData) ? orderData : [])
                    .find((l) => String(l?.id) === String(lineId))?.order?.ordernum
            );

            //console.log('%c✅ [Orders.js] Line status saved successfully!', 'color: #28a745; font-weight: bold', result);

            // Close dropdown after successful save
            setLineStatusDropdownOpen(prev => {
                const newState = { ...prev };
                delete newState[lineId];
                return newState;
            });

            applyLineStatusPatch(lineId, finalSelections);

            // Let everyone else on this page patch the same cell without a refresh.
            presence.broadcastSave({
                cell: lineStatusCell(lineId),
                kind: 'lineStatus',
                lineId: String(lineId),
                value: finalSelections,
            });

        } catch (error) {
            console.error("❌ Error submitting line status:", error);
            alert("Error submitting line status. Please try again.");
        }
    };
    
    // New handler for bulk submit button in Orders.js
    const handleBulkLineStatusSubmit = async (orderNum) => {
        if (!orderNum || !orderHasBulkChanges[orderNum]) return;
        
        setIsSubmittingBulk(true);
        
        try {
            // Get all lines in this order
            const orderDetailsArray = orderDetailsData && orderDetailsData[orderNum];
            if (!Array.isArray(orderDetailsArray) || orderDetailsArray.length === 0) {
                alert("No order details found");
                setIsSubmittingBulk(false);
                return;
            }
            
            // Collect all lines in this order that have changes
            const linesToSubmit = [];
            orderDetailsArray.forEach((line) => {
                const lineId = String(line.id);
                if (hasLineChangesToSubmit(lineId)) {
                    linesToSubmit.push(lineId);
                }
            });
            
            //console.log(`Bulk submit for order ${orderNum}: found ${linesToSubmit.length} lines with changes`);
            
            if (linesToSubmit.length === 0) {
                alert("No changes to submit");
                setIsSubmittingBulk(false);
                return;
            }
            
            // Submit each line one by one (API accepts one at a time)
            for (const lineId of linesToSubmit) {
                const currentSelections = lineStatusSelections[lineId] || [];
                const submittedSelections = submittedLineStatuses[lineId] || [];
                const tagsToRemove = lineTagsToDeselect[lineId] || [];

                // Calculate final selections
                const finalSelections = [
                    ...currentSelections,
                    ...submittedSelections.filter(
                        tag => !tagsToRemove.some(removeTag => removeTag.label === tag.label)
                    )
                ].filter((tag, index, array) =>
                    array.findIndex(t => t.label === tag.label) === index
                );

                const submitData = {
                    orderLineId: lineId,
                    status: JSON.stringify(finalSelections),
                };

                //console.log("Submitting bulk lineItemStatus:", submitData);
                await saveLineStatus(submitData);
                notifyOrderHistoryChanged(
                    (Array.isArray(newOrdersData) ? newOrdersData : [])
                        .concat(Array.isArray(orderData) ? orderData : [])
                        .find((l) => String(l?.id) === String(lineId))?.order?.ordernum
                );

                // Update local state for this line
                setSubmittedLineStatuses(prev => ({
                    ...prev,
                    [lineId]: finalSelections
                }));

                setLineStatusSelections(prev => ({
                    ...prev,
                    [lineId]: []
                }));

                setLineTagsToDeselect(prev => ({
                    ...prev,
                    [lineId]: []
                }));

                setPendingLineRemoval(prev => ({
                    ...prev,
                    [lineId]: false
                }));
                
                // Update orderDetailsData to reflect the saved changes
                setOrderDetailsData(prev => {
                    const updated = { ...prev };
                    const lineIdNum = typeof lineId === 'string' ? parseInt(lineId, 10) : lineId;
                    Object.keys(updated).forEach(orderNum => {
                        if (Array.isArray(updated[orderNum])) {
                            updated[orderNum] = updated[orderNum].map(line => {
                                if (line.id === lineIdNum || String(line.id) === String(lineId)) {
                                    return {
                                        ...line,
                                        lineItemStatus: JSON.stringify(finalSelections)
                                    };
                                }
                                return line;
                            });
                        }
                    });
                    return updated;
                });
            }
            
            // Clear bulk changes flag for this order
            if (orderNum) {
                setOrderHasBulkChanges(prev => ({ ...prev, [orderNum]: false }));
            }
            alert(`Successfully updated ${linesToSubmit.length} order lines!`);
        } catch (error) {
            console.error("Error submitting bulk line status:", error);
            alert("Error submitting bulk line status. Please try again.");
        } finally {
            setIsSubmittingBulk(false);
        }
    };

    // Load line status data when order details are fetched
    useEffect(() => {
        if (orderDetailsData && Object.keys(orderDetailsData).length > 0) {
            Object.values(orderDetailsData).forEach(orderLines => {
                if (Array.isArray(orderLines)) {
                    orderLines.forEach((line) => {
                        if (line?.lineItemStatus) {
                            try {
                                const orderLineStatus = JSON.parse(line.lineItemStatus);
                                setSubmittedLineStatuses((prev) => ({
                                    ...prev,
                                    [line.id]: orderLineStatus,
                                }));
                            } catch (e) {
                                console.error("Invalid JSON in lineItemStatus:", e);
                            }
                        }
                    });
                }
            });
        }
    }, [orderDetailsData]);

    // Per-order Line Status Report: missing-parts count (negative QTY AVAIL in BOM Parts tab) and order-line count
    const orderLineStatusReportMap = useMemo(
        () => buildOrderLineStatusReportMapFromDetails(orderDetailsData, excludedAvailabilityPartsByOrder),
        [orderDetailsData, excludedAvailabilityPartsByOrder]
    );

    const mergedKpiLines = useMemo(() => {
        const map = new Map();
        [...(orderData || []), ...(newOrdersData || [])].forEach((line) => {
            if (!line?.id) return;
            if (archivedOrderNums.has(String(line?.order?.ordernum || ''))) return;
            map.set(line.id, line);
        });
        return Array.from(map.values());
    }, [orderData, newOrdersData, archivedOrderNums]);

    const dueTodayKpiLines = useMemo(() =>
        mergedKpiLines.filter((line) => {
            const ds = getEarliestPromisedDateForOrder(line);
            if (!ds) return false;
            const orderDay = parseAsLocalCalendarDate(ds);
            if (!orderDay) return false;
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return orderDay.getTime() === today.getTime();
        }), [mergedKpiLines, orderDetailsData, orderData, newOrdersData, archivedOrderIds, archivedOrderNums]);

    const pastDueKpiLines = useMemo(() =>
        mergedKpiLines.filter((line) => {
            const ds = getEarliestPromisedDateForOrder(line);
            if (!ds) return false;
            const orderDay = parseAsLocalCalendarDate(ds);
            if (!orderDay) return false;
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return orderDay.getTime() < today.getTime();
        }), [mergedKpiLines, orderDetailsData, orderData, newOrdersData, archivedOrderIds, archivedOrderNums]);

    const dueKpiLines = useMemo(
        () => [...dueTodayKpiLines, ...pastDueKpiLines],
        [dueTodayKpiLines, pastDueKpiLines]
    );

    const missingKpiLines = useMemo(() => {
        const nums = new Set(
            Object.entries(orderLineStatusReportMap || {})
                .filter(([, v]) => (v?.missingPartsCount || 0) > 0)
                .map(([k]) => String(k))
        );
        return mergedKpiLines.filter((line) => nums.has(String(line?.order?.ordernum || '')));
    }, [mergedKpiLines, orderLineStatusReportMap]);

    const uniqueKpiOrders = useMemo(
        () => new Set(mergedKpiLines.map((l) => l?.order?.ordernum).filter(Boolean)).size,
        [mergedKpiLines]
    );

    const missingKpiOrderCount = useMemo(
        () => new Set(missingKpiLines.map((l) => l?.order?.ordernum).filter(Boolean)).size,
        [missingKpiLines]
    );
    const missingKpiTotalBomCount = useMemo(() => {
        const orderNums = Array.from(new Set(missingKpiLines.map((l) => String(l?.order?.ordernum || '')).filter(Boolean)));
        return orderNums.reduce((total, orderNum) => {
            const report = orderLineStatusReportMap?.[orderNum];
            return total + (report?.missingPartsCount || 0);
        }, 0);
    }, [missingKpiLines, orderLineStatusReportMap]);

    const dueTodayKpiOrderCount = useMemo(
        () => new Set(dueTodayKpiLines.map((l) => l?.order?.ordernum).filter(Boolean)).size,
        [dueTodayKpiLines]
    );

    const pastDueKpiOrderCount = useMemo(
        () => new Set(pastDueKpiLines.map((l) => l?.order?.ordernum).filter(Boolean)).size,
        [pastDueKpiLines]
    );

    /** New Orders section lines with entry date in calendar week (Mon–Sun) vs prior week — Total card only. */
    const newOrdersWeekStats = useMemo(() => {
        const weekBounds = (weekOffsetFromCurrent) => {
            const now = new Date();
            const day = now.getDay();
            const mondayThisWeek = new Date(now);
            mondayThisWeek.setDate(now.getDate() + (day === 0 ? -6 : 1 - day));
            mondayThisWeek.setHours(0, 0, 0, 0);
            const weekStart = new Date(mondayThisWeek);
            weekStart.setDate(mondayThisWeek.getDate() - weekOffsetFromCurrent * 7);
            const weekEnd = new Date(weekStart);
            weekEnd.setDate(weekStart.getDate() + 6);
            weekEnd.setHours(23, 59, 59, 999);
            return { weekStart, weekEnd };
        };

        const lines = (newOrdersData || []).filter(
            (l) => !archivedOrderNums.has(String(l?.order?.ordernum || ''))
        );

        const countInWeek = (weekOffset) => {
            const { weekStart, weekEnd } = weekBounds(weekOffset);
            return lines.filter((line) => {
                const d = getOrderLineEntryDate(line);
                if (!d) return false;
                return d >= weekStart && d <= weekEnd;
            }).length;
        };

        const thisWeekCount = countInWeek(0);
        const lastWeekCount = countInWeek(1);
        const withEntryDate = lines.filter((l) => getOrderLineEntryDate(l)).length;

        let pctVsLastWeek = null;
        let changeText = '';
        /** One line for collapsed card (e.g. ↑ 12% from last week) */
        let trendShort = '';
        let trendDir = 'neutral';

        if (lastWeekCount === 0 && thisWeekCount === 0) {
            changeText =
                withEntryDate === 0
                    ? 'Add entry dates on lines to compare weeks, or expand date range'
                    : 'No new-order lines dated this week or last week';
            trendShort = '';
            trendDir = 'neutral';
        } else if (lastWeekCount === 0 && thisWeekCount > 0) {
            changeText = `New activity this week (${thisWeekCount} vs none last week)`;
            pctVsLastWeek = null;
            trendShort = 'New this week';
            trendDir = 'up';
        } else if (lastWeekCount > 0) {
            pctVsLastWeek = Math.round(((thisWeekCount - lastWeekCount) / lastWeekCount) * 1000) / 10;
            const delta = thisWeekCount - lastWeekCount;
            const dSign = delta >= 0 ? '+' : '';
            const pSign = pctVsLastWeek >= 0 ? '+' : '';
            changeText = `${dSign}${delta} vs last week (${pSign}${pctVsLastWeek}%)`;
            trendShort = `${pSign}${pctVsLastWeek}% from last week`;
            if (pctVsLastWeek > 0) trendDir = 'up';
            else if (pctVsLastWeek < 0) trendDir = 'down';
            else trendDir = 'flat';
        }

        return {
            thisWeekCount,
            lastWeekCount,
            changeText,
            pctVsLastWeek,
            linesWithDate: withEntryDate,
            trendShort,
            trendDir,
        };
    }, [newOrdersData, archivedOrderNums]);

    // Handle clicking outside line status dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if click is inside the trigger button container
            const isLineStatusDropdown = event.target.closest('.line-status-dropdown');
            // Check if click is inside the dropdown menu (which is portaled to document.body)
            const isLineStatusDropdownMenu = event.target.closest('.line-status-dropdown-menu');
            
            // Only close if click is outside both the trigger and the menu
            if (!isLineStatusDropdown && !isLineStatusDropdownMenu) {
                setLineStatusDropdownOpen({});
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Close Line Status portal dropdowns on any page/table scroll so the fixed-position
    // menu cannot detach from its trigger. Closing here (single idempotent state reset)
    // instead of per-row toggles avoids re-opening the menu. Scrolling inside the menu
    // list itself keeps it open.
    useEffect(() => {
        const hasOpenLineStatusDropdown = Object.values(lineStatusDropdownOpen).some(Boolean);
        if (!hasOpenLineStatusDropdown) return undefined;

        const handleScroll = (event) => {
            const target = event?.target;
            if (target instanceof Element && target.closest('.line-status-dropdown-menu')) {
                return;
            }
            setLineStatusDropdownOpen({});
        };

        window.addEventListener("scroll", handleScroll, true);
        return () => {
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, [lineStatusDropdownOpen]);

    const renderSectionSearchControls = () => (
        <div
            className="orders-section-header-controls orders-dashboard-search-group d-flex flex-wrap align-items-center gap-2"
            onClick={(e) => e.stopPropagation()}
            role="presentation"
        >
            <button
                type="button"
                className="btn btn-sm reset-column-order-btn"
                onClick={(e) => { e.stopPropagation(); resetColumnOrder(); }}
                title="Reset column order to default"
            >
                <i className="fa fa-undo" style={{ marginRight: '4px' }}></i>
                Reset Column Order
            </button>
            <button
                type="button"
                className="btn btn-sm reset-column-order-btn"
                onClick={(e) => { e.stopPropagation(); setShowColumnVisibilityModal(true); }}
                title="Show or hide columns"
            >
                <i className="fa fa-columns" style={{ marginRight: '4px' }}></i>
                Show/Hide Columns
            </button>
            {hiddenColumnCount > 0 && (
                <button
                    type="button"
                    className="btn btn-sm reset-column-order-btn"
                    onClick={(e) => { e.stopPropagation(); handleShowAllColumns(); }}
                    title="Show all hidden columns"
                >
                    <i className="fa fa-eye" style={{ marginRight: '4px' }}></i>
                    Show all columns ({hiddenColumnCount})
                </button>
            )}
            <button
                type="button"
                className={`btn reset-column-order-btn assemblies${assembliesFilter ? ' is-selected' : ''}`}
                aria-pressed={assembliesFilter}
                onClick={() => setAssembliesFilter(!assembliesFilter)}
            >
                Assemblies
            </button>
            <div className="d-flex align-items-center">
                <input
                    type="text"
                    className="form-control"
                    placeholder={messages.search_label}
                    value={tempSearchTerm}
                    onChange={(e) => setTempSearchTerm(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            searchOrder(tempSearchTerm);
                        }
                    }}
                    style={{ marginRight: '5px', minWidth: '140px' }}
                />
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => searchOrder(tempSearchTerm)}
                    style={{ whiteSpace: 'nowrap' }}
                >
                    Search
                </button>
            </div>
        </div>
    );

    const readyKpiLines = mergedKpiLines.filter((line) => isReadyToShipLine(line));
    const readyKpiOrderCount = new Set(readyKpiLines.map((l) => l?.order?.ordernum).filter(Boolean)).size;

    /** Lines shown in KPI total card — full loaded dataset */
    const kpiTotalLinesDisplay = mergedKpiLines.length;

    const kpiQuickFiltersEqual = (a, b) => {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (typeof a === 'string' && typeof b === 'string') return a === b;
        if (typeof a === 'object' && typeof b === 'object' && a && b)
            return a.kind === b.kind && String(a.label) === String(b.label);
        return false;
    };

    const filterValueForSlot = (slot) => {
        if (!slot || slot.preset === 'total') return null;
        if (slot.preset === 'due') return 'due';
        if (slot.preset === 'missing') return 'missing';
        if (slot.preset === 'ready') return 'ready';
        if (slot.preset === 'order') return { kind: 'order', label: slot.label };
        if (slot.preset === 'line') return { kind: 'line', label: slot.label };
        return null;
    };

    const kpiStatToneClass = ['orders-stat-card--blue', 'orders-stat-card--amber', 'orders-stat-card--rose', 'orders-stat-card--green'];

    const getKpiSlotDisplay = (slot) => {
        if (slot.preset === 'total') {
            return {
                variant: 'total',
                title: 'Total orders',
                value: uniqueKpiOrders,
                meta: null,
                iconClass: 'fa fa-clipboard',
            };
        }
        if (slot.preset === 'due') {
            return {
                variant: 'metric',
                title: 'Orders Due',
                value: dueKpiLines.length,
                meta: `Due today: ${dueTodayKpiOrderCount} · Past Orders Due: ${pastDueKpiOrderCount}`,
                iconClass: 'fa fa-calendar',
            };
        }
        if (slot.preset === 'missing') {
            return {
                variant: 'metric',
                title: 'Missing parts',
                value: missingKpiOrderCount,
                meta: `Total orders: ${missingKpiOrderCount} · Total no. of BOM: ${missingKpiTotalBomCount}`,
                iconClass: 'fa fa-exclamation-triangle',
            };
        }
        if (slot.preset === 'ready') {
            return {
                variant: 'metric',
                title: 'In shipping',
                value: readyKpiLines.length,
                meta: `${readyKpiOrderCount} orders · in shipping pipeline · click to filter lists`,
                iconClass: 'fa fa-check-circle',
            };
        }
        if (slot.preset === 'order') {
            const lines = mergedKpiLines.filter((l) => lineHasOrderStatusLabel(l, slot.label));
            const orderCnt = new Set(lines.map((l) => l?.order?.ordernum).filter(Boolean)).size;
            return {
                variant: 'metric',
                title: slot.label,
                value: lines.length,
                meta: `${orderCnt} orders · order status tag · click to filter lists`,
                iconClass: 'fa fa-tag',
            };
        }
        if (slot.preset === 'line') {
            const lines = mergedKpiLines.filter((l) => lineHasLineStatusLabel(l, slot.label));
            const orderCnt = new Set(lines.map((l) => l?.order?.ordernum).filter(Boolean)).size;
            return {
                variant: 'metric',
                title: slot.label,
                value: lines.length,
                meta: `${orderCnt} orders · line status tag · click to filter lists`,
                iconClass: 'fa fa-list',
            };
        }
        return {
            variant: 'metric',
            title: '—',
            value: 0,
            meta: '',
            iconClass: 'fa fa-circle-o',
        };
    };

    const getLineRowProps = (line) => {
        const source = line?._headerLine || line;
        const displayShipDate = getEarliestPromisedDateForOrder(source);
        const rowStyle = getRowStyle(displayShipDate);
        const existingStyle = rowStyle.style || {};
        const isPoReview = shouldRowBePoReview(source);
        const isOrange = shouldRowBeOrange(source);
        const isPurple = shouldRowBePurple(source);
        const rowBackground = isPoReview ? '#232323' : isOrange ? '#FF9D47' : isPurple ? '#BEA9FF' : (shouldRowBeGreen(source) ? '#d4edda' : (existingStyle.backgroundColor || 'transparent'));
        const lightDateRow = !isPoReview && !isOrange && !isPurple && ['#f8d7da', '#fff3cd', '#d1ecf1', '#d4edda'].includes(String(rowBackground).toLowerCase());
        return {
            className: [isPoReview ? 'po-review-row' : '', !isPoReview && isOrange ? 'hot-order-row' : '', !isPoReview && !isOrange && isPurple ? 'cc-hold-ppa-row' : '', lightDateRow ? 'bridge-light-row' : ''].filter(Boolean).join(' ') || undefined,
            style: {
                ...existingStyle,
                backgroundColor: rowBackground,
                color: isPoReview ? '#ffffff' : (lightDateRow ? '#212529' : undefined),
            },
            isOrange,
            isPoReview,
        };
    };

    const renderOrderLineTable = () => (
        <OrderLineView
            lines={lineRows}
            detailsPending={lineDetailsPending}
            getRowProps={getLineRowProps}
            renderComments={renderLineComments}
            onHistory={handleHistoryIconClick}
            getHistoryUnread={getUnreadCount}
            getOrderLabel={getCetecOrderNumber}
            getFolderLink={resolveOrderFolderLinkForLine}
            renderShippingMethod={renderShippingMethodCell}
            renderStickyNotes={renderStickyNotes}
            onOrderAccess={handleOrderAccessClick}
            onDeleteOrderAccess={handleDeleteOrderAccessLink}
            onSelectOrderStatus={handleSelectTagsClick}
            orderStatusSelections={orderStatusSelections}
            submittedOrderStatuses={submittedOrderStatuses}
            tagsToDeselect={tagsToDeselect}
            hasOrderStatusChanges={hasChangesToSubmit}
            onDeselectOrderTag={handleTagDeselect}
            onSubmitOrderStatus={handleOrderStatusSubmit}
            renderOrderStatusPresence={renderOrderStatusPresence}
            lineStatusSelections={lineStatusSelections}
            submittedLineStatuses={submittedLineStatuses}
            lineTagsToDeselect={lineTagsToDeselect}
            lineStatusDropdownOpen={lineStatusDropdownOpen}
            onToggleLineStatusDropdown={toggleLineStatusDropdown}
            onToggleLineStatus={handleLineStatusToggle}
            onDeselectLineTag={handleLineTagDeselect}
            hasLineStatusChanges={hasLineChangesToSubmit}
            onSubmitLineStatus={handleLineStatusSubmit}
            lineStatusLockOwner={lineStatusLockOwner}
            renderLinePresence={renderLinePresence}
            lineStatusTags={LINE_STATUS_TAGS}
            excludedPartsByOrder={excludedAvailabilityPartsByOrder}
            onArchiveBomPart={handleArchiveBomPart}
            onToggleExcludedAvailabilityPart={handleToggleExcludedAvailabilityPart}
        />
    );

    return (
        <div className="order-validation-outer">
            <div ref={titleWrapRef} className="order-validation-page-title-wrap px-3 pt-3 pb-1">
                <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                    <h1 className="orders-dashboard-page-title table-section-text table-section-text-left mb-0">{path === '652' ? 'Internal ' : ''}Orders</h1>
                    <HeaderLineTabs value={layoutView} onChange={setLayoutView} />
                </div>
            </div>
        <div ref={pageShellRef} className="box-body border b-white rounded-2 orders-dashboard-shell orders-page" style={{ width: '100%', maxWidth: '100%' }}>
            <div ref={stickyStackRef} className="orders-sticky-stack">
            <div className="orders-dashboard-header px-3 pt-2 pb-2">
                <div className="orders-dashboard-header-inner">
                    <PresenceBar
                        here={presence.here}
                        cells={presence.cells}
                        connected={presence.connected}
                        me={presence.me}
                    />
                    <div className="orders-dashboard-actions" style={{ marginLeft: 'auto' }}>
                        <div className="orders-dashboard-refresh-pill" role="status">
                            <span>
                                Auto-refresh in <strong>{timerFormatted}</strong>
                            </span>
                            <span className="orders-dashboard-refresh-meta">Next refresh in 10 minutes</span>
                        </div>
                        <button type="button" className="btn btn-outline-primary d-flex align-items-center gap-2 px-3" onClick={() => { setFilterTab(filterTabOpen === true ? false : true); }}>
                            <img src={filterIcon} style={{ width: '16px', height: '16px' }} alt="" />
                            Filter
                        </button>
                        <button type="button" className="btn btn-outline-primary d-flex align-items-center gap-2 px-3" onClick={handleExportToExcel}>
                            <img src={excelIcon} style={{ width: '16px', height: '16px' }} alt="" />
                            Export
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-primary d-flex align-items-center gap-2 px-3"
                            onClick={() => setShowColumnGroupsModal(true)}
                            title="Combine columns into groups"
                        >
                            <i className="fa fa-object-group" aria-hidden="true"></i>
                            Column Groups
                        </button>
                        <ViewModeToggle
                            inlineDropdownMode={inlineDropdownMode}
                            onSelectView={handleSelectView}
                            defaultViewMode={defaultViewMode}
                            onSetDefault={handleSetViewModeDefault}
                        />
                    </div>
                </div>
            </div>

           <div ref={kpiStatsRef} className="orders-dashboard-stats px-3 pb-3">
                {kpiQuickFilter ? (
                    <div className="orders-stat-filter-banner mb-2 d-flex align-items-center flex-wrap gap-2" role="status">
                        <span className="text-muted small">
                            <strong className="text-body">
                                {kpiQuickFilter === 'due' && 'Active due orders'}
                                {kpiQuickFilter === 'missing' && 'Active missing parts'}
                                {kpiQuickFilter === 'ready' && 'Active in shipping'}
                                {typeof kpiQuickFilter === 'object' && kpiQuickFilter?.kind === 'order' && (
                                    <>Active order status: {kpiQuickFilter.label}</>
                                )}
                                {typeof kpiQuickFilter === 'object' && kpiQuickFilter?.kind === 'line' && (
                                    <>Active line status: {kpiQuickFilter.label}</>
                                )}
                            </strong>
                            <span className="ms-1">— All Orders</span>
                        </span>
                        <button type="button" className="btn btn-sm btn-outline-primary py-0 px-2" onClick={() => setKpiQuickFilter(null)}>
                            Clear
                        </button>
                    </div>
                ) : null}
                <div className="row g-3 align-items-stretch">
                    {[0, 1, 2, 3].map((slotIndex) => {
                        const slot = kpiSlotConfig[slotIndex];
                        const disp = getKpiSlotDisplay(slot);
                        const fv = filterValueForSlot(slot);
                        const isActive = fv != null && kpiQuickFiltersEqual(kpiQuickFilter, fv);
                        const tone = kpiStatToneClass[slotIndex];
                        const toggleListFilter = () => {
                            if (fv == null) return;
                            setKpiQuickFilter((prev) => (kpiQuickFiltersEqual(prev, fv) ? null : fv));
                        };
                        const picker =
                            kpiTagPickerSlot === slotIndex ? (
                                <div
                                    className="orders-kpi-tag-picker shadow border rounded bg-white p-2"
                                    role="group"
                                    aria-label="Choose KPI metric"
                                >
                                    <div className="orders-kpi-picker-header d-flex justify-content-between align-items-center gap-2 mb-2">
                                        <div className="small fw-bold text-muted text-uppercase mb-0">Customize Card</div>
                                        <button
                                            type="button"
                                            className="orders-kpi-picker-restore btn btn-link btn-sm p-0"
                                            onClick={() => {
                                                setKpiSlotConfig((prev) => {
                                                    const next = [...prev];
                                                    next[slotIndex] = { ...DEFAULT_KPI_SLOTS[slotIndex] };
                                                    return next;
                                                });
                                                setKpiTagPickerSlot(null);
                                            }}
                                        >
                                            Restore default
                                        </button>
                                    </div>

                                    <label className="orders-kpi-picker-label small text-muted mb-1" htmlFor={`kpi-order-select-${slotIndex}`}>
                                        Order status tag
                                    </label>
                                    <select
                                        id={`kpi-order-select-${slotIndex}`}
                                        className="form-select form-select-sm orders-kpi-picker-select mb-2"
                                        defaultValue=""
                                        onChange={(e) => {
                                            const label = e.target.value;
                                            if (!label) return;
                                            setKpiSlotConfig((prev) => {
                                                const next = [...prev];
                                                next[slotIndex] = { preset: 'order', label };
                                                return next;
                                            });
                                            setKpiTagPickerSlot(null);
                                        }}
                                    >
                                        <option value="">Select order status...</option>
                                        {ORDER_STATUS_TAGS.map((tag) => (
                                            <option key={`kpi-order-opt-${slotIndex}-${tag.label}`} value={tag.label}>
                                                {tag.label}
                                            </option>
                                        ))}
                                    </select>

                                    <label className="orders-kpi-picker-label small text-muted mb-1" htmlFor={`kpi-line-select-${slotIndex}`}>
                                        Line status tag
                                    </label>
                                    <select
                                        id={`kpi-line-select-${slotIndex}`}
                                        className="form-select form-select-sm orders-kpi-picker-select"
                                        defaultValue=""
                                        onChange={(e) => {
                                            const label = e.target.value;
                                            if (!label) return;
                                            setKpiSlotConfig((prev) => {
                                                const next = [...prev];
                                                next[slotIndex] = { preset: 'line', label };
                                                return next;
                                            });
                                            setKpiTagPickerSlot(null);
                                        }}
                                    >
                                        <option value="">Select line status...</option>
                                        {LINE_STATUS_TAGS.map((tag) => (
                                            <option key={`kpi-line-opt-${slotIndex}-${tag.label}`} value={tag.label}>
                                                {tag.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            ) : null;
                        return (
                            <div key={slotIndex} className="col-12 col-sm-6 col-xl-3">
                                <div className="position-relative h-100 orders-kpi-slot-wrap">
                                    {disp.variant === 'total' ? (
                                        <>
                                            <div className="orders-total-flip-scene w-100 h-100">
                                                <div className={`orders-total-flip-inner ${totalOrdersStatExpanded ? 'is-flipped' : ''}`}>
                                                    <button
                                                        type="button"
                                                        id="orders-total-stat-trigger"
                                                        aria-expanded={totalOrdersStatExpanded}
                                                        aria-controls="orders-total-stat-details"
                                                        className="orders-stat-card orders-stat-card--blue orders-stat-card--clickable orders-total-flip-face orders-total-flip-face--front text-start border-0"
                                                        onClick={() => setTotalOrdersStatExpanded(true)}
                                                        aria-label="Total orders summary, flip to details"
                                                    >
                                                        <div className="orders-stat-card-icon">
                                                            <i className="fa fa-clipboard" aria-hidden="true"></i>
                                                        </div>
                                                        <div className="orders-stat-card-body flex-grow-1 min-w-0">
                                                            <div className="orders-stat-card-label mb-0">Total orders</div>
                                                            <div className="orders-stat-card-value">{uniqueKpiOrders}</div>
                                                            <div className={`orders-stat-card-trend orders-stat-card-trend--${newOrdersWeekStats.trendDir}`}>
                                                                {newOrdersWeekStats.trendShort ? (
                                                                    <>
                                                                        {newOrdersWeekStats.trendDir === 'up' && (
                                                                            <i className="fa fa-arrow-up me-1" aria-hidden="true"></i>
                                                                        )}
                                                                        {newOrdersWeekStats.trendDir === 'down' && (
                                                                            <i className="fa fa-arrow-down me-1" aria-hidden="true"></i>
                                                                        )}
                                                                        <span>{newOrdersWeekStats.trendShort}</span>
                                                                    </>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        id="orders-total-stat-details"
                                                        aria-labelledby="orders-total-stat-trigger"
                                                        className="orders-stat-card orders-stat-card--blue orders-stat-card--clickable orders-total-flip-face orders-total-flip-face--back text-start border-0"
                                                        onClick={() => setTotalOrdersStatExpanded(false)}
                                                        aria-label="Flip back to summary"
                                                    >
                                                        <div className="orders-stat-card-icon orders-total-flip-back-icon">
                                                            <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                                        </div>
                                                        <div className="orders-stat-card-body flex-grow-1 min-w-0">
                                                            <div className="orders-stat-card-label mb-0 mb-2">Details</div>
                                                            <div className="orders-stat-card-meta orders-stat-card-meta--emphasis mb-2 orders-total-flip-detail-text">
                                                                <span>
                                                                    New orders this week: <strong>{newOrdersWeekStats.thisWeekCount}</strong>
                                                                </span>
                                                                <span className="mx-1">·</span>
                                                                <span>
                                                                    Last week: <strong>{newOrdersWeekStats.lastWeekCount}</strong>
                                                                </span>
                                                            </div>
                                                            <div className="orders-stat-card-meta small text-muted mb-2 orders-total-flip-detail-text">
                                                                {newOrdersWeekStats.changeText}
                                                            </div>
                                                            <div className="orders-stat-card-meta small mb-0 orders-total-flip-detail-text">
                                                                <span className="text-body">{kpiTotalLinesDisplay}</span> lines loaded ·{' '}
                                                                <span className="text-body">{uniqueKpiOrders}</span> orders
                                                            </div>
                                                            <div className="orders-total-flip-footnote small text-muted mt-2 mb-0">Tap to flip back</div>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                className="orders-kpi-filter-trigger"
                                                title="Choose tag for this card"
                                                aria-label="Choose tag for this card"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setKpiTagPickerSlot((prev) => (prev === slotIndex ? null : slotIndex));
                                                }}
                                            >
                                                <i className="fa fa-filter" aria-hidden="true"></i>
                                            </button>
                                            {picker}
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                type="button"
                                                className={`orders-stat-card ${tone} orders-stat-card--clickable text-start w-100 border-0 ${isActive ? 'orders-stat-card--active' : ''}`}
                                                onClick={toggleListFilter}
                                                aria-pressed={!!isActive}
                                            >
                                                <div className="orders-stat-card-icon">
                                                    <i className={disp.iconClass} aria-hidden="true"></i>
                                                </div>
                                                <div className="orders-stat-card-body">
                                                    <div className="orders-stat-card-label">{disp.title}</div>
                                                    <div className="orders-stat-card-value">{disp.value}</div>
                                                    {disp.meta ? (
                                                        <div className="orders-stat-card-meta orders-stat-card-meta--emphasis">{disp.meta}</div>
                                                    ) : null}
                                                </div>
                                            </button>
                                            <button
                                                type="button"
                                                className="orders-kpi-filter-trigger"
                                                title="Choose tag for this card"
                                                aria-label="Choose tag for this card"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setKpiTagPickerSlot((prev) => (prev === slotIndex ? null : slotIndex));
                                                }}
                                            >
                                                <i className="fa fa-filter" aria-hidden="true"></i>
                                            </button>
                                            {picker}
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            {filterTabOpen ?
                <div className="row p-2 m-0" style={{ background: '#d3d3d333', width: '100%' }}>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2 filter-label'>Order</div>
                        <input type="text" class="form-control filter-input-wrapper" value={orderValue} onInput={(e) => setUseEffectOrder(e.target.value)} />
                        {orderSearch.length > 0 && (
                            <ul className="filter-autocomplete-list filter-autocomplete-list top-155">
                                {orderSearch.map((item, index) => (
                                    <li
                                        key={index}
                                        className="filter-autocomplete-item"
                                        onClick={() => {
                                            setOrderValue(item.order.ordernum);
                                            setOrderSearch([]);
                                        }}
                                    >
                                        {item.order.ordernum}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2 filter-label'>PO NO.</div>
                        <input type="text" class="form-control filter-input-wrapper" value={POValue} onInput={(e) => setUseEffectPO(e.target.value)} />
                        {POSearch.length > 0 && (
                            <ul className="filter-autocomplete-list filter-autocomplete-list top-155">
                                {POSearch
                                    .filter((item, index, arr) => index === 0 || item.order.custponum !== arr[index - 1].order.custponum)
                                    .map((item, index) => (
                                        <li
                                            key={index}
                                            className="filter-autocomplete-item"
                                            onClick={() => {
                                                setPOValue(item.order.custponum);
                                                setPOSearch([]);
                                            }}
                                        >
                                            {item.order.custponum}
                                        </li>
                                    ))
                                }

                            </ul>
                        )}

                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2 filter-label'>WO#</div>
                        <input type="text" class="form-control filter-input-wrapper" value={WOValue} onInput={(e) => setUseEffectWO(e.target.value)} />
                        {WOSearch.length > 0 && (
                            <ul className="filter-autocomplete-list filter-autocomplete-list top-200">
                                {WOSearch.map((item, index) => (
                                    <li
                                        key={index}
                                        className="filter-autocomplete-item"
                                        onClick={() => {
                                            setWOValue(item.order?.woNum || '');
                                            setWOSearch([]);
                                        }}
                                    >
                                        {item.order?.woNum || 'N/A'}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div class="col-lg-3 col-md-3 col-xs-3 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2 filter-label'>Ship Method</div>
                        <input type="text" class="form-control filter-input-wrapper" value={ShippingMethodValue} onInput={(e) => setUseEffectShippingMethod(e.target.value)} />
                        {ShippingMethodSearch.length > 0 && (
                            <ul className="filter-autocomplete-list filter-autocomplete-list top-155">
                                {ShippingMethodSearch.map((item, index) => (
                                    <li
                                        key={index}
                                        className="filter-autocomplete-item"
                                        onClick={() => {
                                            setShippingMethodValue(item.MethodOfShipment);
                                            setShippingMethodSearch([]);
                                        }}
                                    >
                                        {item.MethodOfShipment}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div class="col-lg-3 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2 filter-label'>Date</div>
                        <div className='d-flex justify-content-start align-items-center gap-2 filter-date-wrapper'>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <DatePicker
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control d-inline w-100"
                                    id="startDate"
                                    selected={startDate ? new Date(startDate) : null}
                                    placeholderText='YYYY-MM-DD'
                                    onChange={(e) => {
                                        if (!e) { setStartDate(''); return; }
                                        const y = e.getFullYear();
                                        const m = String(e.getMonth() + 1).padStart(2, '0');
                                        const d = String(e.getDate()).padStart(2, '0');
                                        setStartDate(`${y}-${m}-${d}`);
                                    }}
                                    isClearable
                                    shouldCloseOnSelect
                                    popperProps={{ strategy: 'fixed' }}
                                    autoComplete='off'
                                />
                            </div>
                            <span> - </span>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <DatePicker
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control d-inline w-100"
                                    id="endDate"
                                    selected={endDate ? new Date(endDate) : null}
                                    placeholderText='YYYY-MM-DD'
                                    onChange={(e) => {
                                        if (!e) { setEndDate(''); return; }
                                        const y = e.getFullYear();
                                        const m = String(e.getMonth() + 1).padStart(2, '0');
                                        const d = String(e.getDate()).padStart(2, '0');
                                        setEndDate(`${y}-${m}-${d}`);
                                    }}
                                    isClearable
                                    shouldCloseOnSelect
                                    popperProps={{ strategy: 'fixed' }}
                                    autoComplete='off'
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center order-status-filter-dropdown filter-submit-wrapper">
                        <div className='px-2 filter-label'>Order Status</div>
                        <div className="filter-tag-selector-wrapper">
                            <div
                                className="form-control d-flex align-items-center justify-content-between filter-tag-selector"
                                onClick={() => setOrderStatusFilterDropdownOpen(!orderStatusFilterDropdownOpen)}
                            >
                                <div className="d-flex flex-wrap gap-1" style={{ flex: 1 }}>
                                    {selectedOrderStatusTags.length > 0 ? (
                                        selectedOrderStatusTags.map((tag, index) => (
                                            <span
                                                key={index}
                                                className="badge filter-tag-badge"
                                                style={{ backgroundColor: tag.color }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleOrderStatusTagToggle(tag);
                                                }}
                                            >
                                                {tag.icon && <i className={tag.icon} aria-hidden="true"></i>}
                                                {tag.label}
                                                <span className="filter-tag-close">×</span>
                                            </span>
                                        ))
                                    ) : (
                                        <span className="text-muted filter-tag-placeholder">Select tags...</span>
                                    )}
                                </div>
                                <i className={`fa fa-chevron-${orderStatusFilterDropdownOpen ? 'up' : 'down'} filter-tag-chevron`}></i>
                            </div>
                            {orderStatusFilterDropdownOpen && (
                                <div className="position-absolute w-100 filter-tag-dropdown">
                                    {ORDER_STATUS_TAGS.map((tag, index) => {
                                        const isSelected = selectedOrderStatusTags.some(t => t.label === tag.label);
                                        return (
                                            <div
                                                key={index}
                                                className={`p-2 d-flex align-items-center filter-tag-dropdown-item ${isSelected ? 'selected' : ''}`}
                                                onClick={() => handleOrderStatusTagToggle(tag)}
                                            >
                                                {tag.icon ? (
                                                    <i className={`${tag.icon} me-2`} aria-hidden="true" style={{ color: tag.color, fontSize: '14px' }}></i>
                                                ) : (
                                                    <div
                                                        className="me-2 filter-tag-color-indicator"
                                                        style={{ backgroundColor: tag.color }}
                                                    ></div>
                                                )}
                                                <span className="filter-tag-label">
                                                    {tag.label}
                                                </span>
                                                {isSelected && (
                                                    <span className="ms-auto filter-tag-checkmark">✓</span>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2 filter-label'>Cust Name</div>
                        <input type="text" class="form-control filter-input-wrapper" value={CustomerValue} onInput={(e) => { setUseEffectCustomer(e.target.value); setCustomerId(''); }} disabled={path === '652'} />
                        {CustomerSearch.length > 0 && (
                            <ul className="filter-autocomplete-list filter-autocomplete-list top-200">
                                {CustomerSearch.map((item, index) => (
                                    <li
                                        key={index}
                                        className="filter-autocomplete-item"
                                        onClick={() => {
                                            setCustomerValue(item.name);
                                            setCustomerId(item.id);
                                            setCustomerSearch([]);
                                        }}
                                    >
                                        {item.name}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2 filter-label'>Country</div>
                        <input type="text" class="form-control filter-input-wrapper" value={CountryValue} onInput={(e) => setUseEffectCountry(e.target.value)} />
                        {CountrySearch.length > 0 && (
                            <ul className="filter-autocomplete-list filter-autocomplete-list top-200">
                                {CountrySearch.map((item, index) => (
                                    <li
                                        key={index}
                                        className="filter-autocomplete-item"
                                        onClick={() => {
                                            setCountryValue(item.Country_Name);
                                            setCountrySearch([]);
                                        }}
                                    >
                                        {item.Country_Name}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div class="col-lg-3 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center line-status-filter-dropdown filter-submit-wrapper">
                        <div className='px-2 filter-label'>Line Status</div>
                        <div className="filter-tag-selector-wrapper">
                            <div
                                className="form-control d-flex align-items-center justify-content-between filter-tag-selector"
                                onClick={() => setLineStatusFilterDropdownOpen(!lineStatusFilterDropdownOpen)}
                            >
                                <div className="d-flex flex-wrap gap-1" style={{ flex: 1 }}>
                                    {selectedLineStatusTags.length > 0 ? (
                                        selectedLineStatusTags.map((tag, index) => (
                                            <span
                                                key={index}
                                                className="badge filter-tag-badge"
                                                style={{ backgroundColor: tag.color }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleLineStatusTagToggle(tag);
                                                }}
                                            >
                                                {tag.icon && <i className={tag.icon} aria-hidden="true"></i>}
                                                {tag.label}
                                                <span className="filter-tag-close">×</span>
                                            </span>
                                        ))
                                    ) : (
                                        <span className="text-muted filter-tag-placeholder">Select tags...</span>
                                    )}
                                </div>
                                <i className={`fa fa-chevron-${lineStatusFilterDropdownOpen ? 'up' : 'down'} filter-tag-chevron`}></i>
                            </div>
                            {lineStatusFilterDropdownOpen && (
                                <div className="position-absolute w-100 filter-tag-dropdown">
                                    {LINE_STATUS_TAGS.map((tag, index) => {
                                        const isSelected = selectedLineStatusTags.some(t => t.label === tag.label);
                                        return (
                                            <div
                                                key={index}
                                                className={`p-2 d-flex align-items-center filter-tag-dropdown-item ${isSelected ? 'selected' : ''}`}
                                                onClick={() => handleLineStatusTagToggle(tag)}
                                            >
                                                {tag.icon ? (
                                                    <i className={`${tag.icon} me-2`} aria-hidden="true" style={{ color: tag.color, fontSize: '14px' }}></i>
                                                ) : (
                                                    <div
                                                        className="me-2 filter-tag-color-indicator"
                                                        style={{ backgroundColor: tag.color }}
                                                    ></div>
                                                )}
                                                <span className="filter-tag-label">
                                                    {tag.label}
                                                </span>
                                                {isSelected && (
                                                    <span className="ms-auto filter-tag-checkmark">✓</span>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-xs-6 pb-2 d-flex justify-content-start align-items-center">
                        <input type="button" class="btn btn-primary" value='Submit' onClick={() => fetchOrdersSearch((currentPage - 1) * itemsPerPage, itemsPerPage, searchTerm)} />
                    </div>

                </div> : ''}
            <div className="orders-toolbar-date-row orders-dashboard-controls-row px-3 pt-3 pb-3 mb-0" style={{ width: '100%', boxSizing: 'border-box' }}>
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div className="d-flex flex-wrap align-items-center orders-dashboard-controls-left" style={{ gap: '10px' }}>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => setShowAllOrdersHistory(true)}
                            title="View audit history across all orders"
                        >
                            <i className="fa fa-history me-1" aria-hidden="true"></i>
                            All Orders History
                        </button>
                        <label className="d-flex align-items-center gap-2 mb-0 small text-muted">
                            <span>Rows</span>
                            <select
                                className="px-2 py-1 border rounded-1 form-select form-select-sm orders-dashboard-page-size"
                                style={{ width: 'auto', minWidth: '72px' }}
                                value={itemsPerPage}
                                onChange={(e) => {
                                    setItemsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="-1">All</option>
                            </select>
                        </label>
                        <div className="orders-dashboard-date-pills d-flex flex-wrap align-items-center">
                            <button
                                type="button"
                                className={`btn orders-date-pill ${weekFilter ? 'orders-date-pill--active orders-date-pill--warning' : 'btn-outline-warning'}`}
                                onClick={() => {
                                    setWeekFilter(!weekFilter);
                                    if (!weekFilter) {
                                        setMonthFilter(false);
                                    }
                                }}
                            >
                                ⏰ Week
                            </button>
                            <button
                                type="button"
                                className={`btn orders-date-pill ${monthFilter ? 'orders-date-pill--active orders-date-pill--success' : 'btn-outline-success'}`}
                                onClick={() => {
                                    setMonthFilter(!monthFilter);
                                    if (!monthFilter) {
                                        setWeekFilter(false);
                                    }
                                }}
                            >
                                📆 Month
                            </button>
                        </div>
                    </div>
                    <div className="orders-dashboard-controls-right d-flex align-items-center gap-2 flex-shrink-0 flex-wrap justify-content-end">
                        {renderSectionSearchControls()}
                    </div>
                </div>
            </div>
            </div>
            <div ref={tableContainerRef} className="orders-tables-region">
            {layoutView === LAYOUT_LINE ? (
            <div className="row px-2 mb-4" style={{ width: '100%' }}>
                <div className="col-12">
                    <div className="table-section-title table-section-title-left">
                        <span className="table-section-text table-section-text-left">Lines</span>
                        <span className="table-section-count" aria-label={`Line count ${lineRows.length}`}>{lineRows.length}</span>
                    </div>
                    <div className="orders-table-scroll">
                        {loading ? (
                            <div className="text-center vh-50 d-flex justify-content-center align-items-center">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : renderOrderLineTable()}
                    </div>
                    {dropdownOpenId && (
                        <OrderStatusDropdown
                            visible={true}
                            position={dropdownPosition}
                            orderStatuses={ORDER_STATUS_TAGS}
                            savedCustomTags={collectCustomOrderStatusTags(
                                [submittedOrderStatuses, orderStatusSelections],
                                ORDER_STATUS_TAGS
                            )}
                            allowCustomTag
                            selectedTags={orderStatusSelections[dropdownOpenId] || []}
                            onToggleTag={(tag) => handleOrderStatusToggle(dropdownOpenId, tag)}
                            onClose={() => setDropdownOpenId(null)}
                            menuClassName="order-status-menu"
                        />
                    )}
                </div>
            </div>
            ) : (
            <>
            {filteredNewOrdersData?.length > 0 && (
            <div className="row px-2 mb-4" style={{ width: '100%' }}>
                <div className="col-12">
            <>
                <div
                    className="table-section-title table-section-title-left"
                    onClick={() => setNewOrdersSectionExpanded((prev) => !prev)}
                    style={{ cursor: 'pointer' }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setNewOrdersSectionExpanded((prev) => !prev); } }}
                    aria-expanded={newOrdersSectionExpanded}
                >
                    <span className="table-section-text table-section-text-left">
                        New Orders
                    </span>
                    <span className="table-section-count" aria-label={`New Orders count ${filteredNewOrdersData.length}`}>
                        {filteredNewOrdersData.length}
                    </span>
                </div>
                {newOrdersSectionExpanded && filteredNewOrdersData?.length > 0 ? (
                    <>
                        <div
                            className="container-fluid p-0"
                            style={{
                                width: '100%',
                                margin: 0,
                            }}
                        >
                            <div
                                className="orders-table-scroll"
                                style={{
                                    width: '100%',
                                    margin: 0,
                                }}
                            >
                                    <table
                                        className="table gf-table table-bordered table-hover mb-0 new-orders-table"
                                        style={{ minWidth: '1000px' }}
                                    >
                                        <thead>
                                            <tr>
                                                <ReorderableCells order={effectiveColumnOrder} mergedCells={mergedHeaderCells} draggable dragHandlers={orderColumnDragHandlers} draggedColumnId={draggedColumnId} columnVisibility={columnVisibility} onToggleColumn={toggleColumnVisibility} isHeader>
<th className="text-center" style={{ minWidth: '130px', maxWidth: '150px' }}>Info</th>
<th className="text-center" style={{ minWidth: '190px', maxWidth: '190px', cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleColumnSort('ordernum')}>
                                                    {messages.order_no_label} {getColumnSortIcon('ordernum')}
                                                </th>
<th className="text-center" style={{ minWidth: '172px', maxWidth: '172px', cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleColumnSort('orderedondate')}>
                                                    Ordered On Date {getColumnSortIcon('orderedondate')}
                                                </th>
<th className="text-center" style={{ minWidth: '120px', maxWidth: '120px' }}>WO#</th>
<th className="text-center" style={{ minWidth: '200px', maxWidth: '200px', cursor: 'pointer' }} onClick={() => handleColumnSort('name')}>
                                                    {messages.customer_name_label} {getColumnSortIcon('name')}
                                                </th>
<th className="text-center" style={{ minWidth: '120px', maxWidth: '120px', cursor: 'pointer' }} onClick={() => handleColumnSort('custponum')}>
                                                    {messages.po_no_label} {getColumnSortIcon('custponum')}
                                                </th>
<th className="text-center" style={{ minWidth: '150px', maxWidth: '150px', cursor: 'pointer' }} onClick={handleShippingDateSort}>
                                                    {messages.shipping_date_label} {getShippingDateSortIcon()}
                                                </th>
<th className="text-center" style={{ minWidth: '100px', maxWidth: '100px' }}>{messages.line_item}</th>
<th className="text-center" style={{ minWidth: '150px', maxWidth: '150px' }}>Order Status</th>
<th className="text-center bom-availability-cell">BOM</th>
<th className="text-center" style={{ minWidth: '200px', maxWidth: '250px' }}>Line Status Report</th>
<th className="text-center" style={{ minWidth: '168px', maxWidth: '168px' }}>{messages.shipping_method_label}</th>
<th className="text-center" style={{ minWidth: '120px', maxWidth: '120px', cursor: 'pointer' }} onClick={() => handleColumnSort('country_name')}>
                                                    {messages.country_label} {getColumnSortIcon('country_name')}
                                                </th>
                                                {/* <th className="text-center" style={{ minWidth: '100px', maxWidth: '100px' }} onClick={() => handleSort('orig_shipdate')}>{messages.shipping_date_label} {getSortIcon('orig_shipdate')}</th> */}
<th className="text-center" style={{ minWidth: '280px', maxWidth: '320px' }}>Sticky Notes</th>
<th className="text-center order-access-column" style={{ width: '152px', minWidth: '152px', maxWidth: '152px' }}>Order Access</th>
<th className="text-center" style={{ minWidth: '96px', maxWidth: '96px' }}>Archive</th>
                                                {/* <th className="text-center" style={{ minWidth: '80px', maxWidth: '80px' }}>{messages.action_label}</th> */}
                                                </ReorderableCells>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredNewOrdersData.map((line, lineIndex) => {
                                                const displayShipDate = getEarliestPromisedDateForOrder(line);
                                                const rowStyle = getRowStyle(displayShipDate);
                                                const existingStyle = rowStyle.style || {};
                                                const isPoReview = shouldRowBePoReview(line);
                                                const isOrange = shouldRowBeOrange(line);
                                                const isPurple = shouldRowBePurple(line);
                                                const rowBackground = isPoReview ? '#232323' : isOrange ? '#FF9D47' : isPurple ? '#BEA9FF' : (shouldRowBeGreen(line) ? '#d4edda' : (existingStyle.backgroundColor || 'transparent'));
                                                const lightDateRow = !isPoReview && !isOrange && !isPurple && ['#f8d7da', '#fff3cd', '#d1ecf1', '#d4edda'].includes(String(rowBackground).toLowerCase());
                                                const priorityLineStatusHighlight = getPriorityLineStatusHighlight(line);
                                                const lineStatusReportHighlight = priorityLineStatusHighlight
                                                    || (isPoReview
                                                        ? { backgroundColor: 'transparent', textColor: '#ffffff', secondaryTextColor: 'rgba(255, 255, 255, 0.85)' }
                                                        : (isOrange || isPurple)
                                                            ? { backgroundColor: 'transparent', textColor: 'inherit', secondaryTextColor: '#212529' }
                                                            : getLineStatusReportHighlight(line));
                                                const isLineItemMismatch = line.negativeCountStr && line.negativeCountStr.includes('/') &&
                                                    parseInt(line.negativeCountStr.split('/')[0]) !== parseInt(line.negativeCountStr.split('/')[1]);
                                                return (
                                                <React.Fragment key={`new-order-${lineIndex}`}>
                                                    <tr
                                                        className={[isPoReview ? 'po-review-row' : '', !isPoReview && isOrange ? 'hot-order-row' : '', !isPoReview && !isOrange && isPurple ? 'cc-hold-ppa-row' : '', lightDateRow ? 'bridge-light-row' : ''].filter(Boolean).join(' ') || undefined}
                                                        style={{
                                                        ...existingStyle,
                                                        backgroundColor: rowBackground,
                                                        color: isPoReview ? '#ffffff' : (lightDateRow ? '#212529' : undefined)
                                                    }}>
                                                        <ReorderableCells order={effectiveColumnOrder} mergedCells={getMergedBodyCells(line, displayShipDate, isOrange, isPoReview)} columnVisibility={columnVisibility}>
<td className="text-center orders-info-cell" >
                                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                                <button onClick={() => { handleEyeIconClick(line) }} title='View order details' style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                                                                    <img src={viewIcon} alt="view order" style={{ width: '20px' }} />
                                                                </button>
                                                                <OrderHistoryIconButton
                                                                    unreadCount={getUnreadCount(line?.order?.ordernum || line?.ordernum)}
                                                                    onClick={() => { handleHistoryIconClick(line) }}
                                                                />
                                                                {renderInfoComments(line)}
                                                                {renderRowPresence(line.order?.ordernum || line.ordernum)}
                                                                {/* <button
                                                                    onClick={() => handleCopyOrderLink(line)} 
                                                                    title={copiedField === `orderLink-${line.order?.ordernum || line.ordernum}` ? 'Link copied!' : 'Copy shareable link'}
                                                                    style={{ 
                                                                        background: 'none', 
                                                                        border: 'none', 
                                                                        padding: 0, 
                                                                        cursor: 'pointer',
                                                                        color: copiedField === `orderLink-${line.order?.ordernum || line.ordernum}` ? '#28a745' : '#007bff'
                                                                    }}
                                                                >
                                                                    <i className={`fa ${copiedField === `orderLink-${line.order?.ordernum || line.ordernum}` ? 'fa-check' : 'fa-link'}`} style={{ fontSize: '16px' }}></i>
                                                                </button> */}
                                                            </div>
                                                        </td>
<td className="text-center">
                                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                                <a href={`https://gigaflightinc.cetecerp.com/order/MN${line.order.ordernum}/view`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ textDecoration: 'none', whiteSpace: 'nowrap' }}>
                                                                    {getCetecOrderNumber(line)}
                                                                </a>
                                                                {renderRowActivity(line)}
                                                                {(() => {
                                                                    const rowLinks = orderAccessLinks?.[line.id];
                                                                    const rowLinkUrl = Array.isArray(rowLinks) && rowLinks.length > 0
                                                                        ? rowLinks[rowLinks.length - 1]?.url?.trim()
                                                                        : null;
                                                                    const fallbackUrl = typeof line.folderUrl === 'string' ? line.folderUrl.trim() : null;
                                                                    const folderLink = rowLinkUrl || fallbackUrl || null;
                                                                    const folderTitle = folderLink ? `Open folder: ${folderLink}` : 'No folder link saved yet';
                                                                    return (
                                                                        <a
                                                                            href={folderLink || '#'}
                                                                            onClick={(event) => {
                                                                                if (!folderLink) {
                                                                                    event.preventDefault();
                                                                                }
                                                                            }}
                                                                            target={folderLink ? '_blank' : undefined}
                                                                            rel={folderLink ? 'noopener noreferrer' : undefined}
                                                                            style={{ 
                                                                                cursor: folderLink ? 'pointer' : 'not-allowed',
                                                                                textDecoration: 'none'
                                                                            }}
                                                                            title={folderTitle}
                                                                        >
                                                                            <i className="fa fa-folder" aria-hidden="true" style={{ fontSize: '16px', color: folderLink ? (isOrange ? '#cc7a00' : '#ff8c00') : '#cccccc' }}></i>
                                                                        </a>
                                                                    );
                                                                })()}
                                                            </div>
                                                        </td>
<td className="text-center" style={{ minWidth: '172px', maxWidth: '172px', whiteSpace: 'nowrap' }}>
                                                            {getOrderedOnDate(line)}
                                                        </td>
<td className="text-center">
                                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                                <a href={`https://gigaflightinc.cetecerp.com/order/MN${line.order?.woNum}/view`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ textDecoration: 'none' }}>
                                                                    {line.order?.woNum || '-'}
                                                                </a>
                                                                {line.order?.woNum && line.order.woNum !== '-' && (
                                                                    <a
                                                                        href={line.order?.woUrl || '#'}
                                                                        onClick={(event) => {
                                                                            if (!line.order?.woUrl) {
                                                                                event.preventDefault();
                                                                            }
                                                                        }}
                                                                        target={line.order?.woUrl ? '_blank' : undefined}
                                                                        rel={line.order?.woUrl ? 'noreferrer' : undefined}
                                                                        style={{ 
                                                                            cursor: line.order?.woUrl ? 'pointer' : 'not-allowed',
                                                                            textDecoration: 'none',
                                                                            marginLeft: '4px'
                                                                        }}
                                                                        title={line.order?.woUrl ? `Open WO folder: ${line.order.woUrl}` : 'No WO folder link available'}
                                                                    >
                                                                        <i className="fa fa-folder" aria-hidden="true" style={{ fontSize: '16px', color: line.order?.woUrl ? (isOrange ? '#cc7a00' : '#ff8c00') : '#cccccc' }}></i>
                                                                    </a>
                                                                )}
                                                            </div>
                                                            {renderPrevWoNum(line)}
                                                        </td>
                                                {/* <td className="text-center">
                                                            {line.order?.woNum || '-'}
                                                        </td> */}
<td className="text-center">
                                                            {line.order.customer?.id ? (
                                                                <a 
                                                                    href={`https://gigaflightinc.cetecerp.com/customer/${line.order.customer.id}/view`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ textDecoration: 'none' }}
                                                                >
                                                                    {line.order.customer.name || ''}
                                                                </a>
                                                            ) : (
                                                                line.order.customer ? line.order.customer.name : ''
                                                            )}
                                                        </td>
<td className="text-center">{line.order.custponum}</td>
<td className="text-center">{displayShipDate || 'N/A'}</td>
<td className="text-center" style={{
                                                            backgroundColor: (isPoReview || isOrange || isPurple) ? 'transparent' : (isLineItemMismatch ? '#e74c3c' : 'transparent'),
                                                            color: isPoReview ? '#ffffff' : ((isLineItemMismatch && !isPurple && !isOrange) ? 'white' : 'inherit'),
                                                            fontWeight: isLineItemMismatch ? 'bold' : 'normal'
                                                        }}>{line.negativeCountStr}</td>
                                                        {/* <td className="text-center">
                                                        <div className="order-status-dropdown position-relative">
                                                            <div
                                                                className="form-control d-flex align-items-center justify-content-between"
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    minHeight: '38px',
                                                                    backgroundColor: 'white',
                                                                    border: '1px solid #ced4da'
                                                                }}
                                                                onClick={() => toggleDropdown(line.id)}
                                                            >
                                                                <div className="d-flex flex-wrap gap-1">
                                                                    {(orderStatusSelections[line.id] || []).map((tag, index) => (
                                                                        <span
                                                                            key={index}
                                                                            className="badge"
                                                                            style={{
                                                                                backgroundColor: tag.color,
                                                                                color: 'white',
                                                                                fontSize: '0.75rem',
                                                                                padding: '4px 8px',
                                                                                borderRadius: '12px'
                                                                            }}
                                                                        >
                                                                            {tag.label}
                                                                            <button
                                                                                type="button"
                                                                                className="btn-close btn-close-white ms-1"
                                                                                style={{ fontSize: '8px' }}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleOrderStatusToggle(line.id, tag);
                                                                                }}
                                                                            >
                                                                                ×
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                    {(orderStatusSelections[line.id] || []).length === 0 && (
                                                                        <span className="text-muted">Select tags...</span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {dropdownOpen[line.id] && (
                                                                <div
                                                                    className="position-absolute w-100"
                                                                >
                                                                    {ORDER_STATUS_TAGS.map((tag, index) => {
                                                                        const isSelected = (orderStatusSelections[line.id] || []).some(
                                                                            selection => selection.label === tag.label
                                                                        );
                                                                        return (
                                                                            <div
                                                                                key={index}
                                                                                className="p-2 d-flex align-items-center"
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    backgroundColor: isSelected ? '#f8f9fa' : 'white',
                                                                                    borderBottom: '1px solid #f1f1f1'
                                                                                }}
                                                                                onClick={() => handleOrderStatusToggle(line.id, tag)}
                                                                            >
                                                                                {tag.icon ? (
                                                                                    <i className={`${tag.icon} me-2`} aria-hidden="true" style={{ color: tag.color, fontSize: '14px' }}></i>
                                                                                ) : (
                                                                                    <div
                                                                                        className="me-2"
                                                                                        style={{
                                                                                            width: '12px',
                                                                                            height: '12px',
                                                                                            borderRadius: '2px',
                                                                                            backgroundColor: tag.color
                                                                                        }}
                                                                                    ></div>
                                                                                )}
                                                                                <span style={{ fontSize: '0.875rem' }}>
                                                                                    {tag.label}
                                                                                </span>
                                                                                {isSelected && (
                                                                                    <span className="ms-auto">✓</span>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td> */}
<td className="text-center">
                                                            <div className="d-flex align-items-center gap-2">
                                                                {renderOrderStatusPresence(line.id)}
                                                                <div
                                                                    className="form-control order-status-trigger d-flex align-items-center justify-content-between flex-grow-1"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        minHeight: "38px",
                                                                        backgroundColor: "white",
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    onClick={(e) => handleSelectTagsClick(e, line)}
                                                                >
                                                                    <div className="d-flex flex-wrap gap-1">
                                                                        {/* Current selections */}
                                                                        {(orderStatusSelections[line.id] || []).map((tag, index) => (
                                                                            <span
                                                                                key={`current-${index}`}
                                                                                className="badge"
                                                                                style={{
                                                                                    backgroundColor: tag.color,
                                                                                    color: "white",
                                                                                    fontSize: "0.75rem",
                                                                                    padding: "4px 8px",
                                                                                    borderRadius: "12px",
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: "4px"
                                                                                }}
                                                                            >
                                                                                {tag.icon && <i className={tag.icon} aria-hidden="true"></i>}
                                                                                {tag.label}
                                                                            </span>
                                                                        ))}

                                                                        {/* Submitted tags with click to deselect */}
                                                                        {(submittedOrderStatuses[line.id] || []).map((tag, index) => {
                                                                            const isMarkedForDeselection = (tagsToDeselect[line.id] || []).some(t => t.label === tag.label);
                                                                            return (
                                                                                <span
                                                                                    key={`submitted-${index}`}
                                                                                    className="badge"
                                                                                    style={{
                                                                                        backgroundColor: isMarkedForDeselection ? "#6c757d" : tag.color,
                                                                                        color: "white",
                                                                                        fontSize: "0.75rem",
                                                                                        padding: "4px 8px",
                                                                                        borderRadius: "12px",
                                                                                        cursor: "pointer",
                                                                                        opacity: isMarkedForDeselection ? 0.6 : 1,
                                                                                        display: "inline-flex",
                                                                                        alignItems: "center",
                                                                                        gap: "4px"
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleTagDeselect(line.id, tag);
                                                                                    }}
                                                                                    title={isMarkedForDeselection ? "Click to keep this tag" : "Click to deselect this tag"}
                                                                                >
                                                                                    {tag.icon && <i className={tag.icon} aria-hidden="true"></i>}
                                                                                    {tag.label}
                                                                                </span>
                                                                            );
                                                                        })}

                                                                        {(orderStatusSelections[line.id] || []).length === 0 && (submittedOrderStatuses[line.id] || []).length === 0 && (
                                                                            <span className="text-muted">Select tags...</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {hasChangesToSubmit(line.id) && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success btn-sm order-status-submit-btn"
                                                                        style={{
                                                                            minWidth: "20px",
                                                                            height: "20px",
                                                                            padding: "0",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            fontSize: "10px",
                                                                            borderRadius: "2px"
                                                                        }}
                                                                        onMouseDown={(e) => e.stopPropagation()}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleOrderStatusSubmit(line.id);
                                                                        }}
                                                                        title="Submit changes"
                                                                    >
                                                                        ✓
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>

<td className="text-center bom-availability-cell">
                                                            {(() => {
                                                                const report = orderLineStatusReportMap[String(line.order?.ordernum || '')] ?? orderLineStatusReportMap[line.order?.ordernum];
                                                                if (!report) return <span className="text-muted">-</span>;
                                                                return <BomAvailabilityPill missing={report.missingPartsCount} total={report.totalPartsCount} />;
                                                            })()}
                                                        </td>
<td
                                                            className={`text-center${priorityLineStatusHighlight ? ' line-status-priority-cell' : ''}`}
                                                            style={{
                                                            minWidth: '200px',
                                                            maxWidth: '250px',
                                                            backgroundColor: lineStatusReportHighlight.backgroundColor,
                                                            color: lineStatusReportHighlight.textColor,
                                                            ...(priorityLineStatusHighlight ? {
                                                                '--line-status-highlight': priorityLineStatusHighlight.backgroundColor,
                                                                '--line-status-highlight-text': priorityLineStatusHighlight.textColor,
                                                                boxShadow: 'none'
                                                            } : {})
                                                        }}>
                                                            {(() => {
                                                                const reportRows = getDisplayLineStatusReportRows(line);
                                                                if (reportRows.length === 0) {
                                                                    return <span className="text-muted">-</span>;
                                                                }
                                                                return (
                                                                <div style={{ fontSize: '0.85rem', lineHeight: '1.4' }}>
                                                                    {reportRows.map((r, idx) => (
                                                                        <div key={`${normalizeLineStatusKey(r.status)}-${idx}`} style={{ paddingBottom: '4px' }}>
                                                                            <strong>{formatLineStatusDisplayLabel(r.status)}</strong> - <span style={{ color: lineStatusReportHighlight.textColor === 'inherit' ? '#28a745' : lineStatusReportHighlight.textColor, fontWeight: '600' }}>{getLineReportPercentage(r)}%</span>
                                                                            <div style={{ fontSize: '0.75rem', color: lineStatusReportHighlight.secondaryTextColor }}>({r.count}/{r.totalCount})</div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                );
                                                            })()}
                                                        </td>

<td className="text-center">{renderShippingMethodCell(line.order.shipmentMethod?.methodOfShipment)}</td>
<td className={!isPoReview && line.order.country.country_Name !== 'United States' ? 'bg-dark text-light text-center country-cell-intl' : (line.order.country.country_Name === 'United States' ? 'text-center country-cell-us' : 'text-center')}>
                                                            {line.order.country.country_Name}
                                                        </td>
                                                        {/* <td>{line.orig_shipdate}</td> */}
<td className="notes-column sticky-notes-column">
                                                            {renderStickyNotes(line)}
                                                        </td>
<td className="order-access-column">
                                                            <div className="d-flex flex-column align-items-center justify-content-center gap-2" style={{ width: '100%', maxWidth: '118px', margin: '0 auto' }}>
                                                                {/* Display existing URLs as chips added for test 989898989 989483984983*/}
                                                                {/* added for test */}
                                                                {line?.order?.orderUrls && line.order.orderUrls.length > 0 && (
                                                                    <div className="d-flex flex-wrap gap-1 justify-content-center" style={{ width: '100%' }}>
                                                                        {line.order.orderUrls.map((urlItem) => (
                                                                            <div
                                                                                key={urlItem.id}
                                                                                style={{
                                                                                    display: 'inline-flex',
                                                                                    alignItems: 'center',
                                                                                    backgroundColor: '#f0f0f0',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '12px',
                                                                                    padding: '3px 6px',
                                                                                    fontSize: '10px',
                                                                                    maxWidth: '112px',
                                                                                    position: 'relative'
                                                                                }}
                                                                            >
                                                                                <a
                                                                                    href={urlItem.url}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    style={{
                                                                                        textDecoration: 'none',
                                                                                        color: '#007bff',
                                                                                        fontWeight: '500',
                                                                                        marginRight: '4px',
                                                                                        flexGrow: 1,
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        whiteSpace: 'nowrap'
                                                                                    }}
                                                                                    title={`${urlItem.urlName}: ${urlItem.url}`}
                                                                                >
                                                                                    {urlItem.urlName}
                                                                                </a>
                                                                                <button
                                                                                    type="button"
                                                                                    className="order-access-remove"
                                                                                    onClick={() => handleDeleteOrderAccessLink(line.id, urlItem.id, line.order?.ordernum, urlItem.urlName)}
                                                                                    title="Delete this URL"
                                                                                >
                                                                                    ×
                                                                                </button>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                                {/* Add button */}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-secondary"
                                                                    style={{
                                                                        fontSize: '0.7rem',
                                                                        padding: '3px 8px',
                                                                        height: '28px'
                                                                    }}
                                                                    onClick={() => handleOrderAccessClick(line)}
                                                                    title="Add folder access link"
                                                                >
                                                                    <i className="fa fa-plus" style={{ marginRight: '3px' }}></i>
                                                                    Add
                                                                </button>
                                                            </div>
                                                        </td>
<td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-link p-0"
                                                                onClick={() => handleArchiveOrder(line)}
                                                                title="Archive this order"
                                                                style={{ 
                                                                    fontSize: '1.2rem',
                                                                    color: '#6c757d',
                                                                    textDecoration: 'none'
                                                                }}
                                                            >
                                                                <i className="fa fa-paper-plane" aria-hidden="true"></i>
                                                            </button>
                                                        </td>
                                                        {/* <td style={{ textAlign: "center" }}>
                                                        <a onClick={() => {
                                                            setUpdatePopUp(line);
                                                            handleShow();
                                                            setFormData(line.comment || null);
                                                        }}>

                                                            <img src={editIcon} className='img-fluid' style={{ height: "20px" }} />
                                                        </a>
                                                    </td> */}
                                                        </ReorderableCells>
                                                    </tr>

                                                    <InlineOrderDropdown
                                                        line={line}
                                                        inlineDropdownMode={inlineDropdownMode}
                                                        expandedInlineOrders={expandedInlineOrders}
                                                        orderDetailsData={orderDetailsData}
                                                        inlineActiveView={inlineActiveView}
                                                        renderInlineOrderHeader={renderInlineOrderHeader}
                                                        orderFolderLink={resolveOrderFolderLinkForLine(line)}
                                                        onInlineViewChange={handleInlineViewChange}
                                                        onInlineSwitchView={handleInlineSwitchView}
                                                        onInlineDualView={handleInlineDualView}
                                                        expandedInlineBomRows={expandedInlineBomRows}
                                                        onToggleInlineBomRow={toggleInlineBomRow}
                                                        lineStatusSelections={lineStatusSelections}
                                                        submittedLineStatuses={submittedLineStatuses}
                                                        lineTagsToDeselect={lineTagsToDeselect}
                                                        lineStatusDropdownOpen={lineStatusDropdownOpen}
                                                        onToggleLineStatusDropdown={toggleLineStatusDropdown}
                                                        onHandleLineStatusToggle={handleLineStatusToggle}
                                                        onHandleLineTagDeselect={handleLineTagDeselect}
                                                        onHandleBulkLineTagDeselect={handleBulkLineTagDeselect}
                                                        hasLineChangesToSubmit={hasLineChangesToSubmit}
                                                        onHandleLineStatusSubmit={handleLineStatusSubmit}
                                                        renderLinePresence={renderLinePresence}
                                                        lineStatusLockOwner={lineStatusLockOwner}
                                                        lineStatusTags={LINE_STATUS_TAGS}
                                                        contentPaddingClass="p-4"
                                                        tableClassName="table table-hover border rounded inline-order-details-table inline-order-lines-table"
                                                        dualViewOrderTableClassName="table table-sm table-hover border rounded inline-dual-order-lines-table"
                                                        dualViewBomTableClassName="table table-sm table-hover border rounded"
                                                        commentsMap={commentsMap}
                                                        onAddComment={handleAddComment}
                                                        shouldRowBeGreen={shouldRowBeGreen}
                                                        orderData={orderData}
                                                        onDeleteComment={handleDeleteComment}
                                                        onResolveThread={handleResolveThread}
                                                        orderBulkModeEnabled={orderBulkModeEnabled}
                                                        setOrderBulkModeEnabled={setOrderBulkModeEnabled}
                                                        orderHasBulkChanges={orderHasBulkChanges}
                                                        setOrderHasBulkChanges={setOrderHasBulkChanges}
                                                        onBulkSubmit={handleBulkLineStatusSubmit}
                                                        onArchiveOrderLine={handleArchiveOrderLineItem}
                                                        onArchiveBomPart={handleArchiveBomPart}
                                                        archivedOrderIds={archivedOrderIds}
                                                        excludedAvailabilityPartsByOrder={excludedAvailabilityPartsByOrder}
                                                        onToggleExcludedAvailabilityPart={handleToggleExcludedAvailabilityPart}
                                                        dropdownColSpan={Math.max(1, effectiveColumnOrder.length - 3)}
                                                        dropdownTrailingCells={3}
                                                    />
                                                </React.Fragment>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    ) : null}
                    {/* Dropdown rendered outside the table */}
                    {dropdownOpenId && (
                        <OrderStatusDropdown
                            visible={true}
                            position={dropdownPosition}
                            orderStatuses={ORDER_STATUS_TAGS}
                            savedCustomTags={collectCustomOrderStatusTags(
                                [submittedOrderStatuses, orderStatusSelections],
                                ORDER_STATUS_TAGS
                            )}
                            allowCustomTag
                            selectedTags={orderStatusSelections[dropdownOpenId] || []}
                            onToggleTag={(tag) => handleOrderStatusToggle(dropdownOpenId, tag)}
                            onClose={() => setDropdownOpenId(null)}
                            menuClassName="order-status-menu"
                        />
                    )}
                </>
                </div>
            </div>
                )}

            <div className="row px-2 mb-4" style={{ width: '100%' }}>
                <div className="col-12">
                    <div className="table-section-title table-section-title-left">
                        <span className="table-section-text table-section-text-left">
                            All Orders
                        </span>
                        <span className="table-section-count" aria-label={`All Orders count ${filteredOrderData.length}`}>
                            {filteredOrderData.length}
                        </span>
                    </div>
                    <div
                        className="container-fluid p-0"
                        style={{
                            width: '100%',
                            margin: 0,
                        }}
                    >
                        <div
                            className="orders-table-scroll"
                            style={{
                                width: '100%',
                                margin: 0,
                            }}
                        >
                    {loading ? (
                        <div className="text-center vh-50 d-flex justify-content-center align-items-center">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <table className="table gf-table table-bordered table-hover mb-0 orders-table" style={{ minWidth: '1000px' }}>
                            <thead className="sticky-top">
                                <tr>
                                    {/* <th className="text-center" onClick={() => handleSort('lineitem')}>{messages.line_item} {getSortIcon('lineitem')}</th> */}
                                    <ReorderableCells order={effectiveColumnOrder} mergedCells={mergedHeaderCells} draggable dragHandlers={orderColumnDragHandlers} draggedColumnId={draggedColumnId} columnVisibility={columnVisibility} onToggleColumn={toggleColumnVisibility} isHeader>
<th className="text-center" style={{ minWidth: '130px', maxWidth: '150px' }}>Info</th>
<th className="text-center" style={{ minWidth: '190px', maxWidth: '190px', cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleColumnSort('ordernum')}>
                                        {messages.order_no_label} {getColumnSortIcon('ordernum')}
                                    </th>
<th className="text-center" style={{ minWidth: '172px', maxWidth: '172px', cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleColumnSort('orderedondate')}>
                                        Ordered On Date {getColumnSortIcon('orderedondate')}
                                    </th>
<th className="text-center" style={{ minWidth: '120px', maxWidth: '120px' }}>WO#</th>
<th className="text-center" style={{ minWidth: '200px', maxWidth: '200px', cursor: 'pointer' }} onClick={() => handleColumnSort('name')}>
                                        {messages.customer_name_label} {getColumnSortIcon('name')}
                                    </th>
<th className="text-center" style={{ minWidth: '120px', maxWidth: '120px', cursor: 'pointer' }} onClick={() => handleColumnSort('custponum')}>
                                        {messages.po_no_label} {getColumnSortIcon('custponum')}
                                    </th>
<th className="text-center" style={{ minWidth: '150px', maxWidth: '150px', cursor: 'pointer' }} onClick={handleShippingDateSort}>
                                        {messages.shipping_date_label} {getShippingDateSortIcon()}
                                    </th>
<th className="text-center" style={{ minWidth: '100px', maxWidth: '100px' }}>{messages.line_item}</th>
<th className="text-center" style={{ minWidth: '150px', maxWidth: '150px' }}>Order Status</th>
<th className="text-center bom-availability-cell">BOM</th>
<th className="text-center" style={{ minWidth: '200px', maxWidth: '250px' }}>Line Status Report</th>
<th className="text-center" style={{ minWidth: '168px', maxWidth: '168px' }}>{messages.shipping_method_label}</th>
<th className="text-center" style={{ minWidth: '120px', maxWidth: '120px', cursor: 'pointer' }} onClick={() => handleColumnSort('country_name')}>
                                        {messages.country_label} {getColumnSortIcon('country_name')}
                                    </th>
                                    {/* <th className="text-center" style={{ minWidth: '100px', maxWidth: '100px' }} onClick={() => handleSort('orig_shipdate')}>{messages.shipping_date_label} {getSortIcon('orig_shipdate')}</th> */}
<th className="text-center" style={{ minWidth: '280px', maxWidth: '320px' }}>Sticky Notes</th>
<th className="text-center order-access-column" style={{ width: '152px', minWidth: '152px', maxWidth: '152px' }}>Order Access</th>
<th className="text-center" style={{ minWidth: '96px', maxWidth: '96px' }}>Archive</th>
                                    {/* <th className="text-center" style={{ minWidth: '80px', maxWidth: '80px' }}>{messages.action_label}</th> */}
                                    </ReorderableCells>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedOrders.length > 0 ? (
                                    paginatedOrders.map((line, lineIndex) => {
                                        const displayShipDate = getEarliestPromisedDateForOrder(line);
                                        const rowStyle = getRowStyle(displayShipDate);
                                        const existingStyle = rowStyle.style || {};
                                        const isPoReview = shouldRowBePoReview(line);
                                        const isOrange = shouldRowBeOrange(line);
                                        const isPurple = shouldRowBePurple(line);
                                        const rowBackground = isPoReview ? '#232323' : isOrange ? '#FF9D47' : isPurple ? '#BEA9FF' : (shouldRowBeGreen(line) ? '#d4edda' : (existingStyle.backgroundColor || 'transparent'));
                                        const lightDateRow = !isPoReview && !isOrange && !isPurple && ['#f8d7da', '#fff3cd', '#d1ecf1', '#d4edda'].includes(String(rowBackground).toLowerCase());
                                        const priorityLineStatusHighlight = getPriorityLineStatusHighlight(line);
                                        const lineStatusReportHighlight = priorityLineStatusHighlight
                                            || (isPoReview
                                                ? { backgroundColor: 'transparent', textColor: '#ffffff', secondaryTextColor: 'rgba(255, 255, 255, 0.85)' }
                                                : (isOrange || isPurple)
                                                    ? { backgroundColor: 'transparent', textColor: 'inherit', secondaryTextColor: '#212529' }
                                                    : getLineStatusReportHighlight(line));
                                        const isLineItemMismatch = line.negativeCountStr && line.negativeCountStr.includes('/') &&
                                            parseInt(line.negativeCountStr.split('/')[0]) !== parseInt(line.negativeCountStr.split('/')[1]);
                                        return (
                                        <React.Fragment key={`${line.order.id}-${lineIndex}`}>
                                            <tr
                                                className={[isPoReview ? 'po-review-row' : '', !isPoReview && isOrange ? 'hot-order-row' : '', !isPoReview && !isOrange && isPurple ? 'cc-hold-ppa-row' : '', lightDateRow ? 'bridge-light-row' : ''].filter(Boolean).join(' ') || undefined}
                                                style={{
                                                ...existingStyle,
                                                backgroundColor: rowBackground,
                                                color: isPoReview ? '#ffffff' : (lightDateRow ? '#212529' : undefined)
                                            }}>
                                                <ReorderableCells order={effectiveColumnOrder} mergedCells={getMergedBodyCells(line, displayShipDate, isOrange, isPoReview)} columnVisibility={columnVisibility}>

                                                {/* <td className="text-center"
                                                style={line.hasNegativeQuantity ? { background: 'pink' } : {}}
                                                // onMouseOver={() => handleSingleOrder(line.order.ordernum)}
                                                // onMouseLeave={() => setHoverRowId(null)}
                                                >
                                                {line.linesIds ? (
                                                    <select 
                                                        className="form-select"
                                                        style={{ width: "75px" }}
                                                        value={line.lineitem}
                                                        onChange={(e) => handleLineItemChange(e.target.value, line.order.ordernum)}
                                                    >
                                                        {line.linesIds.map((id, idx) => (
                                                            <option key={idx} value={id}>
                                                                {id}
                                                            </option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    line.lineitem
                                                )}
                                            </td> */}
<td className="text-center orders-info-cell" >
                                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                                        <button onClick={() => { handleEyeIconClick(line) }} title='View order details' style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                                                            <img src={viewIcon} alt="view order" style={{ width: '20px' }} />
                                                        </button>
                                                        <OrderHistoryIconButton
                                                            unreadCount={getUnreadCount(line?.order?.ordernum || line?.ordernum)}
                                                            onClick={() => { handleHistoryIconClick(line) }}
                                                        />
                                                        {renderInfoComments(line)}
                                                        {renderRowPresence(line.order?.ordernum || line.ordernum)}
                                                        {/* <button
                                                            onClick={() => handleCopyOrderLink(line)} 
                                                            title={copiedField === `orderLink-${line.order?.ordernum || line.ordernum}` ? 'Link copied!' : 'Copy shareable link'}
                                                            style={{ 
                                                                background: 'none', 
                                                                border: 'none', 
                                                                padding: 0, 
                                                                cursor: 'pointer',
                                                                color: copiedField === `orderLink-${line.order?.ordernum || line.ordernum}` ? '#28a745' : '#007bff'
                                                            }}
                                                        >
                                                            <i className={`fa ${copiedField === `orderLink-${line.order?.ordernum || line.ordernum}` ? 'fa-check' : 'fa-link'}`} style={{ fontSize: '16px' }}></i>
                                                        </button> */}
                                                    </div>
                                                </td>
                                               <td className="text-center" style={{ minWidth: '190px', maxWidth: '190px', whiteSpace: 'nowrap'}}>
                                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                                        <a href={`https://gigaflightinc.cetecerp.com/order/MN${line.order.ordernum}/view`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ textDecoration: 'none', whiteSpace: 'nowrap' }}>
                                                            {getCetecOrderNumber(line)}
                                                        </a>
                                                        {renderRowActivity(line)}
                                                        {(() => {
                                                            const rowLinks = orderAccessLinks?.[line.id];
                                                            const rowLinkUrl = Array.isArray(rowLinks) && rowLinks.length > 0
                                                                ? rowLinks[rowLinks.length - 1]?.url?.trim()
                                                                : null;
                                                            const fallbackUrl = typeof line.folderUrl === 'string' ? line.folderUrl.trim() : null;
                                                            const folderLink = rowLinkUrl || fallbackUrl || null;
                                                            const folderTitle = folderLink ? `Open folder: ${folderLink}` : 'No folder link saved yet';
                                                            return (
                                                                <a
                                                                    href={folderLink || '#'}
                                                                    onClick={(event) => {
                                                                        if (!folderLink) {
                                                                            event.preventDefault();
                                                                        }
                                                                    }}
                                                                    target={folderLink ? '_blank' : undefined}
                                                                    rel={folderLink ? 'noopener noreferrer' : undefined}
                                                                    style={{ 
                                                                        cursor: folderLink ? 'pointer' : 'not-allowed',
                                                                        textDecoration: 'none'
                                                                    }}
                                                                    title={folderTitle}
                                                                >
                                                                    <i className="fa fa-folder" aria-hidden="true" style={{ fontSize: '16px', color: folderLink ? (isOrange ? '#cc7a00' : '#ff8c00') : '#cccccc' }}></i>
                                                                </a>
                                                            );
                                                        })()}
                                                    </div>
                                                </td>
                                                <td className="text-center" style={{ minWidth: '172px', maxWidth: '172px', whiteSpace: 'nowrap' }}>
                                                    {getOrderedOnDate(line)}
                                                </td>
<td className="text-center">
                                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                                <a href={`https://gigaflightinc.cetecerp.com/order/MN${line.order?.woNum}/view`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ textDecoration: 'none' }}>
                                                                    {line.order?.woNum || '-'}
                                                                </a>
                                                                {line.order?.woNum && line.order.woNum !== '-' && (
                                                                    <a
                                                                        href={line.order?.woUrl || '#'}
                                                                        onClick={(event) => {
                                                                            if (!line.order?.woUrl) {
                                                                                event.preventDefault();
                                                                            }
                                                                        }}
                                                                        target={line.order?.woUrl ? '_blank' : undefined}
                                                                        rel={line.order?.woUrl ? 'noreferrer' : undefined}
                                                                        style={{ 
                                                                            cursor: line.order?.woUrl ? 'pointer' : 'not-allowed',
                                                                            textDecoration: 'none',
                                                                            marginLeft: '4px'
                                                                        }}
                                                                        title={line.order?.woUrl ? `Open WO folder: ${line.order.woUrl}` : 'No WO folder link available'}
                                                                    >
                                                                        <i className="fa fa-folder" aria-hidden="true" style={{ fontSize: '16px', color: line.order?.woUrl ? (isOrange ? '#cc7a00' : '#ff8c00') : '#cccccc' }}></i>
                                                                    </a>
                                                                )}
                                                            </div>
                                                            {renderPrevWoNum(line)}
                                                        </td>
                                                {/* <td className="text-center">
                                                    {line.order?.woNum || '-'}
                                                </td> */}
<td className="text-center">
                                                    {line.order.customer?.id ? (
                                                        <a 
                                                            href={`https://gigaflightinc.cetecerp.com/customer/${line.order.customer.id}/view`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ textDecoration: 'none' }}
                                                        >
                                                            {line.order.customer.name || ''}
                                                        </a>
                                                    ) : (
                                                        line.order.customer ? line.order.customer.name : ''
                                                    )}
                                                </td>
<td className="text-center">{line.order.custponum}</td>
<td className="text-center">{displayShipDate || 'N/A'}</td>

                                                {/*<td style={{
                                                    backgroundColor: line.negativeCountStr && line.negativeCountStr.includes('/') &&
                                                        parseInt(line.negativeCountStr.split('/')[0]) > 0 ? '#e74c3c' : 'transparent',
                                                    color: line.negativeCountStr && line.negativeCountStr.includes('/') &&
                                                        parseInt(line.negativeCountStr.split('/')[0]) > 0 ? 'white' : 'inherit',
                                                    fontWeight: line.negativeCountStr && line.negativeCountStr.includes('/') &&
                                                        parseInt(line.negativeCountStr.split('/')[0]) > 0 ? 'bold' : 'normal'
													}}>{line.negativeCountStr}</td> */}

<td className="text-center"
                                                    style={{
                                                        backgroundColor: (isPoReview || isOrange || isPurple) ? 'transparent' : (
                                                            line.negativeCountStr &&
                                                            line.negativeCountStr.includes('/') &&
                                                            (() => {
                                                                const parts = line.negativeCountStr.split('/');
                                                                const first = parseInt(parts[0]) || 0;
                                                                const second = parseInt(parts[1]) || 0;
                                                                return first - second === 0 ? 'transparent' : '#e74c3c';
                                                            })()
                                                        ),
                                                        color: isPoReview ? '#ffffff' : (
                                                            (isPurple || isOrange) ? 'inherit' : (
                                                            line.negativeCountStr &&
                                                            line.negativeCountStr.includes('/') &&
                                                            (() => {
                                                                const parts = line.negativeCountStr.split('/');
                                                                const first = parseInt(parts[0]) || 0;
                                                                const second = parseInt(parts[1]) || 0;
                                                                return first - second === 0 ? 'inherit' : 'white';
                                                            })()
                                                            )
                                                        ),
                                                        fontWeight:
                                                            line.negativeCountStr &&
                                                            line.negativeCountStr.includes('/') &&
                                                            (() => {
                                                                const parts = line.negativeCountStr.split('/');
                                                                const first = parseInt(parts[0]) || 0;
                                                                const second = parseInt(parts[1]) || 0;
                                                                return first - second === 0 ? 'normal' : 'bold';
                                                            })(),
                                                    }}
                                                >
                                                    {line.negativeCountStr}
                                                </td>

                                                {/* <td className="text-center">
                                                    <div className="order-status-dropdown position-relative">
                                                        <div
                                                            className="form-control d-flex align-items-center justify-content-between"
                                                            style={{
                                                                cursor: 'pointer',
                                                                minHeight: '38px',
                                                                backgroundColor: 'white',
                                                                border: '1px solid #ced4da'
                                                            }}
                                                            onClick={() => toggleDropdown(line.id)}
                                                        >
                                                            <div className="d-flex flex-wrap gap-1">
                                                                {(orderStatusSelections[line.id] || []).map((tag, index) => (
                                                                    <span
                                                                        key={index}
                                                                        className="badge"
                                                                        style={{
                                                                            backgroundColor: tag.color,
                                                                            color: 'white',
                                                                            fontSize: '0.75rem',
                                                                            padding: '4px 8px',
                                                                            borderRadius: '12px'
                                                                        }}
                                                                    >
                                                                        {tag.label}
                                                                        <button
                                                                            type="button"
                                                                            className="btn-close btn-close-white ms-1"
                                                                            style={{ fontSize: '8px' }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleOrderStatusToggle(line.id, tag);
                                                                            }}
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </span>
                                                                ))}
                                                                {(orderStatusSelections[line.id] || []).length === 0 && (
                                                                    <span className="text-muted">Select tags...</span>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {dropdownOpen[line.id] && (
                                                            <div
                                                                className="position-absolute w-100"
                                                                style={{
                                                                    top: '100%',
                                                                    left: 0,
                                                                    zIndex: 1000,
                                                                    backgroundColor: 'white',
                                                                    border: '1px solid #ced4da',
                                                                    borderRadius: '4px',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                                    maxHeight: '200px',
                                                                    overflowY: 'auto'
                                                                }}
                                                            >
                                                                {ORDER_STATUS_TAGS.map((tag, index) => {
                                                                    const isSelected = (orderStatusSelections[line.id] || []).some(
                                                                        selection => selection.label === tag.label
                                                                    );
                                                                    return (
                                                                        <div
                                                                            key={index}
                                                                            className="p-2 d-flex align-items-center"
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                backgroundColor: isSelected ? '#f8f9fa' : 'white',
                                                                                borderBottom: '1px solid #f1f1f1'
                                                                            }}
                                                                            onClick={() => handleOrderStatusToggle(line.id, tag)}
                                                                        >
                                                                            {tag.icon ? (
                                                                                <i className={`${tag.icon} me-2`} aria-hidden="true" style={{ color: tag.color, fontSize: '14px' }}></i>
                                                                            ) : (
                                                                                <div
                                                                                    className="me-2"
                                                                                    style={{
                                                                                        width: '12px',
                                                                                        height: '12px',
                                                                                        borderRadius: '2px',
                                                                                        backgroundColor: tag.color
                                                                                    }}
                                                                                ></div>
                                                                            )}
                                                                            <span style={{ fontSize: '0.875rem' }}>
                                                                                {tag.label}
                                                                            </span>
                                                                            {isSelected && (
                                                                                <span className="ms-auto">✓</span>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                </td> */}
                                                {/* <td className="text-center">
                                                    <div
                                                    className="form-control d-flex align-items-center justify-content-between"
                                                    style={{
                                                        cursor: "pointer",
                                                        minHeight: "38px",
                                                        backgroundColor: "white",`
                                                        border: "1px solid #ced4da"
                                                    }}
                                                    onClick={(e) => toggleDropdown(line.id, e)}
                                                    >
                                                    <div className="d-flex flex-wrap gap-1">
                                                        {(orderStatusSelections[line.id] || []).map((tag, index) => (
                                                        <span
                                                            key={index}
                                                            className="badge"
                                                            style={{
                                                            backgroundColor: tag.color,
                                                            color: "white",
                                                            fontSize: "0.75rem",
                                                            padding: "4px 8px",
                                                            borderRadius: "12px",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: "4px"
                                                            }}
                                                        >
                                                            {tag.icon && <i className={tag.icon} aria-hidden="true"></i>}
                                                            {tag.label}
                                                        </span>
                                                        ))}
                                                        {(orderStatusSelections[line.id] || []).length === 0 && (
                                                        <span className="text-muted">Select tags...</span>
                                                        )}
                                                    </div>
                                                    </div>
                                                </td> */}
<td className="text-center">
                                                    <div className="d-flex align-items-center gap-2">
                                                        {renderOrderStatusPresence(line.id)}
                                                        <div
                                                            className="form-control order-status-trigger d-flex align-items-center justify-content-between flex-grow-1"
                                                            style={{
                                                                cursor: "pointer",
                                                                minHeight: "38px",
                                                                backgroundColor: "white",
                                                                border: "1px solid #ced4da"
                                                            }}
                                                            onClick={(e) => handleSelectTagsClick(e, line)}
                                                        >
                                                            <div className="d-flex flex-wrap gap-1">
                                                                {/* Current selections */}
                                                                {(orderStatusSelections[line.id] || []).map((tag, index) => (
                                                                    <span
                                                                        key={`current-${index}`}
                                                                        className="badge"
                                                                        style={{
                                                                            backgroundColor: tag.color,
                                                                            color: "white",
                                                                            fontSize: "0.75rem",
                                                                            padding: "4px 8px",
                                                                            borderRadius: "12px",
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            gap: "4px"
                                                                        }}
                                                                    >
                                                                        {tag.icon && <i className={tag.icon} aria-hidden="true"></i>}
                                                                        {tag.label}
                                                                    </span>
                                                                ))}

                                                                {/* Submitted tags with click to deselect */}
                                                                {(submittedOrderStatuses[line.id] || []).map((tag, index) => {
                                                                    const isMarkedForDeselection = (tagsToDeselect[line.id] || []).some(t => t.label === tag.label);
                                                                    return (
                                                                        <span
                                                                            key={`submitted-${index}`}
                                                                            className="badge"
                                                                            style={{
                                                                                backgroundColor: isMarkedForDeselection ? "#6c757d" : tag.color,
                                                                                color: "white",
                                                                                fontSize: "0.75rem",
                                                                                padding: "4px 8px",
                                                                                borderRadius: "12px",
                                                                                cursor: "pointer",
                                                                                opacity: isMarkedForDeselection ? 0.6 : 1,
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                gap: "4px"
                                                                            }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleTagDeselect(line.id, tag);
                                                                            }}
                                                                            title={isMarkedForDeselection ? "Click to keep this tag" : "Click to deselect this tag"}
                                                                        >
                                                                            {tag.icon && <i className={tag.icon} aria-hidden="true"></i>}
                                                                            {tag.label}
                                                                        </span>
                                                                    );
                                                                })}

                                                                {(orderStatusSelections[line.id] || []).length === 0 && (submittedOrderStatuses[line.id] || []).length === 0 && (
                                                                    <span className="text-muted">Select tags...</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {hasChangesToSubmit(line.id) && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-success btn-sm order-status-submit-btn"
                                                                style={{
                                                                    minWidth: "20px",
                                                                    height: "20px",
                                                                    padding: "0",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    fontSize: "10px",
                                                                    borderRadius: "2px"
                                                                }}
                                                                onMouseDown={(e) => e.stopPropagation()}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleOrderStatusSubmit(line.id);
                                                                }}
                                                                title="Submit changes"
                                                            >
                                                                ✓
                                                            </button>
                                                        )}
                                                    </div>
                                                        </td>

<td className="text-center bom-availability-cell">
                                                            {(() => {
                                                                const report = orderLineStatusReportMap[String(line.order?.ordernum || '')] ?? orderLineStatusReportMap[line.order?.ordernum];
                                                                if (!report) return <span className="text-muted">-</span>;
                                                                return <BomAvailabilityPill missing={report.missingPartsCount} total={report.totalPartsCount} />;
                                                            })()}
                                                        </td>
<td
                                                    className={`text-center${priorityLineStatusHighlight ? ' line-status-priority-cell' : ''}`}
                                                    style={{
                                                    minWidth: '200px',
                                                    maxWidth: '250px',
                                                    backgroundColor: lineStatusReportHighlight.backgroundColor,
                                                    color: lineStatusReportHighlight.textColor,
                                                    ...(priorityLineStatusHighlight ? {
                                                        '--line-status-highlight': priorityLineStatusHighlight.backgroundColor,
                                                        '--line-status-highlight-text': priorityLineStatusHighlight.textColor,
                                                        boxShadow: 'none'
                                                    } : {})
                                                }}>
                                                    {(() => {
                                                        const reportRows = getDisplayLineStatusReportRows(line);
                                                        if (reportRows.length === 0) {
                                                            return <span className="text-muted">-</span>;
                                                        }
                                                        return (
                                                        <div style={{ fontSize: '0.85rem', lineHeight: '1.4' }}>
                                                            {reportRows.map((r, idx) => (
                                                                <div key={`${normalizeLineStatusKey(r.status)}-${idx}`} style={{ paddingBottom: '4px' }}>
                                                                    <strong>{formatLineStatusDisplayLabel(r.status)}</strong> - <span style={{ color: lineStatusReportHighlight.textColor === 'inherit' ? '#28a745' : lineStatusReportHighlight.textColor, fontWeight: '600' }}>{getLineReportPercentage(r)}%</span>
                                                                    <div style={{ fontSize: '0.75rem', color: lineStatusReportHighlight.secondaryTextColor }}>({r.count}/{r.totalCount})</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        );
                                                    })()}
                                                </td>

<td className="text-center">{renderShippingMethodCell(line.order.shipmentMethod?.methodOfShipment)}</td>
<td className={!isPoReview && line.order.country.country_Name !== 'United States' ? 'bg-dark text-light text-center country-cell-intl' : (line.order.country.country_Name === 'United States' ? 'text-center country-cell-us' : 'text-center')}>
                                                    {line.order.country.country_Name}
                                                </td>
                                                {/* <td>{line.orig_shipdate}</td> */}
<td className="notes-column sticky-notes-column">
                                                    {renderStickyNotes(line)}
                                                </td>
<td className="order-access-column">
                                                    <div className="d-flex flex-column align-items-center justify-content-center gap-2" style={{ width: '100%', maxWidth: '118px', margin: '0 auto' }}>
                                                        {/* Display existing URLs as chips */}
                                                        {line?.order?.orderUrls && line.order.orderUrls.length > 0 && (
                                                            <div className="d-flex flex-wrap gap-1 justify-content-center" style={{ width: '100%' }}>
                                                                {line.order.orderUrls.map((urlItem) => (
                                                                    <div
                                                                        key={urlItem.id}
                                                                        style={{
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            backgroundColor: '#f0f0f0',
                                                                            border: '1px solid #ddd',
                                                                            borderRadius: '12px',
                                                                            padding: '3px 6px',
                                                                            fontSize: '10px',
                                                                            maxWidth: '112px',
                                                                            position: 'relative'
                                                                        }}
                                                                    >
                                                                        <a
                                                                            href={urlItem.url}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{
                                                                                textDecoration: 'none',
                                                                                color: '#007bff',
                                                                                fontWeight: '500',
                                                                                marginRight: '4px',
                                                                                flexGrow: 1,
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                            title={`${urlItem.urlName}: ${urlItem.url}`}
                                                                        >
                                                                            {urlItem.urlName}
                                                                        </a>
                                                                        <button
                                                                            type="button"
                                                                            className="order-access-remove"
                                                                            onClick={() => handleDeleteOrderAccessLink(line.id, urlItem.id, line.order?.ordernum, urlItem.urlName)}
                                                                            title="Delete this URL"
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                        {/* Add button */}
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            style={{
                                                                fontSize: '0.7rem',
                                                                padding: '3px 8px',
                                                                height: '28px'
                                                            }}
                                                            onClick={() => handleOrderAccessClick(line)}
                                                            title="Add folder access link"
                                                        >
                                                            <i className="fa fa-plus" style={{ marginRight: '3px' }}></i>
                                                            Add
                                                        </button>
                                                    </div>
                                                </td>
<td className="text-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        onClick={() => handleArchiveOrder(line)}
                                                        title="Archive this order"
                                                        style={{ 
                                                            fontSize: '1.2rem',
                                                            color: '#6c757d',
                                                            textDecoration: 'none'
                                                        }}
                                                    >
                                                        <i className="fa fa-paper-plane" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                                {/* <td style={{ textAlign: "center" }}>
                                                    <a onClick={() => {
                                                        setUpdatePopUp(line);
                                                        handleShow();
                                                        setFormData(line.comment || null);
                                                    }}>

                                                        <img src={editIcon} className='img-fluid' style={{ height: "20px" }} />
                                                    </a>
                                                </td> */}
                                                </ReorderableCells>
                                            </tr>

                                            <InlineOrderDropdown
                                                line={line}
                                                inlineDropdownMode={inlineDropdownMode}
                                                expandedInlineOrders={expandedInlineOrders}
                                                orderDetailsData={orderDetailsData}
                                                inlineActiveView={inlineActiveView}
                                                renderInlineOrderHeader={renderInlineOrderHeader}
                                                orderFolderLink={resolveOrderFolderLinkForLine(line)}
                                                onInlineViewChange={handleInlineViewChange}
                                                onInlineSwitchView={handleInlineSwitchView}
                                                onInlineDualView={handleInlineDualView}
                                                expandedInlineBomRows={expandedInlineBomRows}
                                                onToggleInlineBomRow={toggleInlineBomRow}
                                                lineStatusSelections={lineStatusSelections}
                                                submittedLineStatuses={submittedLineStatuses}
                                                lineTagsToDeselect={lineTagsToDeselect}
                                                lineStatusDropdownOpen={lineStatusDropdownOpen}
                                                onToggleLineStatusDropdown={toggleLineStatusDropdown}
                                                onHandleLineStatusToggle={handleLineStatusToggle}
                                                onHandleLineTagDeselect={handleLineTagDeselect}
                                                onHandleBulkLineTagDeselect={handleBulkLineTagDeselect}
                                                hasLineChangesToSubmit={hasLineChangesToSubmit}
                                                onHandleLineStatusSubmit={handleLineStatusSubmit}
                                                renderLinePresence={renderLinePresence}
                                                lineStatusLockOwner={lineStatusLockOwner}
                                                lineStatusTags={LINE_STATUS_TAGS}
                                                contentPaddingClass="p-4"
                                                tableClassName="table table-hover border rounded inline-order-details-table inline-order-lines-table"
                                                dualViewOrderTableClassName="table table-sm table-hover border rounded inline-dual-order-lines-table"
                                                dualViewBomTableClassName="table table-sm table-hover border rounded"
                                                commentsMap={commentsMap}
                                                onAddComment={handleAddComment}
                                                onDeleteComment={handleDeleteComment}
                                                onResolveThread={handleResolveThread}
                                                orderBulkModeEnabled={orderBulkModeEnabled}
                                                setOrderBulkModeEnabled={setOrderBulkModeEnabled}
                                                orderHasBulkChanges={orderHasBulkChanges}
                                                setOrderHasBulkChanges={setOrderHasBulkChanges}
                                                onBulkSubmit={handleBulkLineStatusSubmit}
                                                onArchiveOrderLine={handleArchiveOrderLineItem}
                                                onArchiveBomPart={handleArchiveBomPart}
                                                archivedOrderIds={archivedOrderIds}
                                                excludedAvailabilityPartsByOrder={excludedAvailabilityPartsByOrder}
                                                onToggleExcludedAvailabilityPart={handleToggleExcludedAvailabilityPart}
                                                dropdownColSpan={Math.max(1, effectiveColumnOrder.length - inlineDropdownTrailingCells)}
                                                dropdownTrailingCells={inlineDropdownTrailingCells}
                                            />
                                        </React.Fragment>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={effectiveColumnOrder.length}>No data available</td>
                                    </tr>
                                )}
                            </tbody>


                        </table>
                    )}
                        </div>
                    </div>
                    {/* Dropdown rendered outside the table */}
                    {dropdownOpenId && (
                        <OrderStatusDropdown
                            visible={true}
                            position={dropdownPosition}
                            orderStatuses={ORDER_STATUS_TAGS}
                            savedCustomTags={collectCustomOrderStatusTags(
                                [submittedOrderStatuses, orderStatusSelections],
                                ORDER_STATUS_TAGS
                            )}
                            allowCustomTag
                            selectedTags={orderStatusSelections[dropdownOpenId] || []}
                            onToggleTag={(tag) => handleOrderStatusToggle(dropdownOpenId, tag)}
                            onClose={() => setDropdownOpenId(null)}
                            menuClassName="order-status-menu"
                        />
                    )}
                </div>
            </div>
            </>
            )}
            </div>
            {!loading && (
            <nav
                aria-label="All Orders pagination"
                className="orders-tables-pagination d-flex justify-content-end align-items-center"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    flexWrap: 'wrap',
                    gap: '2.25rem',
                    padding: '8px 16px 4px',
                }}
            >
                <span className="mb-0">
                    Showing {startRecord} to {endRecord} of {displayTotalRecords}
                    {layoutView === LAYOUT_LINE ? ` · ${lineRows.length} lines` : ''}
                </span>

                <ul
                    className="pagination d-flex align-items-center mb-0"
                    style={{ marginLeft: 0 }}
                >
                    {/* Previous Button */}
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                            Previous
                        </button>
                    </li>

                    {/* Page Select Dropdown Styled Like Pagination */}
                    <li className="page-item">
                        <select
                            className="form-select mx-2"
                            style={{ width: 'auto' }}
                            value={currentPage}
                            onChange={(e) => handlePageChange(Number(e.target.value))}
                        >
                            {[...Array(totalPages)].map((_, index) => (
                                <option key={index} value={index + 1}>
                                    Page {index + 1}
                                </option>
                            ))}
                        </select>
                    </li>

                    {/* Next Button */}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                            Next
                        </button>
                    </li>
                </ul>
            </nav>
            )}

            <OrderPopup
                show={showPopup}
                onClose={closePopup}
                orderData={selectedOrder}
                sourceLine={selectedSourceLine}
                orderAccessLinks={orderAccessLinks}
                getOrderFolderLink={getOrderFolderLink}
                commentsMap={commentsMap}
                onAddComment={handleAddComment}
                onDeleteComment={handleDeleteComment}
                onResolveThread={handleResolveThread}
                onOpenOrderAccess={handleOrderAccessClick}
                onDeleteOrderAccessLink={handleDeleteOrderAccessLink}
                excludedAvailabilityPartsByOrder={excludedAvailabilityPartsByOrder}
                onToggleExcludedAvailabilityPart={handleToggleExcludedAvailabilityPart}
                onArchiveBomPart={handleArchiveBomPart}
                renderLinePresence={renderLinePresence}
                lineStatusLockOwner={lineStatusLockOwner}
                presenceFocus={presenceFocus}
                presenceBlur={presenceBlur}
                lineStatusCell={lineStatusCell}
                stickyNotes={stickyNotes}
                shippingInstructions={shippingInstructions}
            />
            <OrderHistoryModal
                show={!!historyModalOrder}
                onClose={() => setHistoryModalOrder(null)}
                ordernum={historyModalOrder}
                onViewed={markViewed}
            />
            <AllOrdersHistoryModal
                show={showAllOrdersHistory}
                onClose={() => setShowAllOrdersHistory(false)}
            />
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label>Comment:</Form.Label>
                            <Form.Control
                                type="text"
                                name="comment"
                                value={formData ? formData.comment : ''}
                                onChange={handleChange}
                                placeholder="Enter comment"
                            />
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>Flow Name:</Form.Label>
                            <Form.Control
                                type="text"
                                name="flowName"
                                value={"Order"}
                                onChange={handleChange}
                                disabled={true}
                                placeholder="Enter flow name"
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>Status:</Form.Label>
                            <Form.Select
                                name="status"
                                onChange={handleChange}
                                required
                            >
                                {formData ? (
                                    <>
                                        <option value="Can ship early" style={{ color: 'green' }} selected={formData.status === "Can ship early"}>Can ship early</option>
                                        <option value="Do not ship early" style={{ color: '#F8D700' }} selected={formData.status === "Do not ship early"}>Do not ship early</option>
                                        <option value="CC hold" style={{ color: 'orange' }} selected={formData.status === "CC hold"}>CC hold</option>
                                        <option value="Wire hold" style={{ color: '#8B47FF' }} selected={formData.status === "Wire hold"}>Wire hold</option>
                                        <option value="Credit hold" style={{ color: 'red' }} selected={formData.status === "Credit hold"}>Credit hold</option>
                                    </>
                                ) : (
                                    <>
                                        <option value="Can ship early" style={{ color: 'green' }}>Can ship early</option>
                                        <option value="Do not ship early" style={{ color: '#F8D700' }}>Do not ship early</option>
                                        <option value="CC hold" style={{ color: 'orange' }}>CC hold</option>
                                        <option value="Wire hold" style={{ color: '#8B47FF' }}>Wire hold</option>
                                        <option value="Credit hold" style={{ color: 'red' }}>Credit hold</option>
                                    </>
                                )}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>Order Line ID:</Form.Label>
                            <Form.Control
                                type="number"
                                name="orderLineId"
                                value={updatePopUp.id}
                                disabled={true}
                                onChange={handleChange}
                                placeholder="Enter Order Line ID"
                                required
                            />
                        </Form.Group>

                        {/* <Form.Group className="mt-3">
                            <Form.Label>Last Update:</Form.Label>
                            <Form.Control
                                type="number"
                                value={formData ?  formData.createdAt : ''}
                                disabled={true}
                                placeholder="Enter Order Line ID"
                                required
                            />
                        </Form.Group> */}

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" type="submit">
                                Save Changes
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Order Access Modal */}
            <Modal
                show={showOrderAccessModal}
                onHide={handleCloseOrderAccessModal}
                centered
                className="order-access-modal-root"
                backdropClassName="order-access-modal-backdrop"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Manage Order URLs</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedOrderForAccess && (
                        <div>
                            <div className="mb-3">
                                <div className="d-flex align-items-center">
                                    <p className="mb-0">
                                        <strong>Order:</strong> {selectedOrderNumber ? (
                                            <a 
                                                href={`https://gigaflightinc.cetecerp.com/order/MN${selectedOrderNumber}/view`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                {selectedOrderNumber}
                                            </a>
                                        ) : (
                                            'N/A'
                                        )}
                                    </p>
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 ms-2 text-decoration-none text-primary d-flex align-items-center"
                                        onClick={() => handleCopyToClipboard(selectedOrderNumber, 'order')}
                                        disabled={!selectedOrderNumber}
                                        title="Copy order number"
                                    >
                                        <i className="fa fa-copy" aria-hidden="true"></i>
                                    </button>
                                    <a
                                        href="https://aeroplicity.com/file-share/all"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-link p-0 ms-2 text-decoration-none text-primary d-flex align-items-center"
                                        title="Open Aeroplicity orders folder"
                                    >
                                        <i className="fa fa-folder-open" aria-hidden="true"></i>
                                    </a>
                                </div>
                                {copiedField === 'order' && (
                                    <small className="text-success d-block mt-1">Copied to clipboard</small>
                                )}
                            </div>
                            <div className="mb-3">
                                <div className="d-flex align-items-center">
                                    <p className="mb-0">
                                        <strong>Customer:</strong> {selectedOrderForAccess?.order?.customer?.id ? (
                                            <a 
                                                href={`https://gigaflightinc.cetecerp.com/customer/${selectedOrderForAccess.order.customer.id}/view`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                {selectedCustomerName || 'N/A'}
                                            </a>
                                        ) : (
                                            selectedCustomerName || 'N/A'
                                        )}
                                    </p>
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 ms-2 text-decoration-none text-primary d-flex align-items-center"
                                        onClick={() => handleCopyToClipboard(selectedCustomerName, 'customer')}
                                        disabled={!selectedCustomerName}
                                        title="Copy customer name"
                                    >
                                        <i className="fa fa-copy" aria-hidden="true"></i>
                                    </button>
                                    <a
                                        href="https://aeroplicity.com/file-share/all"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-link p-0 ms-2 text-decoration-none text-primary d-flex align-items-center"
                                        title="Open Aeroplicity orders folder"
                                    >
                                        <i className="fa fa-folder-open" aria-hidden="true"></i>
                                    </a>
                                </div>
                                {copiedField === 'customer' && (
                                    <small className="text-success d-block mt-1">Copied to clipboard</small>
                                )}
                            </div>

                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>URL Name:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={newLinkUrlName}
                                        onChange={(e) => setNewLinkUrlName(e.target.value)}
                                        placeholder="e.g., Engineering Docs, Customer Files, etc."
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>URL:</Form.Label>
                                    <Form.Control
                                        type="url"
                                        value={newLinkUrl}
                                        onChange={(e) => setNewLinkUrl(e.target.value)}
                                        placeholder="https://example.com/folder"
                                    />
                                </Form.Group>
                            </Form>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseOrderAccessModal}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleAddOrderAccessLink}>
                        Add URL
                    </Button>
                </Modal.Footer>
            </Modal>
            
            {/* Full-screen loading overlay during bulk submit */}
            {isSubmittingBulk && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999999,
                        color: 'white'
                    }}
                >
                    <div className="spinner-border text-light" role="status" style={{ width: '3rem', height: '3rem', marginBottom: '20px' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <h4>Submitting Bulk Status Changes...</h4>
                    <p>Please wait, this may take a moment.</p>
                    <p style={{ fontSize: '14px', opacity: 0.8 }}>Do not close or refresh the page.</p>
                </div>
            )}

            <ColumnGroupsModal
                show={showColumnGroupsModal}
                onHide={() => setShowColumnGroupsModal(false)}
                activeGroupId={activeGroupId}
                defaultGroupId={defaultGroupId}
                customGroups={customGroups}
                onApply={handleColumnGroupsApply}
                onSaveCustomGroup={handleSaveCustomGroup}
                onDeleteCustomGroup={handleDeleteCustomGroup}
            />

            <ColumnVisibilityModal
                show={showColumnVisibilityModal}
                onHide={() => setShowColumnVisibilityModal(false)}
                columns={columnVisibilityList}
                visibleColumns={columnVisibility}
                onColumnVisibilityChange={handleColumnVisibilityChange}
                pageName="Orders"
            />

            <FloatingRefreshButton
                onRefresh={handleManualPageRefresh}
                ariaLabel="Refresh Orders"
                hoverLabel="Refresh"
            />
        </div>
        </div>
    );
};

export default Orders;